import {GoogleMaterialIcon} from "@/utils/common/GUIUtilities.ts";
import AccountingIcon from "@/assets/menuIcons/AccountingIcon.vue";
import AccountingRevenueIcon from "@/assets/menuIcons/AccountingRevenueIcon.vue";
import ActionsIcon from "@/assets/menuIcons/ActionsIcon.vue";
import AddCommentIcon from "@/assets/menuIcons/AddCommentIcon.vue";
import AddDayIcon from "@/assets/menuIcons/AddDayIcon.vue";
import AddGridIcon from "@/assets/menuIcons/AddGridIcon.vue";
import AddGroupsIcon from "@/assets/menuIcons/AddGroupsIcon.vue";
import AddIcon from "@/assets/menuIcons/AddIcon.vue";
import AddPageIcon from "@/assets/menuIcons/AddPageIcon.vue";
import AdministrationIcon from "@/assets/menuIcons/AdministrationIcon.vue";
import ApiIcon from "@/assets/menuIcons/ApiIcon.vue";
import AppStoreIcon from "@/assets/menuIcons/AppStoreIcon.vue";
import AssemblyDocsIcon from "@/assets/menuIcons/AssemblyDocsIcon.vue";
import AssetsIcon from "@/assets/menuIcons/AssetsIcon.vue";
import AuditingIcon from "@/assets/menuIcons/AuditingIcon.vue";
import BalanceIcon from "@/assets/menuIcons/BalanceIcon.vue";
import BankLCIcon from "@/assets/menuIcons/BankLCIcon.vue";
import BankLoansIcon from "@/assets/menuIcons/BankLoansIcon.vue";
import BanksIcon from "@/assets/menuIcons/BanksIcon.vue";
import BasicIcon from "@/assets/menuIcons/BasicIcon.vue";
import BasicInformationIcon from "@/assets/menuIcons/BasicInformationIcon.vue";
import BlocksIcon from "@/assets/menuIcons/BlocksIcon.vue";
import BloodBanksIcon from "@/assets/menuIcons/BloodBanksIcon.vue";
import BudgetsIcon from "@/assets/menuIcons/BudgetsIcon.vue";
import CacheIcon from "@/assets/menuIcons/CacheIcon.vue";
import CapabilitiesIcon from "@/assets/menuIcons/CapabilitiesIcon.vue";
import CarInsuranceIcon from "@/assets/menuIcons/CarInsuranceIcon.vue";
import CartoonIcon from "@/assets/menuIcons/CartoonIcon.vue";
import CashierIcon from "@/assets/menuIcons/CashierIcon.vue";
import CashiersIcon from "@/assets/menuIcons/CashiersIcon.vue";
import ChargeInvoiceIcon from "@/assets/menuIcons/ChargeInvoiceIcon.vue";
import CheckBoxIcon from "@/assets/menuIcons/CheckBoxIcon.vue";
import CheckCircleIcon from "@/assets/menuIcons/CheckCircleIcon.vue";
import CheckIcon from "@/assets/menuIcons/CheckIcon.vue";
import ChequesIcon from "@/assets/menuIcons/ChequesIcon.vue";
import ChiefIcon from "@/assets/menuIcons/ChiefIcon.vue";
import CircularsIcon from "@/assets/menuIcons/CircularsIcon.vue";
import ClipboardCheckIcon from "@/assets/menuIcons/ClipboardCheckIcon.vue";
import ClosingInvoiceIcon from "@/assets/menuIcons/ClosingInvoiceIcon.vue";
import CodeIcon from "@/assets/menuIcons/CodeIcon.vue";
import ColumnsIcon from "@/assets/menuIcons/ColumnsIcon.vue";
import CompactIcon from "@/assets/menuIcons/CompactIcon.vue";
import CompareIcon from "@/assets/menuIcons/CompareIcon.vue";
import ComponentIcon from "@/assets/menuIcons/ComponentIcon.vue";
import CompositeIcon from "@/assets/menuIcons/CompositeIcon.vue";
import ContractingIcon from "@/assets/menuIcons/ContractingIcon.vue";
import ContractorContractingIcon from "@/assets/menuIcons/ContractorContractingIcon.vue";
import ConveyorIcon from "@/assets/menuIcons/ConveyorIcon.vue";
import CopyIcon from "@/assets/menuIcons/CopyIcon.vue";
import CopyToClipboardIcon from "@/assets/menuIcons/CopyToClipboardIcon.vue";
import CostIcon from "@/assets/menuIcons/CostIcon.vue";
import CostsIcon from "@/assets/menuIcons/CostsIcon.vue";
import CreateDocumentsIcon from "@/assets/menuIcons/CreateDocumentsIcon.vue";
import CreateIcon from "@/assets/menuIcons/CreateIcon.vue";
import CreateReportIcon from "@/assets/menuIcons/CreateReportIcon.vue";
import CreditFacilitiesIcon from "@/assets/menuIcons/CreditFacilitiesIcon.vue";
import CriteriaIcon from "@/assets/menuIcons/CriteriaIcon.vue";
import CrmDashboardIcon from "@/assets/menuIcons/CrmDashboardIcon.vue";
import CrmIcon from "@/assets/menuIcons/CrmIcon.vue";
import CustodyOfAssetsIcon from "@/assets/menuIcons/CustodyOfAssetsIcon.vue";
import CustodysIcon from "@/assets/menuIcons/CustodysIcon.vue";
import CustomersIcon from "@/assets/menuIcons/CustomersIcon.vue";
import DarkModeIcon from "@/assets/menuIcons/DarkModeIcon.vue";
import DashboardsIcon from "@/assets/menuIcons/DashboardsIcon.vue";
import DataModelIcon from "@/assets/menuIcons/DataModelIcon.vue";
import DefinitionsIcon from "@/assets/menuIcons/DefinitionsIcon.vue";
import DeliverySettingIcon from "@/assets/menuIcons/DeliverySettingIcon.vue";
import DetailAccountsIcon from "@/assets/menuIcons/DetailAccountsIcon.vue";
import DimensionsIcon from "@/assets/menuIcons/DimensionsIcon.vue";
import DiscardIcon from "@/assets/menuIcons/DiscardIcon.vue";
import DiscussionIcon from "@/assets/menuIcons/DiscussionIcon.vue";
import DisplayedColumnsIcon from "@/assets/menuIcons/DisplayedColumnsIcon.vue";
import DmsLocationIcon from "@/assets/menuIcons/DmsLocationIcon.vue";
import DocumentIcon from "@/assets/menuIcons/DocumentIcon.vue";
import DocumentManagementIcon from "@/assets/menuIcons/DocumentManagementIcon.vue";
import DocumentManagementSystemIcon from "@/assets/menuIcons/DocumentManagementSystemIcon.vue";
import DocumentRevisionIcon from "@/assets/menuIcons/DocumentRevisionIcon.vue";
import DocumentsIcon from "@/assets/menuIcons/DocumentsIcon.vue";
import DownloadIcon from "@/assets/menuIcons/DownloadIcon.vue";
import DragIcon from "@/assets/menuIcons/DragIcon.vue";
import DragRowIndicatorIcon from "@/assets/menuIcons/DragRowIndicatorIcon.vue";
import DuesLiquidationAndFiringIcon from "@/assets/menuIcons/DuesLiquidationAndFiringIcon.vue";
import EcommerceIcon from "@/assets/menuIcons/EcommerceIcon.vue";
import EcpaIcon from "@/assets/menuIcons/EcpaIcon.vue";
import EditScreenIcon from "@/assets/menuIcons/EditScreenIcon.vue";
import EducationIcon from "@/assets/menuIcons/EducationIcon.vue";
import ErrorIcon from "@/assets/menuIcons/ErrorIcon.vue";
import ExpenseIcon from "@/assets/menuIcons/ExpenseIcon.vue";
import ExportAllIcon from "@/assets/menuIcons/ExportAllIcon.vue";
import ExportGroupIcon from "@/assets/menuIcons/ExportGroupIcon.vue";
import ExportIcon from "@/assets/menuIcons/ExportIcon.vue";
import ExportOptionIcon from "@/assets/menuIcons/ExportOptionIcon.vue";
import ExportPageIcon from "@/assets/menuIcons/ExportPageIcon.vue";
import FavouritesIcon from "@/assets/menuIcons/FavouritesIcon.vue";
import FavouritesMinusIcon from "@/assets/menuIcons/FavouritesMinusIcon.vue";
import FavouritesPlusIcon from "@/assets/menuIcons/FavouritesPlusIcon.vue";
import FeedingIcon from "@/assets/menuIcons/FeedingIcon.vue";
import FieldsIcon from "@/assets/menuIcons/FieldsIcon.vue";
import FillIcon from "@/assets/menuIcons/FillIcon.vue";
import FinancialCommitmentManagementIcon from "@/assets/menuIcons/FinancialCommitmentManagementIcon.vue";
import FinancialIcon from "@/assets/menuIcons/FinancialIcon.vue";
import FinancialStatementIcon from "@/assets/menuIcons/FinancialStatementIcon.vue";
import FinesIcon from "@/assets/menuIcons/FinesIcon.vue";
import FixedAssetLetterOfCreditIcon from "@/assets/menuIcons/FixedAssetLetterOfCreditIcon.vue";
import FixedAssetMaintenanceIcon from "@/assets/menuIcons/FixedAssetMaintenanceIcon.vue";
import FixedAssetsIcon from "@/assets/menuIcons/FixedAssetsIcon.vue";
import FixedDepositsIcon from "@/assets/menuIcons/FixedDepositsIcon.vue";
import FocusIcon from "@/assets/menuIcons/FocusIcon.vue";
import FolderIcon from "@/assets/menuIcons/FolderIcon.vue";
import FoldersIcon from "@/assets/menuIcons/FoldersIcon.vue";
import FreightManagementSystemIcon from "@/assets/menuIcons/FreightManagementSystemIcon.vue";
import GooglePlayIcon from "@/assets/menuIcons/GooglePlayIcon.vue";
import GridIcon from "@/assets/menuIcons/GridIcon.vue";
import GroupIcon from "@/assets/menuIcons/GroupIcon.vue";
import HealthInsuranceIcon from "@/assets/menuIcons/HealthInsuranceIcon.vue";
import HomeIcon from "@/assets/menuIcons/HomeIcon.vue";
import HorizontalIcon from "@/assets/menuIcons/HorizontalIcon.vue";
import HospitalManagementSystemIcon from "@/assets/menuIcons/HospitalManagementSystemIcon.vue";
import HospitalStructureIcon from "@/assets/menuIcons/HospitalStructureIcon.vue";
import HousingDocumentsIcon from "@/assets/menuIcons/HousingDocumentsIcon.vue";
import HousingFilesIcon from "@/assets/menuIcons/HousingFilesIcon.vue";
import HousingIcon from "@/assets/menuIcons/HousingIcon.vue";
import HumanResourceIcon from "@/assets/menuIcons/HumanResourceIcon.vue";
import ImportIcon from "@/assets/menuIcons/ImportIcon.vue";
import InformationIcon from "@/assets/menuIcons/InformationIcon.vue";
import InputIcon from "@/assets/menuIcons/InputIcon.vue";
import InternalLinkIcon from "@/assets/menuIcons/InternalLinkIcon.vue";
import InventoryIcon from "@/assets/menuIcons/InventoryIcon.vue";
import InventoryManagementIcon from "@/assets/menuIcons/InventoryManagementIcon.vue";
import InvestmentDocsIcon from "@/assets/menuIcons/InvestmentDocsIcon.vue";
import InvestmentDocumentsIcon from "@/assets/menuIcons/InvestmentDocumentsIcon.vue";
import InvestmentIcon from "@/assets/menuIcons/InvestmentIcon.vue";
import InvestmentPortfoliosIcon from "@/assets/menuIcons/InvestmentPortfoliosIcon.vue";
import InvoiceIcon from "@/assets/menuIcons/InvoiceIcon.vue";
import IsoIcon from "@/assets/menuIcons/IsoIcon.vue";
import IssueDocumentsIcon from "@/assets/menuIcons/IssueDocumentsIcon.vue";
import ItemVotingIcon from "@/assets/menuIcons/ItemVotingIcon.vue";
import JobOrdersIcon from "@/assets/menuIcons/JobOrdersIcon.vue";
import LabIcon from "@/assets/menuIcons/LabIcon.vue";
import LaboratoryTestsIcon from "@/assets/menuIcons/LaboratoryTestsIcon.vue";
import LawsIcon from "@/assets/menuIcons/LawsIcon.vue";
import LayoutIcon from "@/assets/menuIcons/LayoutIcon.vue";
import LetterOfCreditIcon from "@/assets/menuIcons/LetterOfCreditIcon.vue";
import LetterOfGuaranteesIcon from "@/assets/menuIcons/LetterOfGuaranteesIcon.vue";
import ListPlusIcon from "@/assets/menuIcons/ListPlusIcon.vue";
import ListVewIcon from "@/assets/menuIcons/ListVewIcon.vue";
import LoansAndInstallmentsIcon from "@/assets/menuIcons/LoansAndInstallmentsIcon.vue";
import LogFilesIcon from "@/assets/menuIcons/LogFilesIcon.vue";
import LogoutIcon from "@/assets/menuIcons/LogoutIcon.vue";
import MainFilesIcon from "@/assets/menuIcons/MainFilesIcon.vue";
import MainIcon from "@/assets/menuIcons/MainIcon.vue";
import MaintenanceContractingIcon from "@/assets/menuIcons/MaintenanceContractingIcon.vue";
import MaintenanceDocumentsIcon from "@/assets/menuIcons/MaintenanceDocumentsIcon.vue";
import MaintenanceFilesIcon from "@/assets/menuIcons/MaintenanceFilesIcon.vue";
import MaintenanceIcon from "@/assets/menuIcons/MaintenanceIcon.vue";
import ManagementAndOrganizationIcon from "@/assets/menuIcons/ManagementAndOrganizationIcon.vue";
import ManagementDocumentsIcon from "@/assets/menuIcons/ManagementDocumentsIcon.vue";
import ManufacturingIcon from "@/assets/menuIcons/ManufacturingIcon.vue";
import ManufacturingMoldsIcon from "@/assets/menuIcons/ManufacturingMoldsIcon.vue";
import MarketingIcon from "@/assets/menuIcons/MarketingIcon.vue";
import MasterFilesIcon from "@/assets/menuIcons/MasterFilesIcon.vue";
import MaterialResourcePlanningIcon from "@/assets/menuIcons/MaterialResourcePlanningIcon.vue";
import MealsIcon from "@/assets/menuIcons/MealsIcon.vue";
import MedicalOverheadIcon from "@/assets/menuIcons/MedicalOverheadIcon.vue";
import MedicalServicesIcon from "@/assets/menuIcons/MedicalServicesIcon.vue";
import MeetingIcon from "@/assets/menuIcons/MeetingIcon.vue";
import MicroIcon from "@/assets/menuIcons/MicroIcon.vue";
import MigrationIcon from "@/assets/menuIcons/MigrationIcon.vue";
import MiniCompositeIcon from "@/assets/menuIcons/MiniCompositeIcon.vue";
import MiscellaneousIcon from "@/assets/menuIcons/MiscellaneousIcon.vue";
import MobileAppsIcon from "@/assets/menuIcons/MobileAppsIcon.vue";
import ModifiedBlocksIcon from "@/assets/menuIcons/ModifiedBlocksIcon.vue";
import ModifiedGridIcon from "@/assets/menuIcons/ModifiedGridIcon.vue";
import ModifiedGroupsIcon from "@/assets/menuIcons/ModifiedGroupsIcon.vue";
import MonitoringIcon from "@/assets/menuIcons/MonitoringIcon.vue";
import NameIcon from "@/assets/menuIcons/NameIcon.vue";
import NotificationIcon from "@/assets/menuIcons/NotificationIcon.vue";
import NotificationsIcon from "@/assets/menuIcons/NotificationsIcon.vue";
import OldPcIcon from "@/assets/menuIcons/OldPcIcon.vue";
import OtherIcon from "@/assets/menuIcons/OtherIcon.vue";
import OutsourceManufacturingIcon from "@/assets/menuIcons/OutsourceManufacturingIcon.vue";
import OutSourcingOrdersIcon from "@/assets/menuIcons/OutSourcingOrdersIcon.vue";
import PagesIcon from "@/assets/menuIcons/PagesIcon.vue";
import PartyEvaluationsIcon from "@/assets/menuIcons/PartyEvaluationsIcon.vue";
import PayrollIcon from "@/assets/menuIcons/PayrollIcon.vue";
import PerformanceIndicatorsIcon from "@/assets/menuIcons/PerformanceIndicatorsIcon.vue";
import PersonIcon from "@/assets/menuIcons/PersonIcon.vue";
import PharmaciesIcon from "@/assets/menuIcons/PharmaciesIcon.vue";
import PhysicalTherapyIcon from "@/assets/menuIcons/PhysicalTherapyIcon.vue";
import PointOfSaleIcon from "@/assets/menuIcons/PointOfSaleIcon.vue";
import PreventIcon from "@/assets/menuIcons/PreventIcon.vue";
import PreventOptionIcon from "@/assets/menuIcons/PreventOptionIcon.vue";
import PriceVotingIcon from "@/assets/menuIcons/PriceVotingIcon.vue";
import PriorityIcon from "@/assets/menuIcons/PriorityIcon.vue";
import ProjectContractingIcon from "@/assets/menuIcons/ProjectContractingIcon.vue";
import ProjectsIcon from "@/assets/menuIcons/ProjectsIcon.vue";
import PropertyIcon from "@/assets/menuIcons/PropertyIcon.vue";
import PurchasesIcon from "@/assets/menuIcons/PurchasesIcon.vue";
import PurgeDocumentsIcon from "@/assets/menuIcons/PurgeDocumentsIcon.vue";
import QuadLayoutIcon from "@/assets/menuIcons/QuadLayoutIcon.vue";
import QualityIcon from "@/assets/menuIcons/QualityIcon.vue";
import QuestionairsIcon from "@/assets/menuIcons/QuestionairsIcon.vue";
import QuestionAnswersIcon from "@/assets/menuIcons/QuestionAnswersIcon.vue";
import QueueServiceIcon from "@/assets/menuIcons/QueueServiceIcon.vue";
import RadiologyIcon from "@/assets/menuIcons/RadiologyIcon.vue";
import RealEstateAndPropertyIcon from "@/assets/menuIcons/RealEstateAndPropertyIcon.vue";
import ReceiptDocumentsIcon from "@/assets/menuIcons/ReceiptDocumentsIcon.vue";
import ReconciliationsIcon from "@/assets/menuIcons/ReconciliationsIcon.vue";
import RecordIcon from "@/assets/menuIcons/RecordIcon.vue";
import RecruitmentIcon from "@/assets/menuIcons/RecruitmentIcon.vue";
import RegisterIcon from "@/assets/menuIcons/RegisterIcon.vue";
import RegulationsIcon from "@/assets/menuIcons/RegulationsIcon.vue";
import ReloadIcon from "@/assets/menuIcons/ReloadIcon.vue";
import RemarksIcon from "@/assets/menuIcons/RemarksIcon.vue";
import RentalAssetsIcon from "@/assets/menuIcons/RentalAssetsIcon.vue";
import RentsIcon from "@/assets/menuIcons/RentsIcon.vue";
import ReportIcon from "@/assets/menuIcons/ReportIcon.vue";
import ReportsIcon from "@/assets/menuIcons/ReportsIcon.vue";
import ReportsMonitoringIcon from "@/assets/menuIcons/ReportsMonitoringIcon.vue";
import ResearchAndDevelopmentIcon from "@/assets/menuIcons/ResearchAndDevelopmentIcon.vue";
import ReservationDocumentsIcon from "@/assets/menuIcons/ReservationDocumentsIcon.vue";
import ResizerIcon from "@/assets/menuIcons/ResizerIcon.vue";
import RewardAndPenaltyIcon from "@/assets/menuIcons/RewardAndPenaltyIcon.vue";
import SalaryConfigurationsIcon from "@/assets/menuIcons/SalaryConfigurationsIcon.vue";
import SalesIcon from "@/assets/menuIcons/SalesIcon.vue";
import SalesPricesAndOffersIcon from "@/assets/menuIcons/SalesPricesAndOffersIcon.vue";
import SchoolTripsIcon from "@/assets/menuIcons/SchoolTripsIcon.vue";
import ScreenIcon from "@/assets/menuIcons/ScreenIcon.vue";
import ScreenModiferIcon from "@/assets/menuIcons/ScreenModiferIcon.vue";
import SearcherTemplateIcon from "@/assets/menuIcons/SearcherTemplateIcon.vue";
import SearchIcon from "@/assets/menuIcons/SearchIcon.vue";
import SecurityIcon from "@/assets/menuIcons/SecurityIcon.vue";
import ServiceCenterIcon from "@/assets/menuIcons/ServiceCenterIcon.vue";
import ServiceDocumentsIcon from "@/assets/menuIcons/ServiceDocumentsIcon.vue";
import SettingsIcon from "@/assets/menuIcons/SettingsIcon.vue";
import ShippingIcon from "@/assets/menuIcons/ShippingIcon.vue";
import SocialInsuranceIcon from "@/assets/menuIcons/SocialInsuranceIcon.vue";
import SortIcon from "@/assets/menuIcons/SortIcon.vue";
import SqlIcon from "@/assets/menuIcons/SqlIcon.vue";
import StockTakingIcon from "@/assets/menuIcons/StockTakingIcon.vue";
import StockTransDocumentsIcon from "@/assets/menuIcons/StockTransDocumentsIcon.vue";
import StockTransferDocsIcon from "@/assets/menuIcons/StockTransferDocsIcon.vue";
import SupportIcon from "@/assets/menuIcons/SupportIcon.vue";
import SurgeriesIcon from "@/assets/menuIcons/SurgeriesIcon.vue";
import SurgeryPackageIcon from "@/assets/menuIcons/SurgeryPackageIcon.vue";
import SystemUpdateIcon from "@/assets/menuIcons/SystemUpdateIcon.vue";
import TaskExecutionIcon from "@/assets/menuIcons/TaskExecutionIcon.vue";
import TaskIcon from "@/assets/menuIcons/TaskIcon.vue";
import TasksIcon from "@/assets/menuIcons/TasksIcon.vue";
import TaxPayerConfigurationIcon from "@/assets/menuIcons/TaxPayerConfigurationIcon.vue";
import TeamIcon from "@/assets/menuIcons/TeamIcon.vue";
import TemplateColumnsIcon from "@/assets/menuIcons/TemplateColumnsIcon.vue";
import TendersIcon from "@/assets/menuIcons/TendersIcon.vue";
import TestsIcon from "@/assets/menuIcons/TestsIcon.vue";
import ThemeEditorIcon from "@/assets/menuIcons/ThemeEditorIcon.vue";
import TimeAttendanceIcon from "@/assets/menuIcons/TimeAttendanceIcon.vue";
import ToolsIcon from "@/assets/menuIcons/ToolsIcon.vue";
import TrainingIcon from "@/assets/menuIcons/TrainingIcon.vue";
import TransactionsIcon from "@/assets/menuIcons/TransactionsIcon.vue";
import TravelIcon from "@/assets/menuIcons/TravelIcon.vue";
import TreasuryBillIcon from "@/assets/menuIcons/TreasuryBillIcon.vue";
import UploadInvoiceIcon from "@/assets/menuIcons/UploadInvoiceIcon.vue";
import UserIcon from "@/assets/menuIcons/UserIcon.vue";
import VacationsIcon from "@/assets/menuIcons/VacationsIcon.vue";
import VectorIcon from "@/assets/menuIcons/VectorIcon.vue";
import VehiclesIcon from "@/assets/menuIcons/VehiclesIcon.vue";
import VerticalIcon from "@/assets/menuIcons/VerticalIcon.vue";
import ViewCustomizationIcon from "@/assets/menuIcons/ViewCustomizationIcon.vue";
import ViewIcon from "@/assets/menuIcons/ViewIcon.vue";
import VisasIcon from "@/assets/menuIcons/VisasIcon.vue";
import WasteManagementIcon from "@/assets/menuIcons/WasteManagementIcon.vue";
import WeightScaleIcon from "@/assets/menuIcons/WeightScaleIcon.vue";
import WorkListIcon from "@/assets/menuIcons/WorkListIcon.vue";
import ActionBlockIcon from "@/assets/editViewIcons/ActionBlockIcon.vue";
import AddLineIcon from "@/assets/editViewIcons/AddLineIcon.vue";
import AddRecordIcon from "@/assets/editViewIcons/AddRecordIcon.vue";
import ApprovalIcon from "@/assets/editViewIcons/ApprovalIcon.vue";
import ArrowIcon from "@/assets/editViewIcons/ArrowIcon.vue";
import AskAIIcon from "@/assets/editViewIcons/AskAIIcon.vue";
import ChatHistoryIcon from "@/assets/editViewIcons/ChatHistoryIcon.vue";
import DashBoardBlockIcon from "@/assets/editViewIcons/DashBoardBlockIcon.vue";
import DeleteIcon from "@/assets/editViewIcons/DeleteIcon.vue";
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import DislikeIcon from "@/assets/editViewIcons/DislikeIcon.vue";
import DOCXIcon from "@/assets/editViewIcons/DOCXIcon.vue";
import DuplicateIcon from "@/assets/editViewIcons/DuplicateIcon.vue";
import EditIcon from "@/assets/editViewIcons/EditIcon.vue";
import EnableSelectionIcon from "@/assets/editViewIcons/EnableSelectionIcon.vue";
import EnterIcon from "@/assets/editViewIcons/EnterIcon.vue";
import ExpertModeIcon from "@/assets/editViewIcons/ExpertModeIcon.vue";
import FirstIcon from "@/assets/editViewIcons/FirstIcon.vue";
import GoToLineIcon from "@/assets/editViewIcons/GoToLineIcon.vue";
import GridBlockIcon from "@/assets/editViewIcons/GridBlockIcon.vue";
import GroupBlockIcon from "@/assets/editViewIcons/GroupBlockIcon.vue";
import LastIcon from "@/assets/editViewIcons/LastIcon.vue";
import ListBlockIcon from "@/assets/editViewIcons/ListBlockIcon.vue";
import ListViewIcon from "@/assets/editViewIcons/ListViewIcon.vue";
import MoreIcon from "@/assets/editViewIcons/MoreIcon.vue";
import MultiCopyIcon from "@/assets/editViewIcons/MultiCopyIcon.vue";
import NextIcon from "@/assets/editViewIcons/NextIcon.vue";
import PDFIcon from "@/assets/editViewIcons/PDFIcon.vue";
import PPTXIcon from "@/assets/editViewIcons/PPTXIcon.vue";
import PreviousIcon from "@/assets/editViewIcons/PreviousIcon.vue";
import PrintAsIcon from "@/assets/editViewIcons/PrintAsIcon.vue";
import PrintIcon from "@/assets/editViewIcons/PrintIcon.vue";
import RefreshIcon from "@/assets/editViewIcons/RefreshIcon.vue";
import RemoveFilterIcon from "@/assets/editViewIcons/RemoveFilterIcon.vue";
import ReportBlockIcon from "@/assets/editViewIcons/ReportBlockIcon.vue";
import ReviseIcon from "@/assets/editViewIcons/ReviseIcon.vue";
import SaveAndContinueIcon from "@/assets/editViewIcons/SaveAndContinueIcon.vue";
import SaveDraftIcon from "@/assets/editViewIcons/SaveDraftIcon.vue";
import SaveIcon from "@/assets/editViewIcons/SaveIcon.vue";
import SendEmailIcon from "@/assets/editViewIcons/SendEmailIcon.vue";
import ShowHelpMsgsIcon from "@/assets/editViewIcons/ShowHelpMsgsIcon.vue";
import SwitchIcon from "@/assets/editViewIcons/SwitchIcon.vue";
import TimelineIcon from "@/assets/editViewIcons/TimelineIcon.vue";
import TooltipIcon from "@/assets/editViewIcons/TooltipIcon.vue";
import TooltipListIcon from "@/assets/editViewIcons/TooltipListIcon.vue";
import TreeViewIcon from "@/assets/editViewIcons/TreeViewIcon.vue";
import UnReviseIcon from "@/assets/editViewIcons/UnReviseIcon.vue";
import WinCloseIcon from "@/assets/editViewIcons/WinCloseIcon.vue";
import WinMaximizeIcon from "@/assets/editViewIcons/WinMaximizeIcon.vue";
import XLSXIcon from "@/assets/editViewIcons/XLSXIcon.vue";
import ZoomInIcon from "@/assets/editViewIcons/ZoomInIcon.vue";
import ZoomOutIcon from "@/assets/editViewIcons/ZoomOutIcon.vue";
import AscSortIcon from "@/assets/listViewIcons/AscSortIcon.vue";
import AutoFitColIcon from "@/assets/listViewIcons/AutoFitColIcon.vue";
import AutoFitColToContentIcon from "@/assets/listViewIcons/AutoFitColToContentIcon.vue";
import ExportExcelIcon from "@/assets/listViewIcons/ExportExcelIcon.vue";
import FilterIcon from "@/assets/listViewIcons/FilterIcon.vue";
import filterListIcon from "@/assets/listViewIcons/filterListIcon.vue";
import TableColumnsIcon from "@/assets/listViewIcons/TableColumnsIcon.vue";
import AdvancedSearchIcon from "@/assets/widgetIcons/AdvancedSearchIcon.vue";
import AiIcon from "@/assets/widgetIcons/AiIcon.vue";
import ApproveIcon from "@/assets/widgetIcons/ApproveIcon.vue";
import AttachmentIcon from "@/assets/widgetIcons/AttachmentIcon.vue";
import AutoSaveIcon from "@/assets/widgetIcons/AutoSaveIcon.vue";
import CalendarIcon from "@/assets/widgetIcons/CalendarIcon.vue";
import CancelIcon from "@/assets/widgetIcons/CancelIcon.vue";
import ChatIcon from "@/assets/widgetIcons/ChatIcon.vue";
import ClockIcon from "@/assets/widgetIcons/ClockIcon.vue";
import ColorPaletteIcon from "@/assets/widgetIcons/ColorPaletteIcon.vue";
import CriteriaFilterIcon from "@/assets/widgetIcons/CriteriaFilterIcon.vue";
import DescendingSortIcon from "@/assets/widgetIcons/DescendingSortIcon.vue";
import DropDownCloseIcon from "@/assets/widgetIcons/DropDownCloseIcon.vue";
import EditTextIcon from "@/assets/widgetIcons/EditTextIcon.vue";
import EmailIcon from "@/assets/widgetIcons/EmailIcon.vue";
import EmployeeIcon from "@/assets/widgetIcons/EmployeeIcon.vue";
import EmptySearchIcon from "@/assets/widgetIcons/EmptySearchIcon.vue";
import ExceptionIcon from "@/assets/widgetIcons/ExceptionIcon.vue";
import ExpandIcon from "@/assets/widgetIcons/ExpandIcon.vue";
import FacebookIcon from "@/assets/widgetIcons/FacebookIcon.vue";
import FailIcon from "@/assets/widgetIcons/FailIcon.vue";
import InitialIcon from "@/assets/widgetIcons/InitialIcon.vue";
import InstagramIcon from "@/assets/widgetIcons/InstagramIcon.vue";
import InvalidIcon from "@/assets/widgetIcons/InvalidIcon.vue";
import LinkedinIcon from "@/assets/widgetIcons/LinkedinIcon.vue";
import LinkIcon from "@/assets/widgetIcons/LinkIcon.vue";
import LoadingIcon from "@/assets/widgetIcons/LoadingIcon.vue";
import LockIcon from "@/assets/widgetIcons/LockIcon.vue";
import MapLocationIcon from "@/assets/widgetIcons/MapLocationIcon.vue";
import MenuIcon from "@/assets/widgetIcons/MenuIcon.vue";
import MicrophoneIcon from "@/assets/widgetIcons/MicrophoneIcon.vue";
import PendingIcon from "@/assets/widgetIcons/PendingIcon.vue";
import PhoneCallIcon from "@/assets/widgetIcons/PhoneCallIcon.vue";
import PlayIcon from "@/assets/widgetIcons/PlayIcon.vue";
import PreviousStepIcon from "@/assets/widgetIcons/PreviousStepIcon.vue";
import ProcessedIcon from "@/assets/widgetIcons/ProcessedIcon.vue";
import QuestionListIcon from "@/assets/widgetIcons/QuestionListIcon.vue";
import RejectedIcon from "@/assets/widgetIcons/RejectedIcon.vue";
import ReplyIcon from "@/assets/widgetIcons/ReplyIcon.vue";
import RetryIcon from "@/assets/widgetIcons/RetryIcon.vue";
import ReturnedIcon from "@/assets/widgetIcons/ReturnedIcon.vue";
import RevisedLevelIcon from "@/assets/widgetIcons/RevisedLevelIcon.vue";
import RevokedIcon from "@/assets/widgetIcons/RevokedIcon.vue";
import ScanIcon from "@/assets/widgetIcons/ScanIcon.vue";
import SendIcon from "@/assets/widgetIcons/SendIcon.vue";
import SignatureIcon from "@/assets/widgetIcons/SignatureIcon.vue";
import SnapchatIcon from "@/assets/widgetIcons/SnapchatIcon.vue";
import SortResetIcon from "@/assets/widgetIcons/SortResetIcon.vue";
import StableIcon from "@/assets/widgetIcons/StableIcon.vue";
import SupervisorIcon from "@/assets/widgetIcons/SupervisorIcon.vue";
import TiktokIcon from "@/assets/widgetIcons/TiktokIcon.vue";
import TranslationIcon from "@/assets/widgetIcons/TranslationIcon.vue";
import TreeListIcon from "@/assets/widgetIcons/TreeListIcon.vue";
import TwitterIcon from "@/assets/widgetIcons/TwitterIcon.vue";
import UndoIcon from "@/assets/widgetIcons/UndoIcon.vue";
import WaitingIcon from "@/assets/widgetIcons/WaitingIcon.vue";
import WaveIcon from "@/assets/widgetIcons/WaveIcon.vue";
import WhatsAppIcon from "@/assets/widgetIcons/WhatsAppIcon.vue";
import YoutubeIcon from "@/assets/widgetIcons/YoutubeIcon.vue";
import Access_denied_2186052Icon from "@/assets/downloaded/Access_denied_2186052Icon.vue";
import Accomodation_16681378Icon from "@/assets/downloaded/Accomodation_16681378Icon.vue";
import Accountability_9981536Icon from "@/assets/downloaded/Accountability_9981536Icon.vue";
import Accounting_10331873Icon from "@/assets/downloaded/Accounting_10331873Icon.vue";
import Accounting_1570887Icon from "@/assets/downloaded/Accounting_1570887Icon.vue";
import Accounting_4979100Icon from "@/assets/downloaded/Accounting_4979100Icon.vue";
import Account_1233162Icon from "@/assets/downloaded/Account_1233162Icon.vue";
import Account_maintenance_17640422Icon from "@/assets/downloaded/Account_maintenance_17640422Icon.vue";
import Acquisition_12134708Icon from "@/assets/downloaded/Acquisition_12134708Icon.vue";
import Address_3365020Icon from "@/assets/downloaded/Address_3365020Icon.vue";
import Add_10563482Icon from "@/assets/downloaded/Add_10563482Icon.vue";
import Add_12517897Icon from "@/assets/downloaded/Add_12517897Icon.vue";
import Adjustment_4289046Icon from "@/assets/downloaded/Adjustment_4289046Icon.vue";
import Adjust_9710826Icon from "@/assets/downloaded/Adjust_9710826Icon.vue";
import Administrative_fine_9897376Icon from "@/assets/downloaded/Administrative_fine_9897376Icon.vue";
import Administrator_8921054Icon from "@/assets/downloaded/Administrator_8921054Icon.vue";
import Agreement_1278586Icon from "@/assets/downloaded/Agreement_1278586Icon.vue";
import Agreement_1492552Icon from "@/assets/downloaded/Agreement_1492552Icon.vue";
import Agreement_17227040Icon from "@/assets/downloaded/Agreement_17227040Icon.vue";
import Agreement_4504481Icon from "@/assets/downloaded/Agreement_4504481Icon.vue";
import Agreement_4604417Icon from "@/assets/downloaded/Agreement_4604417Icon.vue";
import Ai_17653338Icon from "@/assets/downloaded/Ai_17653338Icon.vue";
import Ai_powered_models_16209773Icon from "@/assets/downloaded/Ai_powered_models_16209773Icon.vue";
import Algebra_4010849Icon from "@/assets/downloaded/Algebra_4010849Icon.vue";
import Allocation_12708441Icon from "@/assets/downloaded/Allocation_12708441Icon.vue";
import Analysis_18362456Icon from "@/assets/downloaded/Analysis_18362456Icon.vue";
import Analysis_809497Icon from "@/assets/downloaded/Analysis_809497Icon.vue";
import Analytics_6012662Icon from "@/assets/downloaded/Analytics_6012662Icon.vue";
import Api_103093Icon from "@/assets/downloaded/Api_103093Icon.vue";
import Application_10227469Icon from "@/assets/downloaded/Application_10227469Icon.vue";
import Application_15875439Icon from "@/assets/downloaded/Application_15875439Icon.vue";
import Application_18277246Icon from "@/assets/downloaded/Application_18277246Icon.vue";
import Application_2245059Icon from "@/assets/downloaded/Application_2245059Icon.vue";
import Application_9791628Icon from "@/assets/downloaded/Application_9791628Icon.vue";
import Appointment_request_12630733Icon from "@/assets/downloaded/Appointment_request_12630733Icon.vue";
import Approved_10721349Icon from "@/assets/downloaded/Approved_10721349Icon.vue";
import Approved_11442743Icon from "@/assets/downloaded/Approved_11442743Icon.vue";
import Approved_942833Icon from "@/assets/downloaded/Approved_942833Icon.vue";
import Approve_7270275Icon from "@/assets/downloaded/Approve_7270275Icon.vue";
import Approve_9926380Icon from "@/assets/downloaded/Approve_9926380Icon.vue";
import Architecture_9398782Icon from "@/assets/downloaded/Architecture_9398782Icon.vue";
import Archive_1721906Icon from "@/assets/downloaded/Archive_1721906Icon.vue";
import Art_5311124Icon from "@/assets/downloaded/Art_5311124Icon.vue";
import Ask_2859733Icon from "@/assets/downloaded/Ask_2859733Icon.vue";
import Assembly_1118470Icon from "@/assets/downloaded/Assembly_1118470Icon.vue";
import Assessment_11112891Icon from "@/assets/downloaded/Assessment_11112891Icon.vue";
import Assessment_12199381Icon from "@/assets/downloaded/Assessment_12199381Icon.vue";
import Asset_12062393Icon from "@/assets/downloaded/Asset_12062393Icon.vue";
import Asset_12300653Icon from "@/assets/downloaded/Asset_12300653Icon.vue";
import Asset_12885326Icon from "@/assets/downloaded/Asset_12885326Icon.vue";
import Asset_4002065Icon from "@/assets/downloaded/Asset_4002065Icon.vue";
import Asset_allocation_11376888Icon from "@/assets/downloaded/Asset_allocation_11376888Icon.vue";
import Asset_allocation_12315713Icon from "@/assets/downloaded/Asset_allocation_12315713Icon.vue";
import Assortment_4827324Icon from "@/assets/downloaded/Assortment_4827324Icon.vue";
import Assurance_4157073Icon from "@/assets/downloaded/Assurance_4157073Icon.vue";
import Attendance_6611895Icon from "@/assets/downloaded/Attendance_6611895Icon.vue";
import Attendance_device_16230724Icon from "@/assets/downloaded/Attendance_device_16230724Icon.vue";
import Auction_783196Icon from "@/assets/downloaded/Auction_783196Icon.vue";
import Audition_10227648Icon from "@/assets/downloaded/Audition_10227648Icon.vue";
import Audit_4307934Icon from "@/assets/downloaded/Audit_4307934Icon.vue";
import Automation_10872051Icon from "@/assets/downloaded/Automation_10872051Icon.vue";
import Automation_15569965Icon from "@/assets/downloaded/Automation_15569965Icon.vue";
import Automation_9325681Icon from "@/assets/downloaded/Automation_9325681Icon.vue";
import Autonomous_car_2941989Icon from "@/assets/downloaded/Autonomous_car_2941989Icon.vue";
import Avatar_266134Icon from "@/assets/downloaded/Avatar_266134Icon.vue";
import Award_badge_11835451Icon from "@/assets/downloaded/Award_badge_11835451Icon.vue";
import B2b_5915166Icon from "@/assets/downloaded/B2b_5915166Icon.vue";
import Bad_9125203Icon from "@/assets/downloaded/Bad_9125203Icon.vue";
import Balance_16680712Icon from "@/assets/downloaded/Balance_16680712Icon.vue";
import Balance_sheet_8682846Icon from "@/assets/downloaded/Balance_sheet_8682846Icon.vue";
import Ballot_1533927Icon from "@/assets/downloaded/Ballot_1533927Icon.vue";
import Bank_1669617Icon from "@/assets/downloaded/Bank_1669617Icon.vue";
import Bank_3635987Icon from "@/assets/downloaded/Bank_3635987Icon.vue";
import Bank_7969361Icon from "@/assets/downloaded/Bank_7969361Icon.vue";
import Bank_account_8432416Icon from "@/assets/downloaded/Bank_account_8432416Icon.vue";
import Bank_account_9359512Icon from "@/assets/downloaded/Bank_account_9359512Icon.vue";
import Bank_statement_3742514Icon from "@/assets/downloaded/Bank_statement_3742514Icon.vue";
import Bank_transfer_2787531Icon from "@/assets/downloaded/Bank_transfer_2787531Icon.vue";
import Barcode_16912866Icon from "@/assets/downloaded/Barcode_16912866Icon.vue";
import Bar_chart_478544Icon from "@/assets/downloaded/Bar_chart_478544Icon.vue";
import Bar_graph_8439433Icon from "@/assets/downloaded/Bar_graph_8439433Icon.vue";
import Battery_4115361Icon from "@/assets/downloaded/Battery_4115361Icon.vue";
import Bell_17465958Icon from "@/assets/downloaded/Bell_17465958Icon.vue";
import Benchmarking_18609810Icon from "@/assets/downloaded/Benchmarking_18609810Icon.vue";
import Bid_2162213Icon from "@/assets/downloaded/Bid_2162213Icon.vue";
import Billing_17625287Icon from "@/assets/downloaded/Billing_17625287Icon.vue";
import Bills_2359971Icon from "@/assets/downloaded/Bills_2359971Icon.vue";
import Bill_14895794Icon from "@/assets/downloaded/Bill_14895794Icon.vue";
import Bill_1763436Icon from "@/assets/downloaded/Bill_1763436Icon.vue";
import Bill_2976378Icon from "@/assets/downloaded/Bill_2976378Icon.vue";
import Bill_4545554Icon from "@/assets/downloaded/Bill_4545554Icon.vue";
import Bill_7372992Icon from "@/assets/downloaded/Bill_7372992Icon.vue";
import Bill_781862Icon from "@/assets/downloaded/Bill_781862Icon.vue";
import Bill_of_lading_14198953Icon from "@/assets/downloaded/Bill_of_lading_14198953Icon.vue";
import Biometric_attendance_12767435Icon from "@/assets/downloaded/Biometric_attendance_12767435Icon.vue";
import Block_user_7838125Icon from "@/assets/downloaded/Block_user_7838125Icon.vue";
import Blood_test_12485937Icon from "@/assets/downloaded/Blood_test_12485937Icon.vue";
import Blood_test_16780038Icon from "@/assets/downloaded/Blood_test_16780038Icon.vue";
import Blood_tube_7678363Icon from "@/assets/downloaded/Blood_tube_7678363Icon.vue";
import Body_paint_repair_13401864Icon from "@/assets/downloaded/Body_paint_repair_13401864Icon.vue";
import Bond_13473066Icon from "@/assets/downloaded/Bond_13473066Icon.vue";
import Bookmark_13124718Icon from "@/assets/downloaded/Bookmark_13124718Icon.vue";
import Book_1211755Icon from "@/assets/downloaded/Book_1211755Icon.vue";
import Book_15947937Icon from "@/assets/downloaded/Book_15947937Icon.vue";
import Book_3238973Icon from "@/assets/downloaded/Book_3238973Icon.vue";
import Book_9257188Icon from "@/assets/downloaded/Book_9257188Icon.vue";
import Box_13964534Icon from "@/assets/downloaded/Box_13964534Icon.vue";
import Box_14116892Icon from "@/assets/downloaded/Box_14116892Icon.vue";
import Box_1524539Icon from "@/assets/downloaded/Box_1524539Icon.vue";
import Box_9962216Icon from "@/assets/downloaded/Box_9962216Icon.vue";
import Branch_6712276Icon from "@/assets/downloaded/Branch_6712276Icon.vue";
import Brand_3886706Icon from "@/assets/downloaded/Brand_3886706Icon.vue";
import Brand_awareness_17328280Icon from "@/assets/downloaded/Brand_awareness_17328280Icon.vue";
import Briefcase_17989959Icon from "@/assets/downloaded/Briefcase_17989959Icon.vue";
import Budgeting_8123485Icon from "@/assets/downloaded/Budgeting_8123485Icon.vue";
import Budget_4341568Icon from "@/assets/downloaded/Budget_4341568Icon.vue";
import Budget_7615720Icon from "@/assets/downloaded/Budget_7615720Icon.vue";
import Budget_9918832Icon from "@/assets/downloaded/Budget_9918832Icon.vue";
import Budget_planning_11048265Icon from "@/assets/downloaded/Budget_planning_11048265Icon.vue";
import Builder_7152038Icon from "@/assets/downloaded/Builder_7152038Icon.vue";
import Building_1324872Icon from "@/assets/downloaded/Building_1324872Icon.vue";
import Businessman_3630246Icon from "@/assets/downloaded/Businessman_3630246Icon.vue";
import Business_14525232Icon from "@/assets/downloaded/Business_14525232Icon.vue";
import Business_15139054Icon from "@/assets/downloaded/Business_15139054Icon.vue";
import Business_and_finance_1773345Icon from "@/assets/downloaded/Business_and_finance_1773345Icon.vue";
import Business_people_9606006Icon from "@/assets/downloaded/Business_people_9606006Icon.vue";
import Business_plan_11925596Icon from "@/assets/downloaded/Business_plan_11925596Icon.vue";
import Business_proposal_6623145Icon from "@/assets/downloaded/Business_proposal_6623145Icon.vue";
import Business_report_4060002Icon from "@/assets/downloaded/Business_report_4060002Icon.vue";
import Business_strategy_9140477Icon from "@/assets/downloaded/Business_strategy_9140477Icon.vue";
import Bus_3124381Icon from "@/assets/downloaded/Bus_3124381Icon.vue";
import Calculator_1760539Icon from "@/assets/downloaded/Calculator_1760539Icon.vue";
import Calculator_2488980Icon from "@/assets/downloaded/Calculator_2488980Icon.vue";
import Calculator_5151275Icon from "@/assets/downloaded/Calculator_5151275Icon.vue";
import Calendar_10403035Icon from "@/assets/downloaded/Calendar_10403035Icon.vue";
import Calendar_1581943Icon from "@/assets/downloaded/Calendar_1581943Icon.vue";
import Calendar_17376753Icon from "@/assets/downloaded/Calendar_17376753Icon.vue";
import Calendar_2370264Icon from "@/assets/downloaded/Calendar_2370264Icon.vue";
import Calendar_2746028Icon from "@/assets/downloaded/Calendar_2746028Icon.vue";
import Campaign_4573251Icon from "@/assets/downloaded/Campaign_4573251Icon.vue";
import Cancelation_7516548Icon from "@/assets/downloaded/Cancelation_7516548Icon.vue";
import Cancel_3037017Icon from "@/assets/downloaded/Cancel_3037017Icon.vue";
import Cancel_7868098Icon from "@/assets/downloaded/Cancel_7868098Icon.vue";
import Cancel_order_12893893Icon from "@/assets/downloaded/Cancel_order_12893893Icon.vue";
import Cancel_order_13466951Icon from "@/assets/downloaded/Cancel_order_13466951Icon.vue";
import Capability_12133586Icon from "@/assets/downloaded/Capability_12133586Icon.vue";
import Capital_12394258Icon from "@/assets/downloaded/Capital_12394258Icon.vue";
import Capital_17980663Icon from "@/assets/downloaded/Capital_17980663Icon.vue";
import Cards_4748745Icon from "@/assets/downloaded/Cards_4748745Icon.vue";
import Carton_5790352Icon from "@/assets/downloaded/Carton_5790352Icon.vue";
import Car_10105423Icon from "@/assets/downloaded/Car_10105423Icon.vue";
import Car_14236293Icon from "@/assets/downloaded/Car_14236293Icon.vue";
import Car_insurance_11442860Icon from "@/assets/downloaded/Car_insurance_11442860Icon.vue";
import Car_insurance_1518645Icon from "@/assets/downloaded/Car_insurance_1518645Icon.vue";
import Car_insurance_1743700Icon from "@/assets/downloaded/Car_insurance_1743700Icon.vue";
import Car_service_1647922Icon from "@/assets/downloaded/Car_service_1647922Icon.vue";
import Cashback_7444875Icon from "@/assets/downloaded/Cashback_7444875Icon.vue";
import Cashier_2450340Icon from "@/assets/downloaded/Cashier_2450340Icon.vue";
import Cashless_payment_4108841Icon from "@/assets/downloaded/Cashless_payment_4108841Icon.vue";
import Cash_flow_10842949Icon from "@/assets/downloaded/Cash_flow_10842949Icon.vue";
import Cash_flow_15341964Icon from "@/assets/downloaded/Cash_flow_15341964Icon.vue";
import Cash_machine_4689858Icon from "@/assets/downloaded/Cash_machine_4689858Icon.vue";
import Casting_18362364Icon from "@/assets/downloaded/Casting_18362364Icon.vue";
import Category_4013399Icon from "@/assets/downloaded/Category_4013399Icon.vue";
import Caution_4601287Icon from "@/assets/downloaded/Caution_4601287Icon.vue";
import Certificate_1470846Icon from "@/assets/downloaded/Certificate_1470846Icon.vue";
import Chain_14148805Icon from "@/assets/downloaded/Chain_14148805Icon.vue";
import Change_125860Icon from "@/assets/downloaded/Change_125860Icon.vue";
import Chapter_15586789Icon from "@/assets/downloaded/Chapter_15586789Icon.vue";
import Chat_2950667Icon from "@/assets/downloaded/Chat_2950667Icon.vue";
import Chat_9742173Icon from "@/assets/downloaded/Chat_9742173Icon.vue";
import Checklists_6735211Icon from "@/assets/downloaded/Checklists_6735211Icon.vue";
import Checklist_11458709Icon from "@/assets/downloaded/Checklist_11458709Icon.vue";
import Checklist_12681572Icon from "@/assets/downloaded/Checklist_12681572Icon.vue";
import Checklist_15169051Icon from "@/assets/downloaded/Checklist_15169051Icon.vue";
import Checklist_3336536Icon from "@/assets/downloaded/Checklist_3336536Icon.vue";
import Checklist_3750160Icon from "@/assets/downloaded/Checklist_3750160Icon.vue";
import Checklist_4342581Icon from "@/assets/downloaded/Checklist_4342581Icon.vue";
import Checklist_7050554Icon from "@/assets/downloaded/Checklist_7050554Icon.vue";
import Checklist_7547631Icon from "@/assets/downloaded/Checklist_7547631Icon.vue";
import Checklist_8214750Icon from "@/assets/downloaded/Checklist_8214750Icon.vue";
import Checklist_8719356Icon from "@/assets/downloaded/Checklist_8719356Icon.vue";
import Checklist_9752119Icon from "@/assets/downloaded/Checklist_9752119Icon.vue";
import Check_13514507Icon from "@/assets/downloaded/Check_13514507Icon.vue";
import Check_2974151Icon from "@/assets/downloaded/Check_2974151Icon.vue";
import Check_8719000Icon from "@/assets/downloaded/Check_8719000Icon.vue";
import Check_list_1721936Icon from "@/assets/downloaded/Check_list_1721936Icon.vue";
import Check_list_3406866Icon from "@/assets/downloaded/Check_list_3406866Icon.vue";
import Choose_12061689Icon from "@/assets/downloaded/Choose_12061689Icon.vue";
import Chronic_illness_18367611Icon from "@/assets/downloaded/Chronic_illness_18367611Icon.vue";
import Cigarette_2925545Icon from "@/assets/downloaded/Cigarette_2925545Icon.vue";
import Circle_1_10595791Icon from "@/assets/downloaded/Circle_1_10595791Icon.vue";
import Circle_2_11183354Icon from "@/assets/downloaded/Circle_2_11183354Icon.vue";
import Circle_7_11183359Icon from "@/assets/downloaded/Circle_7_11183359Icon.vue";
import Circle_8_10595796Icon from "@/assets/downloaded/Circle_8_10595796Icon.vue";
import Circle_9_10595797Icon from "@/assets/downloaded/Circle_9_10595797Icon.vue";
import Citizenship_18278821Icon from "@/assets/downloaded/Citizenship_18278821Icon.vue";
import Citizenship_7141967Icon from "@/assets/downloaded/Citizenship_7141967Icon.vue";
import Claim_2419593Icon from "@/assets/downloaded/Claim_2419593Icon.vue";
import Classification_14639636Icon from "@/assets/downloaded/Classification_14639636Icon.vue";
import Classroom_3197831Icon from "@/assets/downloaded/Classroom_3197831Icon.vue";
import Cleaning_cart_2975216Icon from "@/assets/downloaded/Cleaning_cart_2975216Icon.vue";
import Client_support_17373211Icon from "@/assets/downloaded/Client_support_17373211Icon.vue";
import Clinic_2222554Icon from "@/assets/downloaded/Clinic_2222554Icon.vue";
import Clipboard_13394359Icon from "@/assets/downloaded/Clipboard_13394359Icon.vue";
import Clipboard_1962592Icon from "@/assets/downloaded/Clipboard_1962592Icon.vue";
import Clipboard_3022148Icon from "@/assets/downloaded/Clipboard_3022148Icon.vue";
import Clipboard_8102915Icon from "@/assets/downloaded/Clipboard_8102915Icon.vue";
import Clipboard_839860Icon from "@/assets/downloaded/Clipboard_839860Icon.vue";
import Cli_10237174Icon from "@/assets/downloaded/Cli_10237174Icon.vue";
import Clock_10227441Icon from "@/assets/downloaded/Clock_10227441Icon.vue";
import Clock_4129791Icon from "@/assets/downloaded/Clock_4129791Icon.vue";
import Close_11963953Icon from "@/assets/downloaded/Close_11963953Icon.vue";
import Coal_1275480Icon from "@/assets/downloaded/Coal_1275480Icon.vue";
import Coding_2010990Icon from "@/assets/downloaded/Coding_2010990Icon.vue";
import Coding_3242120Icon from "@/assets/downloaded/Coding_3242120Icon.vue";
import Collaboration_11992996Icon from "@/assets/downloaded/Collaboration_11992996Icon.vue";
import Collaboration_5541565Icon from "@/assets/downloaded/Collaboration_5541565Icon.vue";
import Commentary_1230203Icon from "@/assets/downloaded/Commentary_1230203Icon.vue";
import Commission_7028100Icon from "@/assets/downloaded/Commission_7028100Icon.vue";
import Commitment_11671576Icon from "@/assets/downloaded/Commitment_11671576Icon.vue";
import Commodity_2973905Icon from "@/assets/downloaded/Commodity_2973905Icon.vue";
import Communication_11208135Icon from "@/assets/downloaded/Communication_11208135Icon.vue";
import Company_5741577Icon from "@/assets/downloaded/Company_5741577Icon.vue";
import Compare_6175740Icon from "@/assets/downloaded/Compare_6175740Icon.vue";
import Competitor_analysis_16314442Icon from "@/assets/downloaded/Competitor_analysis_16314442Icon.vue";
import Complaint_9375697Icon from "@/assets/downloaded/Complaint_9375697Icon.vue";
import Compliance_10521137Icon from "@/assets/downloaded/Compliance_10521137Icon.vue";
import Compliance_17474862Icon from "@/assets/downloaded/Compliance_17474862Icon.vue";
import Compliant_4252474Icon from "@/assets/downloaded/Compliant_4252474Icon.vue";
import Compliant_4961688Icon from "@/assets/downloaded/Compliant_4961688Icon.vue";
import Computer_1589642Icon from "@/assets/downloaded/Computer_1589642Icon.vue";
import Computer_16103184Icon from "@/assets/downloaded/Computer_16103184Icon.vue";
import Computer_4007539Icon from "@/assets/downloaded/Computer_4007539Icon.vue";
import Configuration_10618038Icon from "@/assets/downloaded/Configuration_10618038Icon.vue";
import Connect_3974952Icon from "@/assets/downloaded/Connect_3974952Icon.vue";
import Consistency_18832178Icon from "@/assets/downloaded/Consistency_18832178Icon.vue";
import Construction_12359525Icon from "@/assets/downloaded/Construction_12359525Icon.vue";
import Construction_14243038Icon from "@/assets/downloaded/Construction_14243038Icon.vue";
import Construction_method_14106373Icon from "@/assets/downloaded/Construction_method_14106373Icon.vue";
import Contacts_18090908Icon from "@/assets/downloaded/Contacts_18090908Icon.vue";
import Container_3364160Icon from "@/assets/downloaded/Container_3364160Icon.vue";
import Container_4459682Icon from "@/assets/downloaded/Container_4459682Icon.vue";
import Container_7115168Icon from "@/assets/downloaded/Container_7115168Icon.vue";
import Content_11386335Icon from "@/assets/downloaded/Content_11386335Icon.vue";
import Contractor_11671674Icon from "@/assets/downloaded/Contractor_11671674Icon.vue";
import Contractor_12003757Icon from "@/assets/downloaded/Contractor_12003757Icon.vue";
import Contract_10279810Icon from "@/assets/downloaded/Contract_10279810Icon.vue";
import Contract_11000620Icon from "@/assets/downloaded/Contract_11000620Icon.vue";
import Contract_11099161Icon from "@/assets/downloaded/Contract_11099161Icon.vue";
import Contract_12003720Icon from "@/assets/downloaded/Contract_12003720Icon.vue";
import Contract_1275212Icon from "@/assets/downloaded/Contract_1275212Icon.vue";
import Contract_15586801Icon from "@/assets/downloaded/Contract_15586801Icon.vue";
import Contract_17213425Icon from "@/assets/downloaded/Contract_17213425Icon.vue";
import Contract_1721843Icon from "@/assets/downloaded/Contract_1721843Icon.vue";
import Contract_17322641Icon from "@/assets/downloaded/Contract_17322641Icon.vue";
import Contract_17718602Icon from "@/assets/downloaded/Contract_17718602Icon.vue";
import Contract_18601700Icon from "@/assets/downloaded/Contract_18601700Icon.vue";
import Contract_2655351Icon from "@/assets/downloaded/Contract_2655351Icon.vue";
import Contract_2666523Icon from "@/assets/downloaded/Contract_2666523Icon.vue";
import Contract_3985921Icon from "@/assets/downloaded/Contract_3985921Icon.vue";
import Contract_5513696Icon from "@/assets/downloaded/Contract_5513696Icon.vue";
import Contract_5545080Icon from "@/assets/downloaded/Contract_5545080Icon.vue";
import Contract_5545095Icon from "@/assets/downloaded/Contract_5545095Icon.vue";
import Contract_5965822Icon from "@/assets/downloaded/Contract_5965822Icon.vue";
import Contract_6822251Icon from "@/assets/downloaded/Contract_6822251Icon.vue";
import Contract_7352878Icon from "@/assets/downloaded/Contract_7352878Icon.vue";
import Contract_757320Icon from "@/assets/downloaded/Contract_757320Icon.vue";
import Contract_913393Icon from "@/assets/downloaded/Contract_913393Icon.vue";
import Contract_9186233Icon from "@/assets/downloaded/Contract_9186233Icon.vue";
import Contract_document_15913380Icon from "@/assets/downloaded/Contract_document_15913380Icon.vue";
import Controller_1687819Icon from "@/assets/downloaded/Controller_1687819Icon.vue";
import Control_12943317Icon from "@/assets/downloaded/Control_12943317Icon.vue";
import Conversation_3050431Icon from "@/assets/downloaded/Conversation_3050431Icon.vue";
import Conversion_rate_17328299Icon from "@/assets/downloaded/Conversion_rate_17328299Icon.vue";
import Cooperation_9139670Icon from "@/assets/downloaded/Cooperation_9139670Icon.vue";
import Coordinated_17876780Icon from "@/assets/downloaded/Coordinated_17876780Icon.vue";
import Copy_2874774Icon from "@/assets/downloaded/Copy_2874774Icon.vue";
import Corporation_18666942Icon from "@/assets/downloaded/Corporation_18666942Icon.vue";
import Corrugated_16587756Icon from "@/assets/downloaded/Corrugated_16587756Icon.vue";
import Corruption_5267757Icon from "@/assets/downloaded/Corruption_5267757Icon.vue";
import Cost_12573938Icon from "@/assets/downloaded/Cost_12573938Icon.vue";
import Cost_3875852Icon from "@/assets/downloaded/Cost_3875852Icon.vue";
import Cost_5531516Icon from "@/assets/downloaded/Cost_5531516Icon.vue";
import Cost_5656822Icon from "@/assets/downloaded/Cost_5656822Icon.vue";
import Cost_7700020Icon from "@/assets/downloaded/Cost_7700020Icon.vue";
import Cost_circle_18851400Icon from "@/assets/downloaded/Cost_circle_18851400Icon.vue";
import Cost_of_goods_sold_15554945Icon from "@/assets/downloaded/Cost_of_goods_sold_15554945Icon.vue";
import Counter_3410112Icon from "@/assets/downloaded/Counter_3410112Icon.vue";
import Counter_7207766Icon from "@/assets/downloaded/Counter_7207766Icon.vue";
import Coupons_4683372Icon from "@/assets/downloaded/Coupons_4683372Icon.vue";
import Coupon_9551915Icon from "@/assets/downloaded/Coupon_9551915Icon.vue";
import Courier_7000501Icon from "@/assets/downloaded/Courier_7000501Icon.vue";
import Credit_card_4021708Icon from "@/assets/downloaded/Credit_card_4021708Icon.vue";
import Credit_card_4457310Icon from "@/assets/downloaded/Credit_card_4457310Icon.vue";
import Credit_card_4689390Icon from "@/assets/downloaded/Credit_card_4689390Icon.vue";
import Currencies_2601491Icon from "@/assets/downloaded/Currencies_2601491Icon.vue";
import Currency_exchange_2473887Icon from "@/assets/downloaded/Currency_exchange_2473887Icon.vue";
import Customer_journey_18665145Icon from "@/assets/downloaded/Customer_journey_18665145Icon.vue";
import Customer_service_3632552Icon from "@/assets/downloaded/Customer_service_3632552Icon.vue";
import Customer_support_12247491Icon from "@/assets/downloaded/Customer_support_12247491Icon.vue";
import Custom_2760940Icon from "@/assets/downloaded/Custom_2760940Icon.vue";
import Custom_clearance_12828346Icon from "@/assets/downloaded/Custom_clearance_12828346Icon.vue";
import Custom_clearance_14785145Icon from "@/assets/downloaded/Custom_clearance_14785145Icon.vue";
import Custom_clearance_7141914Icon from "@/assets/downloaded/Custom_clearance_7141914Icon.vue";
import Cycle_7267546Icon from "@/assets/downloaded/Cycle_7267546Icon.vue";
import Damaged_package_5501789Icon from "@/assets/downloaded/Damaged_package_5501789Icon.vue";
import Damage_16934322Icon from "@/assets/downloaded/Damage_16934322Icon.vue";
import Dashboard_2956542Icon from "@/assets/downloaded/Dashboard_2956542Icon.vue";
import Dashboard_8278857Icon from "@/assets/downloaded/Dashboard_8278857Icon.vue";
import Database_12945605Icon from "@/assets/downloaded/Database_12945605Icon.vue";
import Data_993762Icon from "@/assets/downloaded/Data_993762Icon.vue";
import Data_cleaning_12091023Icon from "@/assets/downloaded/Data_cleaning_12091023Icon.vue";
import Data_cleanup_17982835Icon from "@/assets/downloaded/Data_cleanup_17982835Icon.vue";
import Data_collection_10003054Icon from "@/assets/downloaded/Data_collection_10003054Icon.vue";
import Data_compression_4403169Icon from "@/assets/downloaded/Data_compression_4403169Icon.vue";
import Data_replication_16810774Icon from "@/assets/downloaded/Data_replication_16810774Icon.vue";
import Data_report_18034974Icon from "@/assets/downloaded/Data_report_18034974Icon.vue";
import Data_transfer_8316751Icon from "@/assets/downloaded/Data_transfer_8316751Icon.vue";
import Data_warehouse_18273867Icon from "@/assets/downloaded/Data_warehouse_18273867Icon.vue";
import Data_warehouse_4149668Icon from "@/assets/downloaded/Data_warehouse_4149668Icon.vue";
import Day_off_7174337Icon from "@/assets/downloaded/Day_off_7174337Icon.vue";
import Deadline_2612924Icon from "@/assets/downloaded/Deadline_2612924Icon.vue";
import Deal_2601512Icon from "@/assets/downloaded/Deal_2601512Icon.vue";
import Deal_paper_18819525Icon from "@/assets/downloaded/Deal_paper_18819525Icon.vue";
import Debit_card_1087117Icon from "@/assets/downloaded/Debit_card_1087117Icon.vue";
import Debt_5104787Icon from "@/assets/downloaded/Debt_5104787Icon.vue";
import Debt_consolidation_2516260Icon from "@/assets/downloaded/Debt_consolidation_2516260Icon.vue";
import Defective_5187063Icon from "@/assets/downloaded/Defective_5187063Icon.vue";
import Deficit_10064043Icon from "@/assets/downloaded/Deficit_10064043Icon.vue";
import Definition_11036823Icon from "@/assets/downloaded/Definition_11036823Icon.vue";
import Definition_15873524Icon from "@/assets/downloaded/Definition_15873524Icon.vue";
import Delegation_7626111Icon from "@/assets/downloaded/Delegation_7626111Icon.vue";
import Delete_2807722Icon from "@/assets/downloaded/Delete_2807722Icon.vue";
import Delete_3240358Icon from "@/assets/downloaded/Delete_3240358Icon.vue";
import Delivery_4791449Icon from "@/assets/downloaded/Delivery_4791449Icon.vue";
import Delivery_box_4213948Icon from "@/assets/downloaded/Delivery_box_4213948Icon.vue";
import Delivery_car_7615749Icon from "@/assets/downloaded/Delivery_car_7615749Icon.vue";
import Delivery_service_11458660Icon from "@/assets/downloaded/Delivery_service_11458660Icon.vue";
import Delivery_status_9272041Icon from "@/assets/downloaded/Delivery_status_9272041Icon.vue";
import Delivery_truck_17886103Icon from "@/assets/downloaded/Delivery_truck_17886103Icon.vue";
import Design_resources_17921234Icon from "@/assets/downloaded/Design_resources_17921234Icon.vue";
import Destination_6889707Icon from "@/assets/downloaded/Destination_6889707Icon.vue";
import Destination_9655360Icon from "@/assets/downloaded/Destination_9655360Icon.vue";
import Detector_11875686Icon from "@/assets/downloaded/Detector_11875686Icon.vue";
import Diagnosis_17749910Icon from "@/assets/downloaded/Diagnosis_17749910Icon.vue";
import Disclaimer_11422025Icon from "@/assets/downloaded/Disclaimer_11422025Icon.vue";
import Disclosure_18035720Icon from "@/assets/downloaded/Disclosure_18035720Icon.vue";
import Discount_17173670Icon from "@/assets/downloaded/Discount_17173670Icon.vue";
import Discount_879757Icon from "@/assets/downloaded/Discount_879757Icon.vue";
import Discount_coupon_9618755Icon from "@/assets/downloaded/Discount_coupon_9618755Icon.vue";
import Dismissal_6896416Icon from "@/assets/downloaded/Dismissal_6896416Icon.vue";
import Disposal_3154606Icon from "@/assets/downloaded/Disposal_3154606Icon.vue";
import Distance_learning_3359690Icon from "@/assets/downloaded/Distance_learning_3359690Icon.vue";
import Distribution_7444365Icon from "@/assets/downloaded/Distribution_7444365Icon.vue";
import Distribution_9402109Icon from "@/assets/downloaded/Distribution_9402109Icon.vue";
import Dms_12280933Icon from "@/assets/downloaded/Dms_12280933Icon.vue";
import Doctor_3481061Icon from "@/assets/downloaded/Doctor_3481061Icon.vue";
import Doctor_consultation_15756405Icon from "@/assets/downloaded/Doctor_consultation_15756405Icon.vue";
import Documents_9409822Icon from "@/assets/downloaded/Documents_9409822Icon.vue";
import Document_10103861Icon from "@/assets/downloaded/Document_10103861Icon.vue";
import Document_10690902Icon from "@/assets/downloaded/Document_10690902Icon.vue";
import Document_12410588Icon from "@/assets/downloaded/Document_12410588Icon.vue";
import Document_12507778Icon from "@/assets/downloaded/Document_12507778Icon.vue";
import Document_13068212Icon from "@/assets/downloaded/Document_13068212Icon.vue";
import Document_14228636Icon from "@/assets/downloaded/Document_14228636Icon.vue";
import Document_1459111Icon from "@/assets/downloaded/Document_1459111Icon.vue";
import Document_15839141Icon from "@/assets/downloaded/Document_15839141Icon.vue";
import Document_16227978Icon from "@/assets/downloaded/Document_16227978Icon.vue";
import Document_17931105Icon from "@/assets/downloaded/Document_17931105Icon.vue";
import Document_2615828Icon from "@/assets/downloaded/Document_2615828Icon.vue";
import Document_2802210Icon from "@/assets/downloaded/Document_2802210Icon.vue";
import Document_2833676Icon from "@/assets/downloaded/Document_2833676Icon.vue";
import Document_3028707Icon from "@/assets/downloaded/Document_3028707Icon.vue";
import Document_3131591Icon from "@/assets/downloaded/Document_3131591Icon.vue";
import Document_4168367Icon from "@/assets/downloaded/Document_4168367Icon.vue";
import Document_5036831Icon from "@/assets/downloaded/Document_5036831Icon.vue";
import Document_5064870Icon from "@/assets/downloaded/Document_5064870Icon.vue";
import Document_6179995Icon from "@/assets/downloaded/Document_6179995Icon.vue";
import Document_6486605Icon from "@/assets/downloaded/Document_6486605Icon.vue";
import Document_6679506Icon from "@/assets/downloaded/Document_6679506Icon.vue";
import Document_8848039Icon from "@/assets/downloaded/Document_8848039Icon.vue";
import Doc_file_8586188Icon from "@/assets/downloaded/Doc_file_8586188Icon.vue";
import Dollar_7250391Icon from "@/assets/downloaded/Dollar_7250391Icon.vue";
import Door_to_door_10352744Icon from "@/assets/downloaded/Door_to_door_10352744Icon.vue";
import Double_bed_2284001Icon from "@/assets/downloaded/Double_bed_2284001Icon.vue";
import Driver_license_2916223Icon from "@/assets/downloaded/Driver_license_2916223Icon.vue";
import Drugs_840781Icon from "@/assets/downloaded/Drugs_840781Icon.vue";
import Due_diligence_12134552Icon from "@/assets/downloaded/Due_diligence_12134552Icon.vue";
import Duplex_9705814Icon from "@/assets/downloaded/Duplex_9705814Icon.vue";
import Ecommerce_2847083Icon from "@/assets/downloaded/Ecommerce_2847083Icon.vue";
import Edit_13246694Icon from "@/assets/downloaded/Edit_13246694Icon.vue";
import Edit_2490572Icon from "@/assets/downloaded/Edit_2490572Icon.vue";
import Edit_7073677Icon from "@/assets/downloaded/Edit_7073677Icon.vue";
import Edit_8470847Icon from "@/assets/downloaded/Edit_8470847Icon.vue";
import Education_level_18178797Icon from "@/assets/downloaded/Education_level_18178797Icon.vue";
import Email_18410022Icon from "@/assets/downloaded/Email_18410022Icon.vue";
import Email_2303951Icon from "@/assets/downloaded/Email_2303951Icon.vue";
import Email_4548492Icon from "@/assets/downloaded/Email_4548492Icon.vue";
import Emergency_17774923Icon from "@/assets/downloaded/Emergency_17774923Icon.vue";
import Emergency_exit_5523246Icon from "@/assets/downloaded/Emergency_exit_5523246Icon.vue";
import Emergency_room_9733672Icon from "@/assets/downloaded/Emergency_room_9733672Icon.vue";
import Employee_14331334Icon from "@/assets/downloaded/Employee_14331334Icon.vue";
import Employee_18819990Icon from "@/assets/downloaded/Employee_18819990Icon.vue";
import Employee_912316Icon from "@/assets/downloaded/Employee_912316Icon.vue";
import Employee_assessment_16761069Icon from "@/assets/downloaded/Employee_assessment_16761069Icon.vue";
import Employee_data_11542066Icon from "@/assets/downloaded/Employee_data_11542066Icon.vue";
import Employee_of_the_month_12422988Icon from "@/assets/downloaded/Employee_of_the_month_12422988Icon.vue";
import Erp_5627023Icon from "@/assets/downloaded/Erp_5627023Icon.vue";
import Error_message_2581972Icon from "@/assets/downloaded/Error_message_2581972Icon.vue";
import Escrow_15166230Icon from "@/assets/downloaded/Escrow_15166230Icon.vue";
import Estate_12394291Icon from "@/assets/downloaded/Estate_12394291Icon.vue";
import Estate_planning_15636935Icon from "@/assets/downloaded/Estate_planning_15636935Icon.vue";
import Estimation_9735680Icon from "@/assets/downloaded/Estimation_9735680Icon.vue";
import Evaluation_12197483Icon from "@/assets/downloaded/Evaluation_12197483Icon.vue";
import Event_2413035Icon from "@/assets/downloaded/Event_2413035Icon.vue";
import Excavator_4968068Icon from "@/assets/downloaded/Excavator_4968068Icon.vue";
import Exchange_1585147Icon from "@/assets/downloaded/Exchange_1585147Icon.vue";
import Exchange_3979328Icon from "@/assets/downloaded/Exchange_3979328Icon.vue";
import Exchange_9788303Icon from "@/assets/downloaded/Exchange_9788303Icon.vue";
import Exchange_rate_2510663Icon from "@/assets/downloaded/Exchange_rate_2510663Icon.vue";
import Exclusion_12058761Icon from "@/assets/downloaded/Exclusion_12058761Icon.vue";
import Execution_16753378Icon from "@/assets/downloaded/Execution_16753378Icon.vue";
import Expenses_17777561Icon from "@/assets/downloaded/Expenses_17777561Icon.vue";
import Expenses_8655448Icon from "@/assets/downloaded/Expenses_8655448Icon.vue";
import Expense_11241017Icon from "@/assets/downloaded/Expense_11241017Icon.vue";
import Export_14105078Icon from "@/assets/downloaded/Export_14105078Icon.vue";
import Export_2356610Icon from "@/assets/downloaded/Export_2356610Icon.vue";
import Extinguisher_5672574Icon from "@/assets/downloaded/Extinguisher_5672574Icon.vue";
import Field_trip_5190157Icon from "@/assets/downloaded/Field_trip_5190157Icon.vue";
import Files_15330716Icon from "@/assets/downloaded/Files_15330716Icon.vue";
import File_10217805Icon from "@/assets/downloaded/File_10217805Icon.vue";
import File_1362090Icon from "@/assets/downloaded/File_1362090Icon.vue";
import File_14680590Icon from "@/assets/downloaded/File_14680590Icon.vue";
import File_16882340Icon from "@/assets/downloaded/File_16882340Icon.vue";
import File_2140667Icon from "@/assets/downloaded/File_2140667Icon.vue";
import File_2521572Icon from "@/assets/downloaded/File_2521572Icon.vue";
import File_2997966Icon from "@/assets/downloaded/File_2997966Icon.vue";
import File_3286176Icon from "@/assets/downloaded/File_3286176Icon.vue";
import File_8406598Icon from "@/assets/downloaded/File_8406598Icon.vue";
import File_8406610Icon from "@/assets/downloaded/File_8406610Icon.vue";
import File_import_14400288Icon from "@/assets/downloaded/File_import_14400288Icon.vue";
import File_rotation_15948280Icon from "@/assets/downloaded/File_rotation_15948280Icon.vue";
import File_transfer_11305627Icon from "@/assets/downloaded/File_transfer_11305627Icon.vue";
import File_transfer_12192997Icon from "@/assets/downloaded/File_transfer_12192997Icon.vue";
import Filter_1159641Icon from "@/assets/downloaded/Filter_1159641Icon.vue";
import Filter_1511905Icon from "@/assets/downloaded/Filter_1511905Icon.vue";
import Filter_17321815Icon from "@/assets/downloaded/Filter_17321815Icon.vue";
import Filter_3839020Icon from "@/assets/downloaded/Filter_3839020Icon.vue";
import Finance_1992253Icon from "@/assets/downloaded/Finance_1992253Icon.vue";
import Finance_4072713Icon from "@/assets/downloaded/Finance_4072713Icon.vue";
import Finance_8581429Icon from "@/assets/downloaded/Finance_8581429Icon.vue";
import Financial_9423027Icon from "@/assets/downloaded/Financial_9423027Icon.vue";
import Financial_audit_17786297Icon from "@/assets/downloaded/Financial_audit_17786297Icon.vue";
import Financial_information_10064074Icon from "@/assets/downloaded/Financial_information_10064074Icon.vue";
import Financial_planning_15586826Icon from "@/assets/downloaded/Financial_planning_15586826Icon.vue";
import Financial_statement_6341974Icon from "@/assets/downloaded/Financial_statement_6341974Icon.vue";
import Financing_18242351Icon from "@/assets/downloaded/Financing_18242351Icon.vue";
import Fiscal_17756128Icon from "@/assets/downloaded/Fiscal_17756128Icon.vue";
import Five_4626501Icon from "@/assets/downloaded/Five_4626501Icon.vue";
import Five_stars_5134846Icon from "@/assets/downloaded/Five_stars_5134846Icon.vue";
import Fixed_asset_3491684Icon from "@/assets/downloaded/Fixed_asset_3491684Icon.vue";
import Flags_455582Icon from "@/assets/downloaded/Flags_455582Icon.vue";
import Floor_7700034Icon from "@/assets/downloaded/Floor_7700034Icon.vue";
import Flute_848166Icon from "@/assets/downloaded/Flute_848166Icon.vue";
import Focus_group_16805859Icon from "@/assets/downloaded/Focus_group_16805859Icon.vue";
import Folder_10210092Icon from "@/assets/downloaded/Folder_10210092Icon.vue";
import Folder_10828574Icon from "@/assets/downloaded/Folder_10828574Icon.vue";
import Folder_13644434Icon from "@/assets/downloaded/Folder_13644434Icon.vue";
import Folder_16090918Icon from "@/assets/downloaded/Folder_16090918Icon.vue";
import Folder_17864149Icon from "@/assets/downloaded/Folder_17864149Icon.vue";
import Folder_8117645Icon from "@/assets/downloaded/Folder_8117645Icon.vue";
import Follow_up_16792851Icon from "@/assets/downloaded/Follow_up_16792851Icon.vue";
import Food_2771460Icon from "@/assets/downloaded/Food_2771460Icon.vue";
import Food_preparation_18810291Icon from "@/assets/downloaded/Food_preparation_18810291Icon.vue";
import Forecasting_8553022Icon from "@/assets/downloaded/Forecasting_8553022Icon.vue";
import Forecast_6633516Icon from "@/assets/downloaded/Forecast_6633516Icon.vue";
import Forecast_analytics_16137972Icon from "@/assets/downloaded/Forecast_analytics_16137972Icon.vue";
import Framework_4160849Icon from "@/assets/downloaded/Framework_4160849Icon.vue";
import Frame_7033171Icon from "@/assets/downloaded/Frame_7033171Icon.vue";
import Free_shipping_15557514Icon from "@/assets/downloaded/Free_shipping_15557514Icon.vue";
import Freight_18303387Icon from "@/assets/downloaded/Freight_18303387Icon.vue";
import Function_18565923Icon from "@/assets/downloaded/Function_18565923Icon.vue";
import Gadget_6711321Icon from "@/assets/downloaded/Gadget_6711321Icon.vue";
import Gears_9581641Icon from "@/assets/downloaded/Gears_9581641Icon.vue";
import Gear_13355740Icon from "@/assets/downloaded/Gear_13355740Icon.vue";
import Gear_17870834Icon from "@/assets/downloaded/Gear_17870834Icon.vue";
import Gear_2953165Icon from "@/assets/downloaded/Gear_2953165Icon.vue";
import Gear_518875Icon from "@/assets/downloaded/Gear_518875Icon.vue";
import Gift_2731865Icon from "@/assets/downloaded/Gift_2731865Icon.vue";
import Gift_box_18098228Icon from "@/assets/downloaded/Gift_box_18098228Icon.vue";
import Goal_1465829Icon from "@/assets/downloaded/Goal_1465829Icon.vue";
import Goods_12003912Icon from "@/assets/downloaded/Goods_12003912Icon.vue";
import Group_3394744Icon from "@/assets/downloaded/Group_3394744Icon.vue";
import Group_8073854Icon from "@/assets/downloaded/Group_8073854Icon.vue";
import Gruop_16390039Icon from "@/assets/downloaded/Gruop_16390039Icon.vue";
import Guide_17050066Icon from "@/assets/downloaded/Guide_17050066Icon.vue";
import Handrail_4349346Icon from "@/assets/downloaded/Handrail_4349346Icon.vue";
import Handshake_10266978Icon from "@/assets/downloaded/Handshake_10266978Icon.vue";
import Handshake_2613094Icon from "@/assets/downloaded/Handshake_2613094Icon.vue";
import Hand_18409994Icon from "@/assets/downloaded/Hand_18409994Icon.vue";
import Hatchback_5035167Icon from "@/assets/downloaded/Hatchback_5035167Icon.vue";
import Healthcare_2966334Icon from "@/assets/downloaded/Healthcare_2966334Icon.vue";
import Healthcare_4003747Icon from "@/assets/downloaded/Healthcare_4003747Icon.vue";
import Healthy_eating_18706159Icon from "@/assets/downloaded/Healthy_eating_18706159Icon.vue";
import Healthy_food_9757178Icon from "@/assets/downloaded/Healthy_food_9757178Icon.vue";
import Health_insurance_12712315Icon from "@/assets/downloaded/Health_insurance_12712315Icon.vue";
import Health_insurance_4388224Icon from "@/assets/downloaded/Health_insurance_4388224Icon.vue";
import Health_report_17967663Icon from "@/assets/downloaded/Health_report_17967663Icon.vue";
import Help_1660114Icon from "@/assets/downloaded/Help_1660114Icon.vue";
import Hijri_15364805Icon from "@/assets/downloaded/Hijri_15364805Icon.vue";
import History_15231313Icon from "@/assets/downloaded/History_15231313Icon.vue";
import Hold_5966090Icon from "@/assets/downloaded/Hold_5966090Icon.vue";
import Holidays_3634857Icon from "@/assets/downloaded/Holidays_3634857Icon.vue";
import Homework_17251701Icon from "@/assets/downloaded/Homework_17251701Icon.vue";
import Homework_4711767Icon from "@/assets/downloaded/Homework_4711767Icon.vue";
import Home_1848500Icon from "@/assets/downloaded/Home_1848500Icon.vue";
import Hospitalisation_2302792Icon from "@/assets/downloaded/Hospitalisation_2302792Icon.vue";
import Hospital_2895071Icon from "@/assets/downloaded/Hospital_2895071Icon.vue";
import Hospital_3209159Icon from "@/assets/downloaded/Hospital_3209159Icon.vue";
import Hotel_201426Icon from "@/assets/downloaded/Hotel_201426Icon.vue";
import Hotel_bed_3060178Icon from "@/assets/downloaded/Hotel_bed_3060178Icon.vue";
import House_10604757Icon from "@/assets/downloaded/House_10604757Icon.vue";
import House_3637773Icon from "@/assets/downloaded/House_3637773Icon.vue";
import House_9202668Icon from "@/assets/downloaded/House_9202668Icon.vue";
import House_lock_5687474Icon from "@/assets/downloaded/House_lock_5687474Icon.vue";
import Human_5246761Icon from "@/assets/downloaded/Human_5246761Icon.vue";
import Human_resources_10488501Icon from "@/assets/downloaded/Human_resources_10488501Icon.vue";
import Idea_9453383Icon from "@/assets/downloaded/Idea_9453383Icon.vue";
import Id_card_10721956Icon from "@/assets/downloaded/Id_card_10721956Icon.vue";
import Illegal_5736545Icon from "@/assets/downloaded/Illegal_5736545Icon.vue";
import Important_mail_11889689Icon from "@/assets/downloaded/Important_mail_11889689Icon.vue";
import Import_export_15221871Icon from "@/assets/downloaded/Import_export_15221871Icon.vue";
import Inbound_12141524Icon from "@/assets/downloaded/Inbound_12141524Icon.vue";
import Inch_4236604Icon from "@/assets/downloaded/Inch_4236604Icon.vue";
import Increase_10243550Icon from "@/assets/downloaded/Increase_10243550Icon.vue";
import Infrastructure_11495742Icon from "@/assets/downloaded/Infrastructure_11495742Icon.vue";
import Input_9671337Icon from "@/assets/downloaded/Input_9671337Icon.vue";
import Insight_18492905Icon from "@/assets/downloaded/Insight_18492905Icon.vue";
import Inspection_15166526Icon from "@/assets/downloaded/Inspection_15166526Icon.vue";
import Inspection_5531663Icon from "@/assets/downloaded/Inspection_5531663Icon.vue";
import Inspection_6052465Icon from "@/assets/downloaded/Inspection_6052465Icon.vue";
import Instructions_12627704Icon from "@/assets/downloaded/Instructions_12627704Icon.vue";
import Insurance_11443006Icon from "@/assets/downloaded/Insurance_11443006Icon.vue";
import Insurance_1962586Icon from "@/assets/downloaded/Insurance_1962586Icon.vue";
import Insurance_6888112Icon from "@/assets/downloaded/Insurance_6888112Icon.vue";
import Insurance_9824434Icon from "@/assets/downloaded/Insurance_9824434Icon.vue";
import Insurance_audit_13068277Icon from "@/assets/downloaded/Insurance_audit_13068277Icon.vue";
import Insurance_company_7339353Icon from "@/assets/downloaded/Insurance_company_7339353Icon.vue";
import Integration_4618560Icon from "@/assets/downloaded/Integration_4618560Icon.vue";
import Interior_design_2400622Icon from "@/assets/downloaded/Interior_design_2400622Icon.vue";
import Internet_16502214Icon from "@/assets/downloaded/Internet_16502214Icon.vue";
import Inventory_12141431Icon from "@/assets/downloaded/Inventory_12141431Icon.vue";
import Inventory_18771476Icon from "@/assets/downloaded/Inventory_18771476Icon.vue";
import Inventory_2897616Icon from "@/assets/downloaded/Inventory_2897616Icon.vue";
import Inventory_management_18564078Icon from "@/assets/downloaded/Inventory_management_18564078Icon.vue";
import Inventory_management_8744645Icon from "@/assets/downloaded/Inventory_management_8744645Icon.vue";
import Investment_12942999Icon from "@/assets/downloaded/Investment_12942999Icon.vue";
import Investment_16485024Icon from "@/assets/downloaded/Investment_16485024Icon.vue";
import Investment_2159865Icon from "@/assets/downloaded/Investment_2159865Icon.vue";
import Investment_4930129Icon from "@/assets/downloaded/Investment_4930129Icon.vue";
import Investor_2386356Icon from "@/assets/downloaded/Investor_2386356Icon.vue";
import Invoices_3358993Icon from "@/assets/downloaded/Invoices_3358993Icon.vue";
import Invoice_10112462Icon from "@/assets/downloaded/Invoice_10112462Icon.vue";
import Invoice_12155208Icon from "@/assets/downloaded/Invoice_12155208Icon.vue";
import Invoice_12676454Icon from "@/assets/downloaded/Invoice_12676454Icon.vue";
import Invoice_12970042Icon from "@/assets/downloaded/Invoice_12970042Icon.vue";
import Invoice_15575258Icon from "@/assets/downloaded/Invoice_15575258Icon.vue";
import Invoice_16933159Icon from "@/assets/downloaded/Invoice_16933159Icon.vue";
import Invoice_18491196Icon from "@/assets/downloaded/Invoice_18491196Icon.vue";
import Invoice_18964749Icon from "@/assets/downloaded/Invoice_18964749Icon.vue";
import Invoice_2474482Icon from "@/assets/downloaded/Invoice_2474482Icon.vue";
import Invoice_3408829Icon from "@/assets/downloaded/Invoice_3408829Icon.vue";
import Invoice_411796Icon from "@/assets/downloaded/Invoice_411796Icon.vue";
import Invoice_4306889Icon from "@/assets/downloaded/Invoice_4306889Icon.vue";
import Invoice_4862319Icon from "@/assets/downloaded/Invoice_4862319Icon.vue";
import Invoice_6026725Icon from "@/assets/downloaded/Invoice_6026725Icon.vue";
import Invoice_7291266Icon from "@/assets/downloaded/Invoice_7291266Icon.vue";
import Invoice_8354689Icon from "@/assets/downloaded/Invoice_8354689Icon.vue";
import Invoice_9071521Icon from "@/assets/downloaded/Invoice_9071521Icon.vue";
import In_stock_7444276Icon from "@/assets/downloaded/In_stock_7444276Icon.vue";
import Isolation_3062991Icon from "@/assets/downloaded/Isolation_3062991Icon.vue";
import Item_12512009Icon from "@/assets/downloaded/Item_12512009Icon.vue";
import Job_11898010Icon from "@/assets/downloaded/Job_11898010Icon.vue";
import Job_application_15189386Icon from "@/assets/downloaded/Job_application_15189386Icon.vue";
import Job_description_7376263Icon from "@/assets/downloaded/Job_description_7376263Icon.vue";
import Job_offer_15189475Icon from "@/assets/downloaded/Job_offer_15189475Icon.vue";
import Journal_12237179Icon from "@/assets/downloaded/Journal_12237179Icon.vue";
import Justice_16200810Icon from "@/assets/downloaded/Justice_16200810Icon.vue";
import Keyboard_15463172Icon from "@/assets/downloaded/Keyboard_15463172Icon.vue";
import Keyword_542632Icon from "@/assets/downloaded/Keyword_542632Icon.vue";
import Key_10217862Icon from "@/assets/downloaded/Key_10217862Icon.vue";
import Key_10647744Icon from "@/assets/downloaded/Key_10647744Icon.vue";
import Key_performance_indicator_10789436Icon from "@/assets/downloaded/Key_performance_indicator_10789436Icon.vue";
import Kitchen_1606657Icon from "@/assets/downloaded/Kitchen_1606657Icon.vue";
import Laboratory_7404175Icon from "@/assets/downloaded/Laboratory_7404175Icon.vue";
import Labor_cost_18250790Icon from "@/assets/downloaded/Labor_cost_18250790Icon.vue";
import Land_8978082Icon from "@/assets/downloaded/Land_8978082Icon.vue";
import Law_book_4474491Icon from "@/assets/downloaded/Law_book_4474491Icon.vue";
import Layout_4507688Icon from "@/assets/downloaded/Layout_4507688Icon.vue";
import Layout_4725672Icon from "@/assets/downloaded/Layout_4725672Icon.vue";
import Leader_10165937Icon from "@/assets/downloaded/Leader_10165937Icon.vue";
import Leader_4059502Icon from "@/assets/downloaded/Leader_4059502Icon.vue";
import Leave_3387310Icon from "@/assets/downloaded/Leave_3387310Icon.vue";
import Ledgers_15773346Icon from "@/assets/downloaded/Ledgers_15773346Icon.vue";
import Ledger_12183981Icon from "@/assets/downloaded/Ledger_12183981Icon.vue";
import Ledger_17001425Icon from "@/assets/downloaded/Ledger_17001425Icon.vue";
import Ledger_4680987Icon from "@/assets/downloaded/Ledger_4680987Icon.vue";
import Legal_18092070Icon from "@/assets/downloaded/Legal_18092070Icon.vue";
import Legal_document_3207533Icon from "@/assets/downloaded/Legal_document_3207533Icon.vue";
import Letter_6259496Icon from "@/assets/downloaded/Letter_6259496Icon.vue";
import Letter_7458351Icon from "@/assets/downloaded/Letter_7458351Icon.vue";
import Letter_of_guarantee_4930623Icon from "@/assets/downloaded/Letter_of_guarantee_4930623Icon.vue";
import Level_up_16863363Icon from "@/assets/downloaded/Level_up_16863363Icon.vue";
import Licensed_12029456Icon from "@/assets/downloaded/Licensed_12029456Icon.vue";
import License_10836475Icon from "@/assets/downloaded/License_10836475Icon.vue";
import Lifting_12299319Icon from "@/assets/downloaded/Lifting_12299319Icon.vue";
import Lighting_3103277Icon from "@/assets/downloaded/Lighting_3103277Icon.vue";
import Link_11598691Icon from "@/assets/downloaded/Link_11598691Icon.vue";
import Link_12366460Icon from "@/assets/downloaded/Link_12366460Icon.vue";
import Link_455691Icon from "@/assets/downloaded/Link_455691Icon.vue";
import Link_building_8157946Icon from "@/assets/downloaded/Link_building_8157946Icon.vue";
import List_17400520Icon from "@/assets/downloaded/List_17400520Icon.vue";
import List_8415783Icon from "@/assets/downloaded/List_8415783Icon.vue";
import List_9131997Icon from "@/assets/downloaded/List_9131997Icon.vue";
import List_9482813Icon from "@/assets/downloaded/List_9482813Icon.vue";
import Loading_8081408Icon from "@/assets/downloaded/Loading_8081408Icon.vue";
import Loan_13794697Icon from "@/assets/downloaded/Loan_13794697Icon.vue";
import Loan_16933118Icon from "@/assets/downloaded/Loan_16933118Icon.vue";
import Loan_5023258Icon from "@/assets/downloaded/Loan_5023258Icon.vue";
import Loan_9828411Icon from "@/assets/downloaded/Loan_9828411Icon.vue";
import Location_12867982Icon from "@/assets/downloaded/Location_12867982Icon.vue";
import Location_7547677Icon from "@/assets/downloaded/Location_7547677Icon.vue";
import Locker_9045439Icon from "@/assets/downloaded/Locker_9045439Icon.vue";
import Logistic_contract_15597258Icon from "@/assets/downloaded/Logistic_contract_15597258Icon.vue";
import Log_17377923Icon from "@/assets/downloaded/Log_17377923Icon.vue";
import Low_performance_2386473Icon from "@/assets/downloaded/Low_performance_2386473Icon.vue";
import Loyal_customer_5431198Icon from "@/assets/downloaded/Loyal_customer_5431198Icon.vue";
import Lunch_4893631Icon from "@/assets/downloaded/Lunch_4893631Icon.vue";
import Machine_13869597Icon from "@/assets/downloaded/Machine_13869597Icon.vue";
import Magazine_4520868Icon from "@/assets/downloaded/Magazine_4520868Icon.vue";
import Mail_12287320Icon from "@/assets/downloaded/Mail_12287320Icon.vue";
import Mail_3720647Icon from "@/assets/downloaded/Mail_3720647Icon.vue";
import Mail_9318057Icon from "@/assets/downloaded/Mail_9318057Icon.vue";
import Maintenance_10559639Icon from "@/assets/downloaded/Maintenance_10559639Icon.vue";
import Maintenance_11276274Icon from "@/assets/downloaded/Maintenance_11276274Icon.vue";
import Maintenance_14305784Icon from "@/assets/downloaded/Maintenance_14305784Icon.vue";
import Maintenance_15569954Icon from "@/assets/downloaded/Maintenance_15569954Icon.vue";
import Maintenance_17073129Icon from "@/assets/downloaded/Maintenance_17073129Icon.vue";
import Maintenance_17876676Icon from "@/assets/downloaded/Maintenance_17876676Icon.vue";
import Maintenance_17972679Icon from "@/assets/downloaded/Maintenance_17972679Icon.vue";
import Maintenance_9831111Icon from "@/assets/downloaded/Maintenance_9831111Icon.vue";
import Maintenance_9878470Icon from "@/assets/downloaded/Maintenance_9878470Icon.vue";
import Management_10211342Icon from "@/assets/downloaded/Management_10211342Icon.vue";
import Management_14432082Icon from "@/assets/downloaded/Management_14432082Icon.vue";
import Management_1570102Icon from "@/assets/downloaded/Management_1570102Icon.vue";
import Management_9205839Icon from "@/assets/downloaded/Management_9205839Icon.vue";
import Manager_10487778Icon from "@/assets/downloaded/Manager_10487778Icon.vue";
import Man_15630692Icon from "@/assets/downloaded/Man_15630692Icon.vue";
import Map_6910292Icon from "@/assets/downloaded/Map_6910292Icon.vue";
import Marketing_16899226Icon from "@/assets/downloaded/Marketing_16899226Icon.vue";
import Marketing_9464695Icon from "@/assets/downloaded/Marketing_9464695Icon.vue";
import Marketing_mix_7253129Icon from "@/assets/downloaded/Marketing_mix_7253129Icon.vue";
import Market_analysis_9254636Icon from "@/assets/downloaded/Market_analysis_9254636Icon.vue";
import Mark_16530462Icon from "@/assets/downloaded/Mark_16530462Icon.vue";
import Material_1556328Icon from "@/assets/downloaded/Material_1556328Icon.vue";
import Math_3655553Icon from "@/assets/downloaded/Math_3655553Icon.vue";
import Meal_17694923Icon from "@/assets/downloaded/Meal_17694923Icon.vue";
import Measure_335446Icon from "@/assets/downloaded/Measure_335446Icon.vue";
import Mechanic_11133669Icon from "@/assets/downloaded/Mechanic_11133669Icon.vue";
import Mediator_7028072Icon from "@/assets/downloaded/Mediator_7028072Icon.vue";
import Medical_2302757Icon from "@/assets/downloaded/Medical_2302757Icon.vue";
import Medical_bill_15135746Icon from "@/assets/downloaded/Medical_bill_15135746Icon.vue";
import Medical_check_2634036Icon from "@/assets/downloaded/Medical_check_2634036Icon.vue";
import Medical_devices_17340723Icon from "@/assets/downloaded/Medical_devices_17340723Icon.vue";
import Medical_expense_17640396Icon from "@/assets/downloaded/Medical_expense_17640396Icon.vue";
import Medical_invoice_4494274Icon from "@/assets/downloaded/Medical_invoice_4494274Icon.vue";
import Medical_journey_17225490Icon from "@/assets/downloaded/Medical_journey_17225490Icon.vue";
import Medical_list_5143800Icon from "@/assets/downloaded/Medical_list_5143800Icon.vue";
import Medical_record_18150546Icon from "@/assets/downloaded/Medical_record_18150546Icon.vue";
import Medical_report_3215528Icon from "@/assets/downloaded/Medical_report_3215528Icon.vue";
import Medical_test_17104715Icon from "@/assets/downloaded/Medical_test_17104715Icon.vue";
import Medicine_5200471Icon from "@/assets/downloaded/Medicine_5200471Icon.vue";
import Message_13579018Icon from "@/assets/downloaded/Message_13579018Icon.vue";
import Message_2604334Icon from "@/assets/downloaded/Message_2604334Icon.vue";
import Message_dollar_14984866Icon from "@/assets/downloaded/Message_dollar_14984866Icon.vue";
import Mic_709950Icon from "@/assets/downloaded/Mic_709950Icon.vue";
import Mission_9092122Icon from "@/assets/downloaded/Mission_9092122Icon.vue";
import Mission_9372147Icon from "@/assets/downloaded/Mission_9372147Icon.vue";
import Mobile_management_17937701Icon from "@/assets/downloaded/Mobile_management_17937701Icon.vue";
import Mobile_payment_4007969Icon from "@/assets/downloaded/Mobile_payment_4007969Icon.vue";
import Modeling_14106298Icon from "@/assets/downloaded/Modeling_14106298Icon.vue";
import Money_10219953Icon from "@/assets/downloaded/Money_10219953Icon.vue";
import Money_13548278Icon from "@/assets/downloaded/Money_13548278Icon.vue";
import Money_14898589Icon from "@/assets/downloaded/Money_14898589Icon.vue";
import Money_16422494Icon from "@/assets/downloaded/Money_16422494Icon.vue";
import Money_16467587Icon from "@/assets/downloaded/Money_16467587Icon.vue";
import Money_2914767Icon from "@/assets/downloaded/Money_2914767Icon.vue";
import Money_3133430Icon from "@/assets/downloaded/Money_3133430Icon.vue";
import Money_bag_2953363Icon from "@/assets/downloaded/Money_bag_2953363Icon.vue";
import Money_box_2504585Icon from "@/assets/downloaded/Money_box_2504585Icon.vue";
import Money_chat_18917729Icon from "@/assets/downloaded/Money_chat_18917729Icon.vue";
import Money_management_12331286Icon from "@/assets/downloaded/Money_management_12331286Icon.vue";
import Money_management_2666527Icon from "@/assets/downloaded/Money_management_2666527Icon.vue";
import Monitor_2930617Icon from "@/assets/downloaded/Monitor_2930617Icon.vue";
import Mortgage_11323576Icon from "@/assets/downloaded/Mortgage_11323576Icon.vue";
import Mortgage_broker_17063906Icon from "@/assets/downloaded/Mortgage_broker_17063906Icon.vue";
import Network_3348099Icon from "@/assets/downloaded/Network_3348099Icon.vue";
import Network_648324Icon from "@/assets/downloaded/Network_648324Icon.vue";
import New_employee_14813059Icon from "@/assets/downloaded/New_employee_14813059Icon.vue";
import New_product_12474335Icon from "@/assets/downloaded/New_product_12474335Icon.vue";
import New_year_16775066Icon from "@/assets/downloaded/New_year_16775066Icon.vue";
import Notebook_3625224Icon from "@/assets/downloaded/Notebook_3625224Icon.vue";
import Note_13703448Icon from "@/assets/downloaded/Note_13703448Icon.vue";
import Notification_2645897Icon from "@/assets/downloaded/Notification_2645897Icon.vue";
import No_corruption_10297234Icon from "@/assets/downloaded/No_corruption_10297234Icon.vue";
import No_document_12342200Icon from "@/assets/downloaded/No_document_12342200Icon.vue";
import No_paper_12065913Icon from "@/assets/downloaded/No_paper_12065913Icon.vue";
import Number_10_7173313Icon from "@/assets/downloaded/Number_10_7173313Icon.vue";
import Number_3_8068125Icon from "@/assets/downloaded/Number_3_8068125Icon.vue";
import Number_3_9387280Icon from "@/assets/downloaded/Number_3_9387280Icon.vue";
import Number_4_10259208Icon from "@/assets/downloaded/Number_4_10259208Icon.vue";
import Number_4_8068178Icon from "@/assets/downloaded/Number_4_8068178Icon.vue";
import Number_5_8068231Icon from "@/assets/downloaded/Number_5_8068231Icon.vue";
import Number_6_8068286Icon from "@/assets/downloaded/Number_6_8068286Icon.vue";
import Number_9_8067927Icon from "@/assets/downloaded/Number_9_8067927Icon.vue";
import Obligations_18564647Icon from "@/assets/downloaded/Obligations_18564647Icon.vue";
import Offer_12003803Icon from "@/assets/downloaded/Offer_12003803Icon.vue";
import Offer_1611173Icon from "@/assets/downloaded/Offer_1611173Icon.vue";
import Offer_9865110Icon from "@/assets/downloaded/Offer_9865110Icon.vue";
import Office_16131924Icon from "@/assets/downloaded/Office_16131924Icon.vue";
import Office_4041177Icon from "@/assets/downloaded/Office_4041177Icon.vue";
import Office_map_13807705Icon from "@/assets/downloaded/Office_map_13807705Icon.vue";
import One_4626473Icon from "@/assets/downloaded/One_4626473Icon.vue";
import Online_16207344Icon from "@/assets/downloaded/Online_16207344Icon.vue";
import Online_learning_18798433Icon from "@/assets/downloaded/Online_learning_18798433Icon.vue";
import Online_shopping_1280804Icon from "@/assets/downloaded/Online_shopping_1280804Icon.vue";
import Online_shopping_3258481Icon from "@/assets/downloaded/Online_shopping_3258481Icon.vue";
import Online_store_9018922Icon from "@/assets/downloaded/Online_store_9018922Icon.vue";
import Operating_system_10397335Icon from "@/assets/downloaded/Operating_system_10397335Icon.vue";
import Operations_18532895Icon from "@/assets/downloaded/Operations_18532895Icon.vue";
import Operation_11337218Icon from "@/assets/downloaded/Operation_11337218Icon.vue";
import Operation_11337444Icon from "@/assets/downloaded/Operation_11337444Icon.vue";
import Operation_11337450Icon from "@/assets/downloaded/Operation_11337450Icon.vue";
import Optimization_8439152Icon from "@/assets/downloaded/Optimization_8439152Icon.vue";
import Order_12015378Icon from "@/assets/downloaded/Order_12015378Icon.vue";
import Order_1554563Icon from "@/assets/downloaded/Order_1554563Icon.vue";
import Order_1671130Icon from "@/assets/downloaded/Order_1671130Icon.vue";
import Order_766251Icon from "@/assets/downloaded/Order_766251Icon.vue";
import Order_7971189Icon from "@/assets/downloaded/Order_7971189Icon.vue";
import Order_fulfillment_17241069Icon from "@/assets/downloaded/Order_fulfillment_17241069Icon.vue";
import Order_tracking_3607527Icon from "@/assets/downloaded/Order_tracking_3607527Icon.vue";
import Order_tracking_9280849Icon from "@/assets/downloaded/Order_tracking_9280849Icon.vue";
import Outpatient_14599729Icon from "@/assets/downloaded/Outpatient_14599729Icon.vue";
import Out_of_stock_10614817Icon from "@/assets/downloaded/Out_of_stock_10614817Icon.vue";
import Overhead_11909702Icon from "@/assets/downloaded/Overhead_11909702Icon.vue";
import Ownership_5605976Icon from "@/assets/downloaded/Ownership_5605976Icon.vue";
import Package_2397992Icon from "@/assets/downloaded/Package_2397992Icon.vue";
import Package_600268Icon from "@/assets/downloaded/Package_600268Icon.vue";
import Packing_list_1670974Icon from "@/assets/downloaded/Packing_list_1670974Icon.vue";
import Papers_12843854Icon from "@/assets/downloaded/Papers_12843854Icon.vue";
import Paper_10407098Icon from "@/assets/downloaded/Paper_10407098Icon.vue";
import Paper_13349577Icon from "@/assets/downloaded/Paper_13349577Icon.vue";
import Paper_14294082Icon from "@/assets/downloaded/Paper_14294082Icon.vue";
import Paper_15978905Icon from "@/assets/downloaded/Paper_15978905Icon.vue";
import Paper_2541979Icon from "@/assets/downloaded/Paper_2541979Icon.vue";
import Paper_5653782Icon from "@/assets/downloaded/Paper_5653782Icon.vue";
import Paper_6300707Icon from "@/assets/downloaded/Paper_6300707Icon.vue";
import Paper_assessment_18895772Icon from "@/assets/downloaded/Paper_assessment_18895772Icon.vue";
import Paper_bag_1625706Icon from "@/assets/downloaded/Paper_bag_1625706Icon.vue";
import Parcel_size_9527158Icon from "@/assets/downloaded/Parcel_size_9527158Icon.vue";
import Parents_10184701Icon from "@/assets/downloaded/Parents_10184701Icon.vue";
import Part_17404360Icon from "@/assets/downloaded/Part_17404360Icon.vue";
import Passport_10865439Icon from "@/assets/downloaded/Passport_10865439Icon.vue";
import Passport_1257113Icon from "@/assets/downloaded/Passport_1257113Icon.vue";
import Passport_control_4696981Icon from "@/assets/downloaded/Passport_control_4696981Icon.vue";
import Patient_2376100Icon from "@/assets/downloaded/Patient_2376100Icon.vue";
import Patient_9733728Icon from "@/assets/downloaded/Patient_9733728Icon.vue";
import Pattern_2048512Icon from "@/assets/downloaded/Pattern_2048512Icon.vue";
import Payment_10683919Icon from "@/assets/downloaded/Payment_10683919Icon.vue";
import Payment_11253966Icon from "@/assets/downloaded/Payment_11253966Icon.vue";
import Payment_18557486Icon from "@/assets/downloaded/Payment_18557486Icon.vue";
import Payment_2530689Icon from "@/assets/downloaded/Payment_2530689Icon.vue";
import Payment_2780279Icon from "@/assets/downloaded/Payment_2780279Icon.vue";
import Payment_4645352Icon from "@/assets/downloaded/Payment_4645352Icon.vue";
import Payment_7262711Icon from "@/assets/downloaded/Payment_7262711Icon.vue";
import Payment_security_14385195Icon from "@/assets/downloaded/Payment_security_14385195Icon.vue";
import Payment_service_17389462Icon from "@/assets/downloaded/Payment_service_17389462Icon.vue";
import Payment_system_15546727Icon from "@/assets/downloaded/Payment_system_15546727Icon.vue";
import Payment_terminal_2666418Icon from "@/assets/downloaded/Payment_terminal_2666418Icon.vue";
import Penalties_12061224Icon from "@/assets/downloaded/Penalties_12061224Icon.vue";
import Penalty_18112872Icon from "@/assets/downloaded/Penalty_18112872Icon.vue";
import Penalty_18144969Icon from "@/assets/downloaded/Penalty_18144969Icon.vue";
import People_15814582Icon from "@/assets/downloaded/People_15814582Icon.vue";
import People_15979414Icon from "@/assets/downloaded/People_15979414Icon.vue";
import People_16070422Icon from "@/assets/downloaded/People_16070422Icon.vue";
import People_1769041Icon from "@/assets/downloaded/People_1769041Icon.vue";
import People_3171593Icon from "@/assets/downloaded/People_3171593Icon.vue";
import Percentage_9731321Icon from "@/assets/downloaded/Percentage_9731321Icon.vue";
import Performance_11883579Icon from "@/assets/downloaded/Performance_11883579Icon.vue";
import Performance_16773505Icon from "@/assets/downloaded/Performance_16773505Icon.vue";
import Performance_3488812Icon from "@/assets/downloaded/Performance_3488812Icon.vue";
import Pharmacy_17692771Icon from "@/assets/downloaded/Pharmacy_17692771Icon.vue";
import Phases_4357Icon from "@/assets/downloaded/Phases_4357Icon.vue";
import Phone_4951609Icon from "@/assets/downloaded/Phone_4951609Icon.vue";
import Phone_call_3059408Icon from "@/assets/downloaded/Phone_call_3059408Icon.vue";
import Photocopy_3648602Icon from "@/assets/downloaded/Photocopy_3648602Icon.vue";
import Physical_therapy_17774705Icon from "@/assets/downloaded/Physical_therapy_17774705Icon.vue";
import Pick_list_11392541Icon from "@/assets/downloaded/Pick_list_11392541Icon.vue";
import Pie_chart_7558222Icon from "@/assets/downloaded/Pie_chart_7558222Icon.vue";
import Pie_graphic_6419899Icon from "@/assets/downloaded/Pie_graphic_6419899Icon.vue";
import Placeholder_819865Icon from "@/assets/downloaded/Placeholder_819865Icon.vue";
import Planning_434346Icon from "@/assets/downloaded/Planning_434346Icon.vue";
import Plan_10120809Icon from "@/assets/downloaded/Plan_10120809Icon.vue";
import Plan_9402085Icon from "@/assets/downloaded/Plan_9402085Icon.vue";
import Point_of_service_6140301Icon from "@/assets/downloaded/Point_of_service_6140301Icon.vue";
import Policy_10710183Icon from "@/assets/downloaded/Policy_10710183Icon.vue";
import Policy_5187181Icon from "@/assets/downloaded/Policy_5187181Icon.vue";
import Portfolio_12304404Icon from "@/assets/downloaded/Portfolio_12304404Icon.vue";
import Portfolio_folder_9413311Icon from "@/assets/downloaded/Portfolio_folder_9413311Icon.vue";
import Posting_11913601Icon from "@/assets/downloaded/Posting_11913601Icon.vue";
import Pos_terminal_6551691Icon from "@/assets/downloaded/Pos_terminal_6551691Icon.vue";
import Preferences_10210533Icon from "@/assets/downloaded/Preferences_10210533Icon.vue";
import Price_list_10103341Icon from "@/assets/downloaded/Price_list_10103341Icon.vue";
import Price_list_11000672Icon from "@/assets/downloaded/Price_list_11000672Icon.vue";
import Price_list_16090725Icon from "@/assets/downloaded/Price_list_16090725Icon.vue";
import Price_list_4464915Icon from "@/assets/downloaded/Price_list_4464915Icon.vue";
import Price_list_4961543Icon from "@/assets/downloaded/Price_list_4961543Icon.vue";
import Price_list_4994468Icon from "@/assets/downloaded/Price_list_4994468Icon.vue";
import Price_list_7444269Icon from "@/assets/downloaded/Price_list_7444269Icon.vue";
import Price_list_8461594Icon from "@/assets/downloaded/Price_list_8461594Icon.vue";
import Price_list_8890319Icon from "@/assets/downloaded/Price_list_8890319Icon.vue";
import Price_tag_567600Icon from "@/assets/downloaded/Price_tag_567600Icon.vue";
import Printer_3465791Icon from "@/assets/downloaded/Printer_3465791Icon.vue";
import Print_4305625Icon from "@/assets/downloaded/Print_4305625Icon.vue";
import Prioritize_10492974Icon from "@/assets/downloaded/Prioritize_10492974Icon.vue";
import Privacy_18238966Icon from "@/assets/downloaded/Privacy_18238966Icon.vue";
import Procedures_11702817Icon from "@/assets/downloaded/Procedures_11702817Icon.vue";
import Procedure_12299115Icon from "@/assets/downloaded/Procedure_12299115Icon.vue";
import Processing_10614604Icon from "@/assets/downloaded/Processing_10614604Icon.vue";
import Process_11494179Icon from "@/assets/downloaded/Process_11494179Icon.vue";
import Process_1865497Icon from "@/assets/downloaded/Process_1865497Icon.vue";
import Process_3078984Icon from "@/assets/downloaded/Process_3078984Icon.vue";
import Process_4149677Icon from "@/assets/downloaded/Process_4149677Icon.vue";
import Procurement_4862413Icon from "@/assets/downloaded/Procurement_4862413Icon.vue";
import Product_1311144Icon from "@/assets/downloaded/Product_1311144Icon.vue";
import Product_15681406Icon from "@/assets/downloaded/Product_15681406Icon.vue";
import Product_15817361Icon from "@/assets/downloaded/Product_15817361Icon.vue";
import Product_2652218Icon from "@/assets/downloaded/Product_2652218Icon.vue";
import Product_3712174Icon from "@/assets/downloaded/Product_3712174Icon.vue";
import Product_7078329Icon from "@/assets/downloaded/Product_7078329Icon.vue";
import Product_8744687Icon from "@/assets/downloaded/Product_8744687Icon.vue";
import Product_categories_15555049Icon from "@/assets/downloaded/Product_categories_15555049Icon.vue";
import Product_cost_12544334Icon from "@/assets/downloaded/Product_cost_12544334Icon.vue";
import Product_description_17311699Icon from "@/assets/downloaded/Product_description_17311699Icon.vue";
import Product_design_15597931Icon from "@/assets/downloaded/Product_design_15597931Icon.vue";
import Product_management_17970641Icon from "@/assets/downloaded/Product_management_17970641Icon.vue";
import Product_recall_16940698Icon from "@/assets/downloaded/Product_recall_16940698Icon.vue";
import Product_return_12459227Icon from "@/assets/downloaded/Product_return_12459227Icon.vue";
import Profile_11889864Icon from "@/assets/downloaded/Profile_11889864Icon.vue";
import Profits_3467240Icon from "@/assets/downloaded/Profits_3467240Icon.vue";
import Programmer_10438910Icon from "@/assets/downloaded/Programmer_10438910Icon.vue";
import Program_10237089Icon from "@/assets/downloaded/Program_10237089Icon.vue";
import Project_10898856Icon from "@/assets/downloaded/Project_10898856Icon.vue";
import Project_2679418Icon from "@/assets/downloaded/Project_2679418Icon.vue";
import Project_408557Icon from "@/assets/downloaded/Project_408557Icon.vue";
import Project_5956597Icon from "@/assets/downloaded/Project_5956597Icon.vue";
import Project_management_1087927Icon from "@/assets/downloaded/Project_management_1087927Icon.vue";
import Project_management_3286703Icon from "@/assets/downloaded/Project_management_3286703Icon.vue";
import Project_management_4946385Icon from "@/assets/downloaded/Project_management_4946385Icon.vue";
import Project_status_10934173Icon from "@/assets/downloaded/Project_status_10934173Icon.vue";
import Promotional_items_16879606Icon from "@/assets/downloaded/Promotional_items_16879606Icon.vue";
import Property_2243704Icon from "@/assets/downloaded/Property_2243704Icon.vue";
import Property_6140354Icon from "@/assets/downloaded/Property_6140354Icon.vue";
import Property_document_13390614Icon from "@/assets/downloaded/Property_document_13390614Icon.vue";
import Protected_2058324Icon from "@/assets/downloaded/Protected_2058324Icon.vue";
import Public_service_9747033Icon from "@/assets/downloaded/Public_service_9747033Icon.vue";
import Public_toilet_3289742Icon from "@/assets/downloaded/Public_toilet_3289742Icon.vue";
import Purchase_order_12341403Icon from "@/assets/downloaded/Purchase_order_12341403Icon.vue";
import Quality_10498248Icon from "@/assets/downloaded/Quality_10498248Icon.vue";
import Quality_control_4374854Icon from "@/assets/downloaded/Quality_control_4374854Icon.vue";
import Quality_control_4862471Icon from "@/assets/downloaded/Quality_control_4862471Icon.vue";
import Quality_control_9789613Icon from "@/assets/downloaded/Quality_control_9789613Icon.vue";
import Question_12544380Icon from "@/assets/downloaded/Question_12544380Icon.vue";
import Question_1746624Icon from "@/assets/downloaded/Question_1746624Icon.vue";
import Question_3156280Icon from "@/assets/downloaded/Question_3156280Icon.vue";
import Queue_11220153Icon from "@/assets/downloaded/Queue_11220153Icon.vue";
import Quotation_4388366Icon from "@/assets/downloaded/Quotation_4388366Icon.vue";
import Quote_16134577Icon from "@/assets/downloaded/Quote_16134577Icon.vue";
import Quote_request_7024144Icon from "@/assets/downloaded/Quote_request_7024144Icon.vue";
import Radiology_15192747Icon from "@/assets/downloaded/Radiology_15192747Icon.vue";
import Ranking_3162263Icon from "@/assets/downloaded/Ranking_3162263Icon.vue";
import Rating_1322236Icon from "@/assets/downloaded/Rating_1322236Icon.vue";
import Raw_materials_12981797Icon from "@/assets/downloaded/Raw_materials_12981797Icon.vue";
import Real_estate_9116574Icon from "@/assets/downloaded/Real_estate_9116574Icon.vue";
import Real_estate_agent_6333471Icon from "@/assets/downloaded/Real_estate_agent_6333471Icon.vue";
import Real_time_3043540Icon from "@/assets/downloaded/Real_time_3043540Icon.vue";
import Receipt_11153374Icon from "@/assets/downloaded/Receipt_11153374Icon.vue";
import Receipt_1554608Icon from "@/assets/downloaded/Receipt_1554608Icon.vue";
import Receipt_869698Icon from "@/assets/downloaded/Receipt_869698Icon.vue";
import Receipt_9069344Icon from "@/assets/downloaded/Receipt_9069344Icon.vue";
import Receipt_9328666Icon from "@/assets/downloaded/Receipt_9328666Icon.vue";
import Received_4536732Icon from "@/assets/downloaded/Received_4536732Icon.vue";
import Receptionist_17625282Icon from "@/assets/downloaded/Receptionist_17625282Icon.vue";
import Recipe_3802177Icon from "@/assets/downloaded/Recipe_3802177Icon.vue";
import Referral_18841524Icon from "@/assets/downloaded/Referral_18841524Icon.vue";
import Refinance_13659814Icon from "@/assets/downloaded/Refinance_13659814Icon.vue";
import Refresh_2546743Icon from "@/assets/downloaded/Refresh_2546743Icon.vue";
import Refund_2366081Icon from "@/assets/downloaded/Refund_2366081Icon.vue";
import Register_17814618Icon from "@/assets/downloaded/Register_17814618Icon.vue";
import Registration_certificate_14001395Icon from "@/assets/downloaded/Registration_certificate_14001395Icon.vue";
import Regulation_11210307Icon from "@/assets/downloaded/Regulation_11210307Icon.vue";
import Regulation_13061404Icon from "@/assets/downloaded/Regulation_13061404Icon.vue";
import Regulation_9926191Icon from "@/assets/downloaded/Regulation_9926191Icon.vue";
import Regulatory_12245250Icon from "@/assets/downloaded/Regulatory_12245250Icon.vue";
import Relax_3063783Icon from "@/assets/downloaded/Relax_3063783Icon.vue";
import Remove_file_3686931Icon from "@/assets/downloaded/Remove_file_3686931Icon.vue";
import Renewal_12003696Icon from "@/assets/downloaded/Renewal_12003696Icon.vue";
import Renewal_18564395Icon from "@/assets/downloaded/Renewal_18564395Icon.vue";
import Renewal_18564409Icon from "@/assets/downloaded/Renewal_18564409Icon.vue";
import Rent_2590451Icon from "@/assets/downloaded/Rent_2590451Icon.vue";
import Rent_4820436Icon from "@/assets/downloaded/Rent_4820436Icon.vue";
import Reporting_13089755Icon from "@/assets/downloaded/Reporting_13089755Icon.vue";
import Reports_12727897Icon from "@/assets/downloaded/Reports_12727897Icon.vue";
import Report_14323490Icon from "@/assets/downloaded/Report_14323490Icon.vue";
import Report_1450932Icon from "@/assets/downloaded/Report_1450932Icon.vue";
import Report_16773533Icon from "@/assets/downloaded/Report_16773533Icon.vue";
import Report_3875734Icon from "@/assets/downloaded/Report_3875734Icon.vue";
import Report_5656296Icon from "@/assets/downloaded/Report_5656296Icon.vue";
import Report_6199776Icon from "@/assets/downloaded/Report_6199776Icon.vue";
import Report_6345343Icon from "@/assets/downloaded/Report_6345343Icon.vue";
import Report_9504986Icon from "@/assets/downloaded/Report_9504986Icon.vue";
import Report_card_13334856Icon from "@/assets/downloaded/Report_card_13334856Icon.vue";
import Report_card_3819810Icon from "@/assets/downloaded/Report_card_3819810Icon.vue";
import Request_18857268Icon from "@/assets/downloaded/Request_18857268Icon.vue";
import Request_2117251Icon from "@/assets/downloaded/Request_2117251Icon.vue";
import Request_for_proposal_11000717Icon from "@/assets/downloaded/Request_for_proposal_11000717Icon.vue";
import Request_for_proposal_12321839Icon from "@/assets/downloaded/Request_for_proposal_12321839Icon.vue";
import Requirement_10326046Icon from "@/assets/downloaded/Requirement_10326046Icon.vue";
import Requirement_12048812Icon from "@/assets/downloaded/Requirement_12048812Icon.vue";
import Requisition_17235067Icon from "@/assets/downloaded/Requisition_17235067Icon.vue";
import Research_9419215Icon from "@/assets/downloaded/Research_9419215Icon.vue";
import Residential_13519264Icon from "@/assets/downloaded/Residential_13519264Icon.vue";
import Resignation_10436019Icon from "@/assets/downloaded/Resignation_10436019Icon.vue";
import Resignation_7376570Icon from "@/assets/downloaded/Resignation_7376570Icon.vue";
import Resource_allocation_13728428Icon from "@/assets/downloaded/Resource_allocation_13728428Icon.vue";
import Responsibility_10172476Icon from "@/assets/downloaded/Responsibility_10172476Icon.vue";
import Restaurant_3208003Icon from "@/assets/downloaded/Restaurant_3208003Icon.vue";
import Restaurant_561382Icon from "@/assets/downloaded/Restaurant_561382Icon.vue";
import Return_11722917Icon from "@/assets/downloaded/Return_11722917Icon.vue";
import Return_16117131Icon from "@/assets/downloaded/Return_16117131Icon.vue";
import Return_1671017Icon from "@/assets/downloaded/Return_1671017Icon.vue";
import Return_2801689Icon from "@/assets/downloaded/Return_2801689Icon.vue";
import Return_9252729Icon from "@/assets/downloaded/Return_9252729Icon.vue";
import Return_box_5469919Icon from "@/assets/downloaded/Return_box_5469919Icon.vue";
import Reverse_logistics_18248683Icon from "@/assets/downloaded/Reverse_logistics_18248683Icon.vue";
import Review_3168622Icon from "@/assets/downloaded/Review_3168622Icon.vue";
import Revision_18857103Icon from "@/assets/downloaded/Revision_18857103Icon.vue";
import Rewards_6062118Icon from "@/assets/downloaded/Rewards_6062118Icon.vue";
import Rfq_18564043Icon from "@/assets/downloaded/Rfq_18564043Icon.vue";
import Risk_12315850Icon from "@/assets/downloaded/Risk_12315850Icon.vue";
import Room_489874Icon from "@/assets/downloaded/Room_489874Icon.vue";
import Room_service_3575841Icon from "@/assets/downloaded/Room_service_3575841Icon.vue";
import Round_16199578Icon from "@/assets/downloaded/Round_16199578Icon.vue";
import Route_15546556Icon from "@/assets/downloaded/Route_15546556Icon.vue";
import Route_3061732Icon from "@/assets/downloaded/Route_3061732Icon.vue";
import Ruler_18994252Icon from "@/assets/downloaded/Ruler_18994252Icon.vue";
import Rules_2046915Icon from "@/assets/downloaded/Rules_2046915Icon.vue";
import Running_repair_man_with_wrench_and_kit_25559Icon from "@/assets/downloaded/Running_repair_man_with_wrench_and_kit_25559Icon.vue";
import Sacrifice_15942674Icon from "@/assets/downloaded/Sacrifice_15942674Icon.vue";
import Safe_2208007Icon from "@/assets/downloaded/Safe_2208007Icon.vue";
import Safe_box_2676779Icon from "@/assets/downloaded/Safe_box_2676779Icon.vue";
import Salary_13441695Icon from "@/assets/downloaded/Salary_13441695Icon.vue";
import Salary_1672164Icon from "@/assets/downloaded/Salary_1672164Icon.vue";
import Salary_18566499Icon from "@/assets/downloaded/Salary_18566499Icon.vue";
import Sale_5959799Icon from "@/assets/downloaded/Sale_5959799Icon.vue";
import Sale_8480947Icon from "@/assets/downloaded/Sale_8480947Icon.vue";
import Save_money_1611179Icon from "@/assets/downloaded/Save_money_1611179Icon.vue";
import Saving_11915929Icon from "@/assets/downloaded/Saving_11915929Icon.vue";
import Scale_16182041Icon from "@/assets/downloaded/Scale_16182041Icon.vue";
import Schedule_3107295Icon from "@/assets/downloaded/Schedule_3107295Icon.vue";
import Schedule_3215495Icon from "@/assets/downloaded/Schedule_3215495Icon.vue";
import Schedule_8718753Icon from "@/assets/downloaded/Schedule_8718753Icon.vue";
import Schedule_9375984Icon from "@/assets/downloaded/Schedule_9375984Icon.vue";
import Schedule_9640755Icon from "@/assets/downloaded/Schedule_9640755Icon.vue";
import School_2602412Icon from "@/assets/downloaded/School_2602412Icon.vue";
import School_4710565Icon from "@/assets/downloaded/School_4710565Icon.vue";
import School_bus_3471534Icon from "@/assets/downloaded/School_bus_3471534Icon.vue";
import Search_2820167Icon from "@/assets/downloaded/Search_2820167Icon.vue";
import Season_4360322Icon from "@/assets/downloaded/Season_4360322Icon.vue";
import Seating_area_18868370Icon from "@/assets/downloaded/Seating_area_18868370Icon.vue";
import Secure_9461347Icon from "@/assets/downloaded/Secure_9461347Icon.vue";
import Security_10235668Icon from "@/assets/downloaded/Security_10235668Icon.vue";
import Security_17404290Icon from "@/assets/downloaded/Security_17404290Icon.vue";
import Security_2058432Icon from "@/assets/downloaded/Security_2058432Icon.vue";
import Sedan_2736918Icon from "@/assets/downloaded/Sedan_2736918Icon.vue";
import Send_18857153Icon from "@/assets/downloaded/Send_18857153Icon.vue";
import Send_file_6601155Icon from "@/assets/downloaded/Send_file_6601155Icon.vue";
import Services_11671609Icon from "@/assets/downloaded/Services_11671609Icon.vue";
import Services_12003833Icon from "@/assets/downloaded/Services_12003833Icon.vue";
import Services_14784839Icon from "@/assets/downloaded/Services_14784839Icon.vue";
import Service_1649375Icon from "@/assets/downloaded/Service_1649375Icon.vue";
import Service_4692103Icon from "@/assets/downloaded/Service_4692103Icon.vue";
import Service_center_1698510Icon from "@/assets/downloaded/Service_center_1698510Icon.vue";
import Service_station_7600849Icon from "@/assets/downloaded/Service_station_7600849Icon.vue";
import Settings_15477908Icon from "@/assets/downloaded/Settings_15477908Icon.vue";
import Settings_2099058Icon from "@/assets/downloaded/Settings_2099058Icon.vue";
import Settings_6057870Icon from "@/assets/downloaded/Settings_6057870Icon.vue";
import Setting_1787641Icon from "@/assets/downloaded/Setting_1787641Icon.vue";
import Setting_3210045Icon from "@/assets/downloaded/Setting_3210045Icon.vue";
import Setting_5470294Icon from "@/assets/downloaded/Setting_5470294Icon.vue";
import Shared_folder_1045537Icon from "@/assets/downloaded/Shared_folder_1045537Icon.vue";
import Shelf_3396325Icon from "@/assets/downloaded/Shelf_3396325Icon.vue";
import Shift_5538633Icon from "@/assets/downloaded/Shift_5538633Icon.vue";
import Shift_5539726Icon from "@/assets/downloaded/Shift_5539726Icon.vue";
import Shipped_411763Icon from "@/assets/downloaded/Shipped_411763Icon.vue";
import Shipping_11153410Icon from "@/assets/downloaded/Shipping_11153410Icon.vue";
import Shipping_18532922Icon from "@/assets/downloaded/Shipping_18532922Icon.vue";
import Shipping_cost_11000652Icon from "@/assets/downloaded/Shipping_cost_11000652Icon.vue";
import Shipping_location_17573458Icon from "@/assets/downloaded/Shipping_location_17573458Icon.vue";
import Ship_2485084Icon from "@/assets/downloaded/Ship_2485084Icon.vue";
import Shopping_13630745Icon from "@/assets/downloaded/Shopping_13630745Icon.vue";
import Shopping_4183908Icon from "@/assets/downloaded/Shopping_4183908Icon.vue";
import Shortcut_9784396Icon from "@/assets/downloaded/Shortcut_9784396Icon.vue";
import Signing_3130444Icon from "@/assets/downloaded/Signing_3130444Icon.vue";
import Six_4626510Icon from "@/assets/downloaded/Six_4626510Icon.vue";
import Skill_development_9953680Icon from "@/assets/downloaded/Skill_development_9953680Icon.vue";
import Sla_17064924Icon from "@/assets/downloaded/Sla_17064924Icon.vue";
import Sleep_11117712Icon from "@/assets/downloaded/Sleep_11117712Icon.vue";
import Slot_machine_3076839Icon from "@/assets/downloaded/Slot_machine_3076839Icon.vue";
import Smartphone_18462159Icon from "@/assets/downloaded/Smartphone_18462159Icon.vue";
import Smart_temperature_7882983Icon from "@/assets/downloaded/Smart_temperature_7882983Icon.vue";
import Smelting_14400846Icon from "@/assets/downloaded/Smelting_14400846Icon.vue";
import Snowflake_5795206Icon from "@/assets/downloaded/Snowflake_5795206Icon.vue";
import Sorting_18771472Icon from "@/assets/downloaded/Sorting_18771472Icon.vue";
import Specification_6207279Icon from "@/assets/downloaded/Specification_6207279Icon.vue";
import Split_1541211Icon from "@/assets/downloaded/Split_1541211Icon.vue";
import Sponsorship_17788130Icon from "@/assets/downloaded/Sponsorship_17788130Icon.vue";
import Sponsorship_18824056Icon from "@/assets/downloaded/Sponsorship_18824056Icon.vue";
import Square_11287293Icon from "@/assets/downloaded/Square_11287293Icon.vue";
import Stacks_12305887Icon from "@/assets/downloaded/Stacks_12305887Icon.vue";
import Standards_18575239Icon from "@/assets/downloaded/Standards_18575239Icon.vue";
import Standard_8439144Icon from "@/assets/downloaded/Standard_8439144Icon.vue";
import Standard_operating_procedures_16985619Icon from "@/assets/downloaded/Standard_operating_procedures_16985619Icon.vue";
import Stand_3306951Icon from "@/assets/downloaded/Stand_3306951Icon.vue";
import Status_8917343Icon from "@/assets/downloaded/Status_8917343Icon.vue";
import Stock_6902435Icon from "@/assets/downloaded/Stock_6902435Icon.vue";
import Stock_keeping_unit_12141504Icon from "@/assets/downloaded/Stock_keeping_unit_12141504Icon.vue";
import Stop_3178618Icon from "@/assets/downloaded/Stop_3178618Icon.vue";
import Storage_2728486Icon from "@/assets/downloaded/Storage_2728486Icon.vue";
import Storage_6015470Icon from "@/assets/downloaded/Storage_6015470Icon.vue";
import Storyboard_12577375Icon from "@/assets/downloaded/Storyboard_12577375Icon.vue";
import Strategy_planning_16743863Icon from "@/assets/downloaded/Strategy_planning_16743863Icon.vue";
import Student_8892896Icon from "@/assets/downloaded/Student_8892896Icon.vue";
import Subcontracting_14458891Icon from "@/assets/downloaded/Subcontracting_14458891Icon.vue";
import Subscribe_5671858Icon from "@/assets/downloaded/Subscribe_5671858Icon.vue";
import Sub_8835627Icon from "@/assets/downloaded/Sub_8835627Icon.vue";
import Suggestion_2593658Icon from "@/assets/downloaded/Suggestion_2593658Icon.vue";
import Supplier_12321920Icon from "@/assets/downloaded/Supplier_12321920Icon.vue";
import Supplier_8071262Icon from "@/assets/downloaded/Supplier_8071262Icon.vue";
import Supply_chain_4813885Icon from "@/assets/downloaded/Supply_chain_4813885Icon.vue";
import Surgeon_7031573Icon from "@/assets/downloaded/Surgeon_7031573Icon.vue";
import Surgery_room_4006097Icon from "@/assets/downloaded/Surgery_room_4006097Icon.vue";
import Survey_10930719Icon from "@/assets/downloaded/Survey_10930719Icon.vue";
import Sync_data_16856249Icon from "@/assets/downloaded/Sync_data_16856249Icon.vue";
import System_16454641Icon from "@/assets/downloaded/System_16454641Icon.vue";
import Talent_15595789Icon from "@/assets/downloaded/Talent_15595789Icon.vue";
import Tape_measure_2739200Icon from "@/assets/downloaded/Tape_measure_2739200Icon.vue";
import Tariff_14104983Icon from "@/assets/downloaded/Tariff_14104983Icon.vue";
import Task_18312178Icon from "@/assets/downloaded/Task_18312178Icon.vue";
import Task_2098313Icon from "@/assets/downloaded/Task_2098313Icon.vue";
import Task_3774569Icon from "@/assets/downloaded/Task_3774569Icon.vue";
import Task_actions_18988010Icon from "@/assets/downloaded/Task_actions_18988010Icon.vue";
import Task_complete_17377933Icon from "@/assets/downloaded/Task_complete_17377933Icon.vue";
import Task_list_2029830Icon from "@/assets/downloaded/Task_list_2029830Icon.vue";
import Task_management_15762588Icon from "@/assets/downloaded/Task_management_15762588Icon.vue";
import Taxation_17756286Icon from "@/assets/downloaded/Taxation_17756286Icon.vue";
import Taxes_4749988Icon from "@/assets/downloaded/Taxes_4749988Icon.vue";
import Team_11049551Icon from "@/assets/downloaded/Team_11049551Icon.vue";
import Team_13483396Icon from "@/assets/downloaded/Team_13483396Icon.vue";
import Team_management_8840707Icon from "@/assets/downloaded/Team_management_8840707Icon.vue";
import Technical_support_4230997Icon from "@/assets/downloaded/Technical_support_4230997Icon.vue";
import Technician_9922689Icon from "@/assets/downloaded/Technician_9922689Icon.vue";
import Temperature_1872808Icon from "@/assets/downloaded/Temperature_1872808Icon.vue";
import Temperature_8775923Icon from "@/assets/downloaded/Temperature_8775923Icon.vue";
import Templates_559907Icon from "@/assets/downloaded/Templates_559907Icon.vue";
import Tender_17148344Icon from "@/assets/downloaded/Tender_17148344Icon.vue";
import Tender_18699187Icon from "@/assets/downloaded/Tender_18699187Icon.vue";
import Terms_11582779Icon from "@/assets/downloaded/Terms_11582779Icon.vue";
import Terms_and_conditions_16331104Icon from "@/assets/downloaded/Terms_and_conditions_16331104Icon.vue";
import Terms_and_conditions_4436515Icon from "@/assets/downloaded/Terms_and_conditions_4436515Icon.vue";
import Test_2916315Icon from "@/assets/downloaded/Test_2916315Icon.vue";
import Test_3204284Icon from "@/assets/downloaded/Test_3204284Icon.vue";
import Test_results_15756461Icon from "@/assets/downloaded/Test_results_15756461Icon.vue";
import Test_tube_3373616Icon from "@/assets/downloaded/Test_tube_3373616Icon.vue";
import Text_11024126Icon from "@/assets/downloaded/Text_11024126Icon.vue";
import Text_analytics_16137864Icon from "@/assets/downloaded/Text_analytics_16137864Icon.vue";
import Theme_10134298Icon from "@/assets/downloaded/Theme_10134298Icon.vue";
import Three_4626487Icon from "@/assets/downloaded/Three_4626487Icon.vue";
import Ticket_6977799Icon from "@/assets/downloaded/Ticket_6977799Icon.vue";
import Time_3064481Icon from "@/assets/downloaded/Time_3064481Icon.vue";
import Time_is_money_6404725Icon from "@/assets/downloaded/Time_is_money_6404725Icon.vue";
import Time_management_11862147Icon from "@/assets/downloaded/Time_management_11862147Icon.vue";
import Time_sheet_4388165Icon from "@/assets/downloaded/Time_sheet_4388165Icon.vue";
import Toolkit_4228902Icon from "@/assets/downloaded/Toolkit_4228902Icon.vue";
import Tool_2760119Icon from "@/assets/downloaded/Tool_2760119Icon.vue";
import Top_up_6379125Icon from "@/assets/downloaded/Top_up_6379125Icon.vue";
import Tourism_2560124Icon from "@/assets/downloaded/Tourism_2560124Icon.vue";
import Tour_guide_3284377Icon from "@/assets/downloaded/Tour_guide_3284377Icon.vue";
import Tour_guide_9636012Icon from "@/assets/downloaded/Tour_guide_9636012Icon.vue";
import To_do_list_18645372Icon from "@/assets/downloaded/To_do_list_18645372Icon.vue";
import To_do_list_3647695Icon from "@/assets/downloaded/To_do_list_3647695Icon.vue";
import Track_4974331Icon from "@/assets/downloaded/Track_4974331Icon.vue";
import Track_delivery_12624957Icon from "@/assets/downloaded/Track_delivery_12624957Icon.vue";
import Training_12650217Icon from "@/assets/downloaded/Training_12650217Icon.vue";
import Transactional_data_18253441Icon from "@/assets/downloaded/Transactional_data_18253441Icon.vue";
import Transaction_11826754Icon from "@/assets/downloaded/Transaction_11826754Icon.vue";
import Transfer_2818813Icon from "@/assets/downloaded/Transfer_2818813Icon.vue";
import Transfer_757515Icon from "@/assets/downloaded/Transfer_757515Icon.vue";
import Translation_2793765Icon from "@/assets/downloaded/Translation_2793765Icon.vue";
import Transport_15841669Icon from "@/assets/downloaded/Transport_15841669Icon.vue";
import Travel_3376684Icon from "@/assets/downloaded/Travel_3376684Icon.vue";
import Travel_agency_4586974Icon from "@/assets/downloaded/Travel_agency_4586974Icon.vue";
import Trolley_4664272Icon from "@/assets/downloaded/Trolley_4664272Icon.vue";
import Troubleshooting_18643300Icon from "@/assets/downloaded/Troubleshooting_18643300Icon.vue";
import Trustworthiness_12772408Icon from "@/assets/downloaded/Trustworthiness_12772408Icon.vue";
import Two_4626479Icon from "@/assets/downloaded/Two_4626479Icon.vue";
import Typography_14282875Icon from "@/assets/downloaded/Typography_14282875Icon.vue";
import Unsecured_8900232Icon from "@/assets/downloaded/Unsecured_8900232Icon.vue";
import Update_4059752Icon from "@/assets/downloaded/Update_4059752Icon.vue";
import Update_4067725Icon from "@/assets/downloaded/Update_4067725Icon.vue";
import Update_7159542Icon from "@/assets/downloaded/Update_7159542Icon.vue";
import Update_list_14752951Icon from "@/assets/downloaded/Update_list_14752951Icon.vue";
import Updating_2990003Icon from "@/assets/downloaded/Updating_2990003Icon.vue";
import Usability_12465756Icon from "@/assets/downloaded/Usability_12465756Icon.vue";
import User_1515713Icon from "@/assets/downloaded/User_1515713Icon.vue";
import User_456283Icon from "@/assets/downloaded/User_456283Icon.vue";
import User_favourite_17123247Icon from "@/assets/downloaded/User_favourite_17123247Icon.vue";
import Vacancy_4288089Icon from "@/assets/downloaded/Vacancy_4288089Icon.vue";
import Vacation_10403845Icon from "@/assets/downloaded/Vacation_10403845Icon.vue";
import Vacation_16984394Icon from "@/assets/downloaded/Vacation_16984394Icon.vue";
import Vacation_18238495Icon from "@/assets/downloaded/Vacation_18238495Icon.vue";
import Vacation_18747738Icon from "@/assets/downloaded/Vacation_18747738Icon.vue";
import Validating_ticket_7377200Icon from "@/assets/downloaded/Validating_ticket_7377200Icon.vue";
import Value_1528669Icon from "@/assets/downloaded/Value_1528669Icon.vue";
import Variant_12062492Icon from "@/assets/downloaded/Variant_12062492Icon.vue";
import Vehicle_12359514Icon from "@/assets/downloaded/Vehicle_12359514Icon.vue";
import Vehicle_12359527Icon from "@/assets/downloaded/Vehicle_12359527Icon.vue";
import Venture_7261828Icon from "@/assets/downloaded/Venture_7261828Icon.vue";
import Visa_15916931Icon from "@/assets/downloaded/Visa_15916931Icon.vue";
import Vision_14014408Icon from "@/assets/downloaded/Vision_14014408Icon.vue";
import Visitor_753114Icon from "@/assets/downloaded/Visitor_753114Icon.vue";
import Visit_16841242Icon from "@/assets/downloaded/Visit_16841242Icon.vue";
import Voltage_indicator_12191265Icon from "@/assets/downloaded/Voltage_indicator_12191265Icon.vue";
import Voucher_13280369Icon from "@/assets/downloaded/Voucher_13280369Icon.vue";
import Voucher_481387Icon from "@/assets/downloaded/Voucher_481387Icon.vue";
import Voucher_7183794Icon from "@/assets/downloaded/Voucher_7183794Icon.vue";
import Waiting_list_11209494Icon from "@/assets/downloaded/Waiting_list_11209494Icon.vue";
import Wallet_1198393Icon from "@/assets/downloaded/Wallet_1198393Icon.vue";
import Warehouse_10638567Icon from "@/assets/downloaded/Warehouse_10638567Icon.vue";
import Warehouse_702455Icon from "@/assets/downloaded/Warehouse_702455Icon.vue";
import Warehouse_9597872Icon from "@/assets/downloaded/Warehouse_9597872Icon.vue";
import Warning_159469Icon from "@/assets/downloaded/Warning_159469Icon.vue";
import Warranty_card_16868866Icon from "@/assets/downloaded/Warranty_card_16868866Icon.vue";
import Weighing_machine_2929016Icon from "@/assets/downloaded/Weighing_machine_2929016Icon.vue";
import Weight_15169691Icon from "@/assets/downloaded/Weight_15169691Icon.vue";
import Whatsapp_2582600Icon from "@/assets/downloaded/Whatsapp_2582600Icon.vue";
import Worker_782899Icon from "@/assets/downloaded/Worker_782899Icon.vue";
import Worker_9936521Icon from "@/assets/downloaded/Worker_9936521Icon.vue";
import Workflow_5365050Icon from "@/assets/downloaded/Workflow_5365050Icon.vue";
import Workflow_8317775Icon from "@/assets/downloaded/Workflow_8317775Icon.vue";
import Working_hours_18103931Icon from "@/assets/downloaded/Working_hours_18103931Icon.vue";
import Working_time_7626204Icon from "@/assets/downloaded/Working_time_7626204Icon.vue";
import Workspace_9787259Icon from "@/assets/downloaded/Workspace_9787259Icon.vue";
import Work_plan_12422852Icon from "@/assets/downloaded/Work_plan_12422852Icon.vue";
import World_10690961Icon from "@/assets/downloaded/World_10690961Icon.vue";
import Write_13785332Icon from "@/assets/downloaded/Write_13785332Icon.vue";
import Write_14944972Icon from "@/assets/downloaded/Write_14944972Icon.vue";
import Writing_15889631Icon from "@/assets/downloaded/Writing_15889631Icon.vue";
import X_rays_10160241Icon from "@/assets/downloaded/X_rays_10160241Icon.vue";
import EyeCheckIcon from "@/assets/editViewIcons/EyeCheckIcon.vue";
import ArowFitHeightIcon from "@/assets/editViewIcons/ArowFitHeightIcon.vue";
import AdjustmentsIcon from "@/assets/editViewIcons/AdjustmentsIcon.vue";
import AddImageIcon from "@/assets/editViewIcons/AddImageIcon.vue";

export const icons = {
  "nm-accounting": AccountingIcon,
  "nm-accounting-revenue": AccountingRevenueIcon,
  "nm-actions": ActionsIcon,
  "nm-add-comment": AddCommentIcon,
  "nm-add-day": AddDayIcon,
  "nm-add-grid": AddGridIcon,
  "nm-add-groups": AddGroupsIcon,
  "nm-add": AddIcon,
  "nm-add-page": AddPageIcon,
  "nm-administration": AdministrationIcon,
  "nm-api": ApiIcon,
  "nm-app-store": AppStoreIcon,
  "nm-assembly-docs": AssemblyDocsIcon,
  "nm-assets": AssetsIcon,
  "nm-auditing": AuditingIcon,
  "nm-balance": BalanceIcon,
  "nm-bank-l-c": BankLCIcon,
  "nm-bank-loans": BankLoansIcon,
  "nm-banks": BanksIcon,
  "nm-basic": BasicIcon,
  "nm-basic-information": BasicInformationIcon,
  "nm-blocks": BlocksIcon,
  "nm-blood-banks": BloodBanksIcon,
  "nm-budgets": BudgetsIcon,
  "nm-cache": CacheIcon,
  "nm-capabilities": CapabilitiesIcon,
  "nm-car-insurance": CarInsuranceIcon,
  "nm-cartoon": CartoonIcon,
  "nm-cashier": CashierIcon,
  "nm-cashiers": CashiersIcon,
  "nm-charge-invoice": ChargeInvoiceIcon,
  "nm-check-box": CheckBoxIcon,
  "nm-check-circle": CheckCircleIcon,
  "nm-check": CheckIcon,
  "nm-cheques": ChequesIcon,
  "nm-chief": ChiefIcon,
  "nm-circulars": CircularsIcon,
  "nm-clipboard-check": ClipboardCheckIcon,
  "nm-closing-invoice": ClosingInvoiceIcon,
  "nm-code": CodeIcon,
  "nm-columns": ColumnsIcon,
  "nm-compact": CompactIcon,
  "nm-compare": CompareIcon,
  "nm-component": ComponentIcon,
  "nm-composite": CompositeIcon,
  "nm-contracting": ContractingIcon,
  "nm-contractor-contracting": ContractorContractingIcon,
  "nm-conveyor": ConveyorIcon,
  "nm-copy": CopyIcon,
  "nm-copy-to-clipboard": CopyToClipboardIcon,
  "nm-cost": CostIcon,
  "nm-costs": CostsIcon,
  "nm-create-documents": CreateDocumentsIcon,
  "nm-create": CreateIcon,
  "nm-create-report": CreateReportIcon,
  "nm-credit-facilities": CreditFacilitiesIcon,
  "nm-criteria": CriteriaIcon,
  "nm-crm-dashboard": CrmDashboardIcon,
  "nm-crm": CrmIcon,
  "nm-custody-of-assets": CustodyOfAssetsIcon,
  "nm-custodys": CustodysIcon,
  "nm-customers": CustomersIcon,
  "nm-dark-mode": DarkModeIcon,
  "nm-dashboards": DashboardsIcon,
  "nm-data-model": DataModelIcon,
  "nm-definitions": DefinitionsIcon,
  "nm-delivery-setting": DeliverySettingIcon,
  "nm-detail-accounts": DetailAccountsIcon,
  "nm-dimensions": DimensionsIcon,
  "nm-discard": DiscardIcon,
  "nm-discussion": DiscussionIcon,
  "nm-displayed-columns": DisplayedColumnsIcon,
  "nm-dms-location": DmsLocationIcon,
  "nm-document": DocumentIcon,
  "nm-document-management": DocumentManagementIcon,
  "nm-document-management-system": DocumentManagementSystemIcon,
  "nm-document-revision": DocumentRevisionIcon,
  "nm-documents": DocumentsIcon,
  "nm-download": DownloadIcon,
  "nm-drag": DragIcon,
  "nm-drag-row-indicator": DragRowIndicatorIcon,
  "nm-dues-liquidation-and-firing": DuesLiquidationAndFiringIcon,
  "nm-ecommerce": EcommerceIcon,
  "nm-ecpa": EcpaIcon,
  "nm-edit-screen": EditScreenIcon,
  "nm-education": EducationIcon,
  "nm-error": ErrorIcon,
  "nm-expense": ExpenseIcon,
  "nm-export-all": ExportAllIcon,
  "nm-export-group": ExportGroupIcon,
  "nm-export": ExportIcon,
  "nm-export-option": ExportOptionIcon,
  "nm-export-page": ExportPageIcon,
  "nm-favourites": FavouritesIcon,
  "nm-favourites-minus": FavouritesMinusIcon,
  "nm-favourites-plus": FavouritesPlusIcon,
  "nm-feeding": FeedingIcon,
  "nm-fields": FieldsIcon,
  "nm-fill": FillIcon,
  "nm-financial-commitment-management": FinancialCommitmentManagementIcon,
  "nm-financial": FinancialIcon,
  "nm-financial-statement": FinancialStatementIcon,
  "nm-fines": FinesIcon,
  "nm-fixed-asset-letter-of-credit": FixedAssetLetterOfCreditIcon,
  "nm-fixed-asset-maintenance": FixedAssetMaintenanceIcon,
  "nm-fixed-assets": FixedAssetsIcon,
  "nm-fixed-deposits": FixedDepositsIcon,
  "nm-focus": FocusIcon,
  "nm-folder": FolderIcon,
  "nm-folders": FoldersIcon,
  "nm-freight-management-system": FreightManagementSystemIcon,
  "nm-google-play": GooglePlayIcon,
  "nm-grid": GridIcon,
  "nm-group": GroupIcon,
  "nm-health-insurance": HealthInsuranceIcon,
  "nm-home": HomeIcon,
  "nm-horizontal": HorizontalIcon,
  "nm-hospital-management-system": HospitalManagementSystemIcon,
  "nm-hospital-structure": HospitalStructureIcon,
  "nm-housing-documents": HousingDocumentsIcon,
  "nm-housing-files": HousingFilesIcon,
  "nm-housing": HousingIcon,
  "nm-human-resource": HumanResourceIcon,
  "nm-import": ImportIcon,
  "nm-information": InformationIcon,
  "nm-input": InputIcon,
  "nm-internal-link": InternalLinkIcon,
  "nm-inventory": InventoryIcon,
  "nm-inventory-management": InventoryManagementIcon,
  "nm-investment-docs": InvestmentDocsIcon,
  "nm-investment-documents": InvestmentDocumentsIcon,
  "nm-investment": InvestmentIcon,
  "nm-investment-portfolios": InvestmentPortfoliosIcon,
  "nm-invoice": InvoiceIcon,
  "nm-iso": IsoIcon,
  "nm-issue-documents": IssueDocumentsIcon,
  "nm-item-voting": ItemVotingIcon,
  "nm-job-orders": JobOrdersIcon,
  "nm-lab": LabIcon,
  "nm-laboratory-tests": LaboratoryTestsIcon,
  "nm-laws": LawsIcon,
  "nm-layout": LayoutIcon,
  "nm-letter-of-credit": LetterOfCreditIcon,
  "nm-letter-of-guarantees": LetterOfGuaranteesIcon,
  "nm-list-plus": ListPlusIcon,
  "nm-list-vew": ListVewIcon,
  "nm-loans-and-installments": LoansAndInstallmentsIcon,
  "nm-log-files": LogFilesIcon,
  "nm-logout": LogoutIcon,
  "nm-main-files": MainFilesIcon,
  "nm-main": MainIcon,
  "nm-maintenance-contracting": MaintenanceContractingIcon,
  "nm-maintenance-documents": MaintenanceDocumentsIcon,
  "nm-maintenance-files": MaintenanceFilesIcon,
  "nm-maintenance": MaintenanceIcon,
  "nm-management-and-organization": ManagementAndOrganizationIcon,
  "nm-management-documents": ManagementDocumentsIcon,
  "nm-manufacturing": ManufacturingIcon,
  "nm-manufacturing-molds": ManufacturingMoldsIcon,
  "nm-marketing": MarketingIcon,
  "nm-master-files": MasterFilesIcon,
  "nm-material-resource-planning": MaterialResourcePlanningIcon,
  "nm-meals": MealsIcon,
  "nm-medical-overhead": MedicalOverheadIcon,
  "nm-medical-services": MedicalServicesIcon,
  "nm-meeting": MeetingIcon,
  "nm-micro": MicroIcon,
  "nm-migration": MigrationIcon,
  "nm-mini-composite": MiniCompositeIcon,
  "nm-miscellaneous": MiscellaneousIcon,
  "nm-mobile-apps": MobileAppsIcon,
  "nm-modified-blocks": ModifiedBlocksIcon,
  "nm-modified-grid": ModifiedGridIcon,
  "nm-modified-groups": ModifiedGroupsIcon,
  "nm-monitoring": MonitoringIcon,
  "nm-name": NameIcon,
  "nm-notification": NotificationIcon,
  "nm-notifications": NotificationsIcon,
  "nm-old-pc": OldPcIcon,
  "nm-other": OtherIcon,
  "nm-outsource-manufacturing": OutsourceManufacturingIcon,
  "nm-out-sourcing-orders": OutSourcingOrdersIcon,
  "nm-pages": PagesIcon,
  "nm-party-evaluations": PartyEvaluationsIcon,
  "nm-payroll": PayrollIcon,
  "nm-performance-indicators": PerformanceIndicatorsIcon,
  "nm-person": PersonIcon,
  "nm-pharmacies": PharmaciesIcon,
  "nm-physical-therapy": PhysicalTherapyIcon,
  "nm-point-of-sale": PointOfSaleIcon,
  "nm-prevent": PreventIcon,
  "nm-prevent-option": PreventOptionIcon,
  "nm-price-voting": PriceVotingIcon,
  "nm-priority": PriorityIcon,
  "nm-project-contracting": ProjectContractingIcon,
  "nm-projects": ProjectsIcon,
  "nm-property": PropertyIcon,
  "nm-purchases": PurchasesIcon,
  "nm-purge-documents": PurgeDocumentsIcon,
  "nm-quad-layout": QuadLayoutIcon,
  "nm-quality": QualityIcon,
  "nm-questionairs": QuestionairsIcon,
  "nm-question-answers": QuestionAnswersIcon,
  "nm-queue-service": QueueServiceIcon,
  "nm-radiology": RadiologyIcon,
  "nm-real-estate-and-property": RealEstateAndPropertyIcon,
  "nm-receipt-documents": ReceiptDocumentsIcon,
  "nm-reconciliations": ReconciliationsIcon,
  "nm-record": RecordIcon,
  "nm-recruitment": RecruitmentIcon,
  "nm-register": RegisterIcon,
  "nm-regulations": RegulationsIcon,
  "nm-reload": ReloadIcon,
  "nm-remarks": RemarksIcon,
  "nm-rental-assets": RentalAssetsIcon,
  "nm-rents": RentsIcon,
  "nm-report": ReportIcon,
  "nm-reports": ReportsIcon,
  "nm-reports-monitoring": ReportsMonitoringIcon,
  "nm-research-and-development": ResearchAndDevelopmentIcon,
  "nm-reservation-documents": ReservationDocumentsIcon,
  "nm-resizer": ResizerIcon,
  "nm-reward-and-penalty": RewardAndPenaltyIcon,
  "nm-salary-configurations": SalaryConfigurationsIcon,
  "nm-sales": SalesIcon,
  "nm-sales-prices-and-offers": SalesPricesAndOffersIcon,
  "nm-school-trips": SchoolTripsIcon,
  "nm-screen": ScreenIcon,
  "nm-screen-modifer": ScreenModiferIcon,
  "nm-searcher-template": SearcherTemplateIcon,
  "nm-search": SearchIcon,
  "nm-security": SecurityIcon,
  "nm-service-center": ServiceCenterIcon,
  "nm-service-documents": ServiceDocumentsIcon,
  "nm-settings": SettingsIcon,
  "nm-shipping": ShippingIcon,
  "nm-social-insurance": SocialInsuranceIcon,
  "nm-sort": SortIcon,
  "nm-sql": SqlIcon,
  "nm-stock-taking": StockTakingIcon,
  "nm-stock-trans-documents": StockTransDocumentsIcon,
  "nm-stock-transfer-docs": StockTransferDocsIcon,
  "nm-support": SupportIcon,
  "nm-surgeries": SurgeriesIcon,
  "nm-surgery-package": SurgeryPackageIcon,
  "nm-system-update": SystemUpdateIcon,
  "nm-task-execution": TaskExecutionIcon,
  "nm-task": TaskIcon,
  "nm-tasks": TasksIcon,
  "nm-tax-payer-configuration": TaxPayerConfigurationIcon,
  "nm-team": TeamIcon,
  "nm-template-columns": TemplateColumnsIcon,
  "nm-tenders": TendersIcon,
  "nm-tests": TestsIcon,
  "nm-theme-editor": ThemeEditorIcon,
  "nm-time-attendance": TimeAttendanceIcon,
  "nm-tools": ToolsIcon,
  "nm-training": TrainingIcon,
  "nm-transactions": TransactionsIcon,
  "nm-travel": TravelIcon,
  "nm-treasury-bill": TreasuryBillIcon,
  "nm-upload-invoice": UploadInvoiceIcon,
  "nm-user": UserIcon,
  "nm-vacations": VacationsIcon,
  "nm-vector": VectorIcon,
  "nm-vehicles": VehiclesIcon,
  "nm-vertical": VerticalIcon,
  "nm-view-customization": ViewCustomizationIcon,
  "nm-view": ViewIcon,
  "nm-visas": VisasIcon,
  "nm-waste-management": WasteManagementIcon,
  "nm-weight-scale": WeightScaleIcon,
  "nm-work-list": WorkListIcon,
  "nm-action-block": ActionBlockIcon,
  "nm-add-line": AddLineIcon,
  "nm-add-record": AddRecordIcon,
  "nm-approval": ApprovalIcon,
  "nm-arrow": ArrowIcon,
  "nm-ask-a-i": AskAIIcon,
  "nm-chat-history": ChatHistoryIcon,
  "nm-dash-board-block": DashBoardBlockIcon,
  "nm-delete": DeleteIcon,
  "nm-dialog-close": DialogCloseIcon,
  "nm-dislike": DislikeIcon,
  "nm-d-o-c-x": DOCXIcon,
  "nm-duplicate": DuplicateIcon,
  "nm-edit": EditIcon,
  "nm-enable-selection": EnableSelectionIcon,
  "nm-enter": EnterIcon,
  "nm-expert-mode": ExpertModeIcon,
  "nm-first": FirstIcon,
  "nm-go-to-line": GoToLineIcon,
  "nm-grid-block": GridBlockIcon,
  "nm-group-block": GroupBlockIcon,
  "nm-last": LastIcon,
  "nm-list-block": ListBlockIcon,
  "nm-list-view": ListViewIcon,
  "nm-more": MoreIcon,
  "nm-multi-copy": MultiCopyIcon,
  "nm-next": NextIcon,
  "nm-p-d-f": PDFIcon,
  "nm-p-p-t-x": PPTXIcon,
  "nm-previous": PreviousIcon,
  "nm-print-as": PrintAsIcon,
  "nm-print": PrintIcon,
  "nm-refresh": RefreshIcon,
  "nm-remove-filter": RemoveFilterIcon,
  "nm-report-block": ReportBlockIcon,
  "nm-revise": ReviseIcon,
  "nm-save-and-continue": SaveAndContinueIcon,
  "nm-save-draft": SaveDraftIcon,
  "nm-save": SaveIcon,
  "nm-send-email": SendEmailIcon,
  "nm-show-help-msgs": ShowHelpMsgsIcon,
  "nm-switch": SwitchIcon,
  "nm-timeline": TimelineIcon,
  "nm-tooltip": TooltipIcon,
  "nm-tooltip-list": TooltipListIcon,
  "nm-tree-view": TreeViewIcon,
  "nm-un-revise": UnReviseIcon,
  "nm-win-close": WinCloseIcon,
  "nm-win-maximize": WinMaximizeIcon,
  "nm-x-l-s-x": XLSXIcon,
  "nm-zoom-in": ZoomInIcon,
  "nm-zoom-out": ZoomOutIcon,
  "nm-asc-sort": AscSortIcon,
  "nm-auto-fit-col": AutoFitColIcon,
  "nm-auto-fit-col-to-content": AutoFitColToContentIcon,
  "nm-export-excel": ExportExcelIcon,
  "nm-filter": FilterIcon,
  "nm-filter-list": filterListIcon,
  "nm-table-columns": TableColumnsIcon,
  "nm-advanced-search": AdvancedSearchIcon,
  "nm-ai": AiIcon,
  "nm-approve": ApproveIcon,
  "nm-attachment": AttachmentIcon,
  "nm-auto-save": AutoSaveIcon,
  "nm-calendar": CalendarIcon,
  "nm-cancel": CancelIcon,
  "nm-chat": ChatIcon,
  "nm-clock": ClockIcon,
  "nm-color-palette": ColorPaletteIcon,
  "nm-criteria-filter": CriteriaFilterIcon,
  "nm-descending-sort": DescendingSortIcon,
  "nm-drop-down-close": DropDownCloseIcon,
  "nm-edit-text": EditTextIcon,
  "nm-email": EmailIcon,
  "nm-employee": EmployeeIcon,
  "nm-empty-search": EmptySearchIcon,
  "nm-exception": ExceptionIcon,
  "nm-expand": ExpandIcon,
  "nm-facebook": FacebookIcon,
  "nm-fail": FailIcon,
  "nm-initial": InitialIcon,
  "nm-instagram": InstagramIcon,
  "nm-invalid": InvalidIcon,
  "nm-linkedin": LinkedinIcon,
  "nm-link": LinkIcon,
  "nm-loading": LoadingIcon,
  "nm-lock": LockIcon,
  "nm-map-location": MapLocationIcon,
  "nm-menu": MenuIcon,
  "nm-microphone": MicrophoneIcon,
  "nm-pending": PendingIcon,
  "nm-phone-call": PhoneCallIcon,
  "nm-play": PlayIcon,
  "nm-previous-step": PreviousStepIcon,
  "nm-processed": ProcessedIcon,
  "nm-question-list": QuestionListIcon,
  "nm-rejected": RejectedIcon,
  "nm-reply": ReplyIcon,
  "nm-retry": RetryIcon,
  "nm-returned": ReturnedIcon,
  "nm-revised-level": RevisedLevelIcon,
  "nm-revoked": RevokedIcon,
  "nm-scan": ScanIcon,
  "nm-send": SendIcon,
  "nm-signature": SignatureIcon,
  "nm-snapchat": SnapchatIcon,
  "nm-sort-reset": SortResetIcon,
  "nm-stable": StableIcon,
  "nm-supervisor": SupervisorIcon,
  "nm-tiktok": TiktokIcon,
  "nm-translation": TranslationIcon,
  "nm-tree-list": TreeListIcon,
  "nm-twitter": TwitterIcon,
  "nm-undo": UndoIcon,
  "nm-waiting": WaitingIcon,
  "nm-wave": WaveIcon,
  "nm-whats-app": WhatsAppIcon,
  "nm-youtube": YoutubeIcon,
  "nm-access_denied_2186052": Access_denied_2186052Icon,
  "nm-accomodation_16681378": Accomodation_16681378Icon,
  "nm-accountability_9981536": Accountability_9981536Icon,
  "nm-accounting_10331873": Accounting_10331873Icon,
  "nm-accounting_1570887": Accounting_1570887Icon,
  "nm-accounting_4979100": Accounting_4979100Icon,
  "nm-account_1233162": Account_1233162Icon,
  "nm-account_maintenance_17640422": Account_maintenance_17640422Icon,
  "nm-acquisition_12134708": Acquisition_12134708Icon,
  "nm-address_3365020": Address_3365020Icon,
  "nm-add_10563482": Add_10563482Icon,
  "nm-add_12517897": Add_12517897Icon,
  "nm-adjustment_4289046": Adjustment_4289046Icon,
  "nm-adjust_9710826": Adjust_9710826Icon,
  "nm-administrative_fine_9897376": Administrative_fine_9897376Icon,
  "nm-administrator_8921054": Administrator_8921054Icon,
  "nm-agreement_1278586": Agreement_1278586Icon,
  "nm-agreement_1492552": Agreement_1492552Icon,
  "nm-agreement_17227040": Agreement_17227040Icon,
  "nm-agreement_4504481": Agreement_4504481Icon,
  "nm-agreement_4604417": Agreement_4604417Icon,
  "nm-ai_17653338": Ai_17653338Icon,
  "nm-ai_powered_models_16209773": Ai_powered_models_16209773Icon,
  "nm-algebra_4010849": Algebra_4010849Icon,
  "nm-allocation_12708441": Allocation_12708441Icon,
  "nm-analysis_18362456": Analysis_18362456Icon,
  "nm-analysis_809497": Analysis_809497Icon,
  "nm-analytics_6012662": Analytics_6012662Icon,
  "nm-api_103093": Api_103093Icon,
  "nm-application_10227469": Application_10227469Icon,
  "nm-application_15875439": Application_15875439Icon,
  "nm-application_18277246": Application_18277246Icon,
  "nm-application_2245059": Application_2245059Icon,
  "nm-application_9791628": Application_9791628Icon,
  "nm-appointment_request_12630733": Appointment_request_12630733Icon,
  "nm-approved_10721349": Approved_10721349Icon,
  "nm-approved_11442743": Approved_11442743Icon,
  "nm-approved_942833": Approved_942833Icon,
  "nm-approve_7270275": Approve_7270275Icon,
  "nm-approve_9926380": Approve_9926380Icon,
  "nm-architecture_9398782": Architecture_9398782Icon,
  "nm-archive_1721906": Archive_1721906Icon,
  "nm-art_5311124": Art_5311124Icon,
  "nm-ask_2859733": Ask_2859733Icon,
  "nm-assembly_1118470": Assembly_1118470Icon,
  "nm-assessment_11112891": Assessment_11112891Icon,
  "nm-assessment_12199381": Assessment_12199381Icon,
  "nm-asset_12062393": Asset_12062393Icon,
  "nm-asset_12300653": Asset_12300653Icon,
  "nm-asset_12885326": Asset_12885326Icon,
  "nm-asset_4002065": Asset_4002065Icon,
  "nm-asset_allocation_11376888": Asset_allocation_11376888Icon,
  "nm-asset_allocation_12315713": Asset_allocation_12315713Icon,
  "nm-assortment_4827324": Assortment_4827324Icon,
  "nm-assurance_4157073": Assurance_4157073Icon,
  "nm-attendance_6611895": Attendance_6611895Icon,
  "nm-attendance_device_16230724": Attendance_device_16230724Icon,
  "nm-auction_783196": Auction_783196Icon,
  "nm-audition_10227648": Audition_10227648Icon,
  "nm-audit_4307934": Audit_4307934Icon,
  "nm-automation_10872051": Automation_10872051Icon,
  "nm-automation_15569965": Automation_15569965Icon,
  "nm-automation_9325681": Automation_9325681Icon,
  "nm-autonomous_car_2941989": Autonomous_car_2941989Icon,
  "nm-avatar_266134": Avatar_266134Icon,
  "nm-award_badge_11835451": Award_badge_11835451Icon,
  "nm-b2b_5915166": B2b_5915166Icon,
  "nm-bad_9125203": Bad_9125203Icon,
  "nm-balance_16680712": Balance_16680712Icon,
  "nm-balance_sheet_8682846": Balance_sheet_8682846Icon,
  "nm-ballot_1533927": Ballot_1533927Icon,
  "nm-bank_1669617": Bank_1669617Icon,
  "nm-bank_3635987": Bank_3635987Icon,
  "nm-bank_7969361": Bank_7969361Icon,
  "nm-bank_account_8432416": Bank_account_8432416Icon,
  "nm-bank_account_9359512": Bank_account_9359512Icon,
  "nm-bank_statement_3742514": Bank_statement_3742514Icon,
  "nm-bank_transfer_2787531": Bank_transfer_2787531Icon,
  "nm-barcode_16912866": Barcode_16912866Icon,
  "nm-bar_chart_478544": Bar_chart_478544Icon,
  "nm-bar_graph_8439433": Bar_graph_8439433Icon,
  "nm-battery_4115361": Battery_4115361Icon,
  "nm-bell_17465958": Bell_17465958Icon,
  "nm-benchmarking_18609810": Benchmarking_18609810Icon,
  "nm-bid_2162213": Bid_2162213Icon,
  "nm-billing_17625287": Billing_17625287Icon,
  "nm-bills_2359971": Bills_2359971Icon,
  "nm-bill_14895794": Bill_14895794Icon,
  "nm-bill_1763436": Bill_1763436Icon,
  "nm-bill_2976378": Bill_2976378Icon,
  "nm-bill_4545554": Bill_4545554Icon,
  "nm-bill_7372992": Bill_7372992Icon,
  "nm-bill_781862": Bill_781862Icon,
  "nm-bill_of_lading_14198953": Bill_of_lading_14198953Icon,
  "nm-biometric_attendance_12767435": Biometric_attendance_12767435Icon,
  "nm-block_user_7838125": Block_user_7838125Icon,
  "nm-blood_test_12485937": Blood_test_12485937Icon,
  "nm-blood_test_16780038": Blood_test_16780038Icon,
  "nm-blood_tube_7678363": Blood_tube_7678363Icon,
  "nm-body_paint_repair_13401864": Body_paint_repair_13401864Icon,
  "nm-bond_13473066": Bond_13473066Icon,
  "nm-bookmark_13124718": Bookmark_13124718Icon,
  "nm-book_1211755": Book_1211755Icon,
  "nm-book_15947937": Book_15947937Icon,
  "nm-book_3238973": Book_3238973Icon,
  "nm-book_9257188": Book_9257188Icon,
  "nm-box_13964534": Box_13964534Icon,
  "nm-box_14116892": Box_14116892Icon,
  "nm-box_1524539": Box_1524539Icon,
  "nm-box_9962216": Box_9962216Icon,
  "nm-branch_6712276": Branch_6712276Icon,
  "nm-brand_3886706": Brand_3886706Icon,
  "nm-brand_awareness_17328280": Brand_awareness_17328280Icon,
  "nm-briefcase_17989959": Briefcase_17989959Icon,
  "nm-budgeting_8123485": Budgeting_8123485Icon,
  "nm-budget_4341568": Budget_4341568Icon,
  "nm-budget_7615720": Budget_7615720Icon,
  "nm-budget_9918832": Budget_9918832Icon,
  "nm-budget_planning_11048265": Budget_planning_11048265Icon,
  "nm-builder_7152038": Builder_7152038Icon,
  "nm-building_1324872": Building_1324872Icon,
  "nm-businessman_3630246": Businessman_3630246Icon,
  "nm-business_14525232": Business_14525232Icon,
  "nm-business_15139054": Business_15139054Icon,
  "nm-business_and_finance_1773345": Business_and_finance_1773345Icon,
  "nm-business_people_9606006": Business_people_9606006Icon,
  "nm-business_plan_11925596": Business_plan_11925596Icon,
  "nm-business_proposal_6623145": Business_proposal_6623145Icon,
  "nm-business_report_4060002": Business_report_4060002Icon,
  "nm-business_strategy_9140477": Business_strategy_9140477Icon,
  "nm-bus_3124381": Bus_3124381Icon,
  "nm-calculator_1760539": Calculator_1760539Icon,
  "nm-calculator_2488980": Calculator_2488980Icon,
  "nm-calculator_5151275": Calculator_5151275Icon,
  "nm-calendar_10403035": Calendar_10403035Icon,
  "nm-calendar_1581943": Calendar_1581943Icon,
  "nm-calendar_17376753": Calendar_17376753Icon,
  "nm-calendar_2370264": Calendar_2370264Icon,
  "nm-calendar_2746028": Calendar_2746028Icon,
  "nm-campaign_4573251": Campaign_4573251Icon,
  "nm-cancelation_7516548": Cancelation_7516548Icon,
  "nm-cancel_3037017": Cancel_3037017Icon,
  "nm-cancel_7868098": Cancel_7868098Icon,
  "nm-cancel_order_12893893": Cancel_order_12893893Icon,
  "nm-cancel_order_13466951": Cancel_order_13466951Icon,
  "nm-capability_12133586": Capability_12133586Icon,
  "nm-capital_12394258": Capital_12394258Icon,
  "nm-capital_17980663": Capital_17980663Icon,
  "nm-cards_4748745": Cards_4748745Icon,
  "nm-carton_5790352": Carton_5790352Icon,
  "nm-car_10105423": Car_10105423Icon,
  "nm-car_14236293": Car_14236293Icon,
  "nm-car_insurance_11442860": Car_insurance_11442860Icon,
  "nm-car_insurance_1518645": Car_insurance_1518645Icon,
  "nm-car_insurance_1743700": Car_insurance_1743700Icon,
  "nm-car_service_1647922": Car_service_1647922Icon,
  "nm-cashback_7444875": Cashback_7444875Icon,
  "nm-cashier_2450340": Cashier_2450340Icon,
  "nm-cashless_payment_4108841": Cashless_payment_4108841Icon,
  "nm-cash_flow_10842949": Cash_flow_10842949Icon,
  "nm-cash_flow_15341964": Cash_flow_15341964Icon,
  "nm-cash_machine_4689858": Cash_machine_4689858Icon,
  "nm-casting_18362364": Casting_18362364Icon,
  "nm-category_4013399": Category_4013399Icon,
  "nm-caution_4601287": Caution_4601287Icon,
  "nm-certificate_1470846": Certificate_1470846Icon,
  "nm-chain_14148805": Chain_14148805Icon,
  "nm-change_125860": Change_125860Icon,
  "nm-chapter_15586789": Chapter_15586789Icon,
  "nm-chat_2950667": Chat_2950667Icon,
  "nm-chat_9742173": Chat_9742173Icon,
  "nm-checklists_6735211": Checklists_6735211Icon,
  "nm-checklist_11458709": Checklist_11458709Icon,
  "nm-checklist_12681572": Checklist_12681572Icon,
  "nm-checklist_15169051": Checklist_15169051Icon,
  "nm-checklist_3336536": Checklist_3336536Icon,
  "nm-checklist_3750160": Checklist_3750160Icon,
  "nm-checklist_4342581": Checklist_4342581Icon,
  "nm-checklist_7050554": Checklist_7050554Icon,
  "nm-checklist_7547631": Checklist_7547631Icon,
  "nm-checklist_8214750": Checklist_8214750Icon,
  "nm-checklist_8719356": Checklist_8719356Icon,
  "nm-checklist_9752119": Checklist_9752119Icon,
  "nm-check_13514507": Check_13514507Icon,
  "nm-check_2974151": Check_2974151Icon,
  "nm-check_8719000": Check_8719000Icon,
  "nm-check_list_1721936": Check_list_1721936Icon,
  "nm-check_list_3406866": Check_list_3406866Icon,
  "nm-choose_12061689": Choose_12061689Icon,
  "nm-chronic_illness_18367611": Chronic_illness_18367611Icon,
  "nm-cigarette_2925545": Cigarette_2925545Icon,
  "nm-circle_1_10595791": Circle_1_10595791Icon,
  "nm-circle_2_11183354": Circle_2_11183354Icon,
  "nm-circle_7_11183359": Circle_7_11183359Icon,
  "nm-circle_8_10595796": Circle_8_10595796Icon,
  "nm-circle_9_10595797": Circle_9_10595797Icon,
  "nm-citizenship_18278821": Citizenship_18278821Icon,
  "nm-citizenship_7141967": Citizenship_7141967Icon,
  "nm-claim_2419593": Claim_2419593Icon,
  "nm-classification_14639636": Classification_14639636Icon,
  "nm-classroom_3197831": Classroom_3197831Icon,
  "nm-cleaning_cart_2975216": Cleaning_cart_2975216Icon,
  "nm-client_support_17373211": Client_support_17373211Icon,
  "nm-clinic_2222554": Clinic_2222554Icon,
  "nm-clipboard_13394359": Clipboard_13394359Icon,
  "nm-clipboard_1962592": Clipboard_1962592Icon,
  "nm-clipboard_3022148": Clipboard_3022148Icon,
  "nm-clipboard_8102915": Clipboard_8102915Icon,
  "nm-clipboard_839860": Clipboard_839860Icon,
  "nm-cli_10237174": Cli_10237174Icon,
  "nm-clock_10227441": Clock_10227441Icon,
  "nm-clock_4129791": Clock_4129791Icon,
  "nm-close_11963953": Close_11963953Icon,
  "nm-coal_1275480": Coal_1275480Icon,
  "nm-coding_2010990": Coding_2010990Icon,
  "nm-coding_3242120": Coding_3242120Icon,
  "nm-collaboration_11992996": Collaboration_11992996Icon,
  "nm-collaboration_5541565": Collaboration_5541565Icon,
  "nm-commentary_1230203": Commentary_1230203Icon,
  "nm-commission_7028100": Commission_7028100Icon,
  "nm-commitment_11671576": Commitment_11671576Icon,
  "nm-commodity_2973905": Commodity_2973905Icon,
  "nm-communication_11208135": Communication_11208135Icon,
  "nm-company_5741577": Company_5741577Icon,
  "nm-compare_6175740": Compare_6175740Icon,
  "nm-competitor_analysis_16314442": Competitor_analysis_16314442Icon,
  "nm-complaint_9375697": Complaint_9375697Icon,
  "nm-compliance_10521137": Compliance_10521137Icon,
  "nm-compliance_17474862": Compliance_17474862Icon,
  "nm-compliant_4252474": Compliant_4252474Icon,
  "nm-compliant_4961688": Compliant_4961688Icon,
  "nm-computer_1589642": Computer_1589642Icon,
  "nm-computer_16103184": Computer_16103184Icon,
  "nm-computer_4007539": Computer_4007539Icon,
  "nm-configuration_10618038": Configuration_10618038Icon,
  "nm-connect_3974952": Connect_3974952Icon,
  "nm-consistency_18832178": Consistency_18832178Icon,
  "nm-construction_12359525": Construction_12359525Icon,
  "nm-construction_14243038": Construction_14243038Icon,
  "nm-construction_method_14106373": Construction_method_14106373Icon,
  "nm-contacts_18090908": Contacts_18090908Icon,
  "nm-container_3364160": Container_3364160Icon,
  "nm-container_4459682": Container_4459682Icon,
  "nm-container_7115168": Container_7115168Icon,
  "nm-content_11386335": Content_11386335Icon,
  "nm-contractor_11671674": Contractor_11671674Icon,
  "nm-contractor_12003757": Contractor_12003757Icon,
  "nm-contract_10279810": Contract_10279810Icon,
  "nm-contract_11000620": Contract_11000620Icon,
  "nm-contract_11099161": Contract_11099161Icon,
  "nm-contract_12003720": Contract_12003720Icon,
  "nm-contract_1275212": Contract_1275212Icon,
  "nm-contract_15586801": Contract_15586801Icon,
  "nm-contract_17213425": Contract_17213425Icon,
  "nm-contract_1721843": Contract_1721843Icon,
  "nm-contract_17322641": Contract_17322641Icon,
  "nm-contract_17718602": Contract_17718602Icon,
  "nm-contract_18601700": Contract_18601700Icon,
  "nm-contract_2655351": Contract_2655351Icon,
  "nm-contract_2666523": Contract_2666523Icon,
  "nm-contract_3985921": Contract_3985921Icon,
  "nm-contract_5513696": Contract_5513696Icon,
  "nm-contract_5545080": Contract_5545080Icon,
  "nm-contract_5545095": Contract_5545095Icon,
  "nm-contract_5965822": Contract_5965822Icon,
  "nm-contract_6822251": Contract_6822251Icon,
  "nm-contract_7352878": Contract_7352878Icon,
  "nm-contract_757320": Contract_757320Icon,
  "nm-contract_913393": Contract_913393Icon,
  "nm-contract_9186233": Contract_9186233Icon,
  "nm-contract_document_15913380": Contract_document_15913380Icon,
  "nm-controller_1687819": Controller_1687819Icon,
  "nm-control_12943317": Control_12943317Icon,
  "nm-conversation_3050431": Conversation_3050431Icon,
  "nm-conversion_rate_17328299": Conversion_rate_17328299Icon,
  "nm-cooperation_9139670": Cooperation_9139670Icon,
  "nm-coordinated_17876780": Coordinated_17876780Icon,
  "nm-copy_2874774": Copy_2874774Icon,
  "nm-corporation_18666942": Corporation_18666942Icon,
  "nm-corrugated_16587756": Corrugated_16587756Icon,
  "nm-corruption_5267757": Corruption_5267757Icon,
  "nm-cost_12573938": Cost_12573938Icon,
  "nm-cost_3875852": Cost_3875852Icon,
  "nm-cost_5531516": Cost_5531516Icon,
  "nm-cost_5656822": Cost_5656822Icon,
  "nm-cost_7700020": Cost_7700020Icon,
  "nm-cost_circle_18851400": Cost_circle_18851400Icon,
  "nm-cost_of_goods_sold_15554945": Cost_of_goods_sold_15554945Icon,
  "nm-counter_3410112": Counter_3410112Icon,
  "nm-counter_7207766": Counter_7207766Icon,
  "nm-coupons_4683372": Coupons_4683372Icon,
  "nm-coupon_9551915": Coupon_9551915Icon,
  "nm-courier_7000501": Courier_7000501Icon,
  "nm-credit_card_4021708": Credit_card_4021708Icon,
  "nm-credit_card_4457310": Credit_card_4457310Icon,
  "nm-credit_card_4689390": Credit_card_4689390Icon,
  "nm-currencies_2601491": Currencies_2601491Icon,
  "nm-currency_exchange_2473887": Currency_exchange_2473887Icon,
  "nm-customer_journey_18665145": Customer_journey_18665145Icon,
  "nm-customer_service_3632552": Customer_service_3632552Icon,
  "nm-customer_support_12247491": Customer_support_12247491Icon,
  "nm-custom_2760940": Custom_2760940Icon,
  "nm-custom_clearance_12828346": Custom_clearance_12828346Icon,
  "nm-custom_clearance_14785145": Custom_clearance_14785145Icon,
  "nm-custom_clearance_7141914": Custom_clearance_7141914Icon,
  "nm-cycle_7267546": Cycle_7267546Icon,
  "nm-damaged_package_5501789": Damaged_package_5501789Icon,
  "nm-damage_16934322": Damage_16934322Icon,
  "nm-dashboard_2956542": Dashboard_2956542Icon,
  "nm-dashboard_8278857": Dashboard_8278857Icon,
  "nm-database_12945605": Database_12945605Icon,
  "nm-data_993762": Data_993762Icon,
  "nm-data_cleaning_12091023": Data_cleaning_12091023Icon,
  "nm-data_cleanup_17982835": Data_cleanup_17982835Icon,
  "nm-data_collection_10003054": Data_collection_10003054Icon,
  "nm-data_compression_4403169": Data_compression_4403169Icon,
  "nm-data_replication_16810774": Data_replication_16810774Icon,
  "nm-data_report_18034974": Data_report_18034974Icon,
  "nm-data_transfer_8316751": Data_transfer_8316751Icon,
  "nm-data_warehouse_18273867": Data_warehouse_18273867Icon,
  "nm-data_warehouse_4149668": Data_warehouse_4149668Icon,
  "nm-day_off_7174337": Day_off_7174337Icon,
  "nm-deadline_2612924": Deadline_2612924Icon,
  "nm-deal_2601512": Deal_2601512Icon,
  "nm-deal_paper_18819525": Deal_paper_18819525Icon,
  "nm-debit_card_1087117": Debit_card_1087117Icon,
  "nm-debt_5104787": Debt_5104787Icon,
  "nm-debt_consolidation_2516260": Debt_consolidation_2516260Icon,
  "nm-defective_5187063": Defective_5187063Icon,
  "nm-deficit_10064043": Deficit_10064043Icon,
  "nm-definition_11036823": Definition_11036823Icon,
  "nm-definition_15873524": Definition_15873524Icon,
  "nm-delegation_7626111": Delegation_7626111Icon,
  "nm-delete_2807722": Delete_2807722Icon,
  "nm-delete_3240358": Delete_3240358Icon,
  "nm-delivery_4791449": Delivery_4791449Icon,
  "nm-delivery_box_4213948": Delivery_box_4213948Icon,
  "nm-delivery_car_7615749": Delivery_car_7615749Icon,
  "nm-delivery_service_11458660": Delivery_service_11458660Icon,
  "nm-delivery_status_9272041": Delivery_status_9272041Icon,
  "nm-delivery_truck_17886103": Delivery_truck_17886103Icon,
  "nm-design_resources_17921234": Design_resources_17921234Icon,
  "nm-destination_6889707": Destination_6889707Icon,
  "nm-destination_9655360": Destination_9655360Icon,
  "nm-detector_11875686": Detector_11875686Icon,
  "nm-diagnosis_17749910": Diagnosis_17749910Icon,
  "nm-disclaimer_11422025": Disclaimer_11422025Icon,
  "nm-disclosure_18035720": Disclosure_18035720Icon,
  "nm-discount_17173670": Discount_17173670Icon,
  "nm-discount_879757": Discount_879757Icon,
  "nm-discount_coupon_9618755": Discount_coupon_9618755Icon,
  "nm-dismissal_6896416": Dismissal_6896416Icon,
  "nm-disposal_3154606": Disposal_3154606Icon,
  "nm-distance_learning_3359690": Distance_learning_3359690Icon,
  "nm-distribution_7444365": Distribution_7444365Icon,
  "nm-distribution_9402109": Distribution_9402109Icon,
  "nm-dms_12280933": Dms_12280933Icon,
  "nm-doctor_3481061": Doctor_3481061Icon,
  "nm-doctor_consultation_15756405": Doctor_consultation_15756405Icon,
  "nm-documents_9409822": Documents_9409822Icon,
  "nm-document_10103861": Document_10103861Icon,
  "nm-document_10690902": Document_10690902Icon,
  "nm-document_12410588": Document_12410588Icon,
  "nm-document_12507778": Document_12507778Icon,
  "nm-document_13068212": Document_13068212Icon,
  "nm-document_14228636": Document_14228636Icon,
  "nm-document_1459111": Document_1459111Icon,
  "nm-document_15839141": Document_15839141Icon,
  "nm-document_16227978": Document_16227978Icon,
  "nm-document_17931105": Document_17931105Icon,
  "nm-document_2615828": Document_2615828Icon,
  "nm-document_2802210": Document_2802210Icon,
  "nm-document_2833676": Document_2833676Icon,
  "nm-document_3028707": Document_3028707Icon,
  "nm-document_3131591": Document_3131591Icon,
  "nm-document_4168367": Document_4168367Icon,
  "nm-document_5036831": Document_5036831Icon,
  "nm-document_5064870": Document_5064870Icon,
  "nm-document_6179995": Document_6179995Icon,
  "nm-document_6486605": Document_6486605Icon,
  "nm-document_6679506": Document_6679506Icon,
  "nm-document_8848039": Document_8848039Icon,
  "nm-doc_file_8586188": Doc_file_8586188Icon,
  "nm-dollar_7250391": Dollar_7250391Icon,
  "nm-door_to_door_10352744": Door_to_door_10352744Icon,
  "nm-double_bed_2284001": Double_bed_2284001Icon,
  "nm-driver_license_2916223": Driver_license_2916223Icon,
  "nm-drugs_840781": Drugs_840781Icon,
  "nm-due_diligence_12134552": Due_diligence_12134552Icon,
  "nm-duplex_9705814": Duplex_9705814Icon,
  "nm-ecommerce_2847083": Ecommerce_2847083Icon,
  "nm-edit_13246694": Edit_13246694Icon,
  "nm-edit_2490572": Edit_2490572Icon,
  "nm-edit_7073677": Edit_7073677Icon,
  "nm-edit_8470847": Edit_8470847Icon,
  "nm-education_level_18178797": Education_level_18178797Icon,
  "nm-email_18410022": Email_18410022Icon,
  "nm-email_2303951": Email_2303951Icon,
  "nm-email_4548492": Email_4548492Icon,
  "nm-emergency_17774923": Emergency_17774923Icon,
  "nm-emergency_exit_5523246": Emergency_exit_5523246Icon,
  "nm-emergency_room_9733672": Emergency_room_9733672Icon,
  "nm-employee_14331334": Employee_14331334Icon,
  "nm-employee_18819990": Employee_18819990Icon,
  "nm-employee_912316": Employee_912316Icon,
  "nm-employee_assessment_16761069": Employee_assessment_16761069Icon,
  "nm-employee_data_11542066": Employee_data_11542066Icon,
  "nm-employee_of_the_month_12422988": Employee_of_the_month_12422988Icon,
  "nm-erp_5627023": Erp_5627023Icon,
  "nm-error_message_2581972": Error_message_2581972Icon,
  "nm-escrow_15166230": Escrow_15166230Icon,
  "nm-estate_12394291": Estate_12394291Icon,
  "nm-estate_planning_15636935": Estate_planning_15636935Icon,
  "nm-estimation_9735680": Estimation_9735680Icon,
  "nm-evaluation_12197483": Evaluation_12197483Icon,
  "nm-event_2413035": Event_2413035Icon,
  "nm-excavator_4968068": Excavator_4968068Icon,
  "nm-exchange_1585147": Exchange_1585147Icon,
  "nm-exchange_3979328": Exchange_3979328Icon,
  "nm-exchange_9788303": Exchange_9788303Icon,
  "nm-exchange_rate_2510663": Exchange_rate_2510663Icon,
  "nm-exclusion_12058761": Exclusion_12058761Icon,
  "nm-execution_16753378": Execution_16753378Icon,
  "nm-expenses_17777561": Expenses_17777561Icon,
  "nm-expenses_8655448": Expenses_8655448Icon,
  "nm-expense_11241017": Expense_11241017Icon,
  "nm-export_14105078": Export_14105078Icon,
  "nm-export_2356610": Export_2356610Icon,
  "nm-extinguisher_5672574": Extinguisher_5672574Icon,
  "nm-field_trip_5190157": Field_trip_5190157Icon,
  "nm-files_15330716": Files_15330716Icon,
  "nm-file_10217805": File_10217805Icon,
  "nm-file_1362090": File_1362090Icon,
  "nm-file_14680590": File_14680590Icon,
  "nm-file_16882340": File_16882340Icon,
  "nm-file_2140667": File_2140667Icon,
  "nm-file_2521572": File_2521572Icon,
  "nm-file_2997966": File_2997966Icon,
  "nm-file_3286176": File_3286176Icon,
  "nm-file_8406598": File_8406598Icon,
  "nm-file_8406610": File_8406610Icon,
  "nm-file_import_14400288": File_import_14400288Icon,
  "nm-file_rotation_15948280": File_rotation_15948280Icon,
  "nm-file_transfer_11305627": File_transfer_11305627Icon,
  "nm-file_transfer_12192997": File_transfer_12192997Icon,
  "nm-filter_1159641": Filter_1159641Icon,
  "nm-filter_1511905": Filter_1511905Icon,
  "nm-filter_17321815": Filter_17321815Icon,
  "nm-filter_3839020": Filter_3839020Icon,
  "nm-finance_1992253": Finance_1992253Icon,
  "nm-finance_4072713": Finance_4072713Icon,
  "nm-finance_8581429": Finance_8581429Icon,
  "nm-financial_9423027": Financial_9423027Icon,
  "nm-financial_audit_17786297": Financial_audit_17786297Icon,
  "nm-financial_information_10064074": Financial_information_10064074Icon,
  "nm-financial_planning_15586826": Financial_planning_15586826Icon,
  "nm-financial_statement_6341974": Financial_statement_6341974Icon,
  "nm-financing_18242351": Financing_18242351Icon,
  "nm-fiscal_17756128": Fiscal_17756128Icon,
  "nm-five_4626501": Five_4626501Icon,
  "nm-five_stars_5134846": Five_stars_5134846Icon,
  "nm-fixed_asset_3491684": Fixed_asset_3491684Icon,
  "nm-flags_455582": Flags_455582Icon,
  "nm-floor_7700034": Floor_7700034Icon,
  "nm-flute_848166": Flute_848166Icon,
  "nm-focus_group_16805859": Focus_group_16805859Icon,
  "nm-folder_10210092": Folder_10210092Icon,
  "nm-folder_10828574": Folder_10828574Icon,
  "nm-folder_13644434": Folder_13644434Icon,
  "nm-folder_16090918": Folder_16090918Icon,
  "nm-folder_17864149": Folder_17864149Icon,
  "nm-folder_8117645": Folder_8117645Icon,
  "nm-follow_up_16792851": Follow_up_16792851Icon,
  "nm-food_2771460": Food_2771460Icon,
  "nm-food_preparation_18810291": Food_preparation_18810291Icon,
  "nm-forecasting_8553022": Forecasting_8553022Icon,
  "nm-forecast_6633516": Forecast_6633516Icon,
  "nm-forecast_analytics_16137972": Forecast_analytics_16137972Icon,
  "nm-framework_4160849": Framework_4160849Icon,
  "nm-frame_7033171": Frame_7033171Icon,
  "nm-free_shipping_15557514": Free_shipping_15557514Icon,
  "nm-freight_18303387": Freight_18303387Icon,
  "nm-function_18565923": Function_18565923Icon,
  "nm-gadget_6711321": Gadget_6711321Icon,
  "nm-gears_9581641": Gears_9581641Icon,
  "nm-gear_13355740": Gear_13355740Icon,
  "nm-gear_17870834": Gear_17870834Icon,
  "nm-gear_2953165": Gear_2953165Icon,
  "nm-gear_518875": Gear_518875Icon,
  "nm-gift_2731865": Gift_2731865Icon,
  "nm-gift_box_18098228": Gift_box_18098228Icon,
  "nm-goal_1465829": Goal_1465829Icon,
  "nm-goods_12003912": Goods_12003912Icon,
  "nm-group_3394744": Group_3394744Icon,
  "nm-group_8073854": Group_8073854Icon,
  "nm-gruop_16390039": Gruop_16390039Icon,
  "nm-guide_17050066": Guide_17050066Icon,
  "nm-handrail_4349346": Handrail_4349346Icon,
  "nm-handshake_10266978": Handshake_10266978Icon,
  "nm-handshake_2613094": Handshake_2613094Icon,
  "nm-hand_18409994": Hand_18409994Icon,
  "nm-hatchback_5035167": Hatchback_5035167Icon,
  "nm-healthcare_2966334": Healthcare_2966334Icon,
  "nm-healthcare_4003747": Healthcare_4003747Icon,
  "nm-healthy_eating_18706159": Healthy_eating_18706159Icon,
  "nm-healthy_food_9757178": Healthy_food_9757178Icon,
  "nm-health_insurance_12712315": Health_insurance_12712315Icon,
  "nm-health_insurance_4388224": Health_insurance_4388224Icon,
  "nm-health_report_17967663": Health_report_17967663Icon,
  "nm-help_1660114": Help_1660114Icon,
  "nm-hijri_15364805": Hijri_15364805Icon,
  "nm-history_15231313": History_15231313Icon,
  "nm-hold_5966090": Hold_5966090Icon,
  "nm-holidays_3634857": Holidays_3634857Icon,
  "nm-homework_17251701": Homework_17251701Icon,
  "nm-homework_4711767": Homework_4711767Icon,
  "nm-home_1848500": Home_1848500Icon,
  "nm-hospitalisation_2302792": Hospitalisation_2302792Icon,
  "nm-hospital_2895071": Hospital_2895071Icon,
  "nm-hospital_3209159": Hospital_3209159Icon,
  "nm-hotel_201426": Hotel_201426Icon,
  "nm-hotel_bed_3060178": Hotel_bed_3060178Icon,
  "nm-house_10604757": House_10604757Icon,
  "nm-house_3637773": House_3637773Icon,
  "nm-house_9202668": House_9202668Icon,
  "nm-house_lock_5687474": House_lock_5687474Icon,
  "nm-human_5246761": Human_5246761Icon,
  "nm-human_resources_10488501": Human_resources_10488501Icon,
  "nm-idea_9453383": Idea_9453383Icon,
  "nm-id_card_10721956": Id_card_10721956Icon,
  "nm-illegal_5736545": Illegal_5736545Icon,
  "nm-important_mail_11889689": Important_mail_11889689Icon,
  "nm-import_export_15221871": Import_export_15221871Icon,
  "nm-inbound_12141524": Inbound_12141524Icon,
  "nm-inch_4236604": Inch_4236604Icon,
  "nm-increase_10243550": Increase_10243550Icon,
  "nm-infrastructure_11495742": Infrastructure_11495742Icon,
  "nm-input_9671337": Input_9671337Icon,
  "nm-insight_18492905": Insight_18492905Icon,
  "nm-inspection_15166526": Inspection_15166526Icon,
  "nm-inspection_5531663": Inspection_5531663Icon,
  "nm-inspection_6052465": Inspection_6052465Icon,
  "nm-instructions_12627704": Instructions_12627704Icon,
  "nm-insurance_11443006": Insurance_11443006Icon,
  "nm-insurance_1962586": Insurance_1962586Icon,
  "nm-insurance_6888112": Insurance_6888112Icon,
  "nm-insurance_9824434": Insurance_9824434Icon,
  "nm-insurance_audit_13068277": Insurance_audit_13068277Icon,
  "nm-insurance_company_7339353": Insurance_company_7339353Icon,
  "nm-integration_4618560": Integration_4618560Icon,
  "nm-interior_design_2400622": Interior_design_2400622Icon,
  "nm-internet_16502214": Internet_16502214Icon,
  "nm-inventory_12141431": Inventory_12141431Icon,
  "nm-inventory_18771476": Inventory_18771476Icon,
  "nm-inventory_2897616": Inventory_2897616Icon,
  "nm-inventory_management_18564078": Inventory_management_18564078Icon,
  "nm-inventory_management_8744645": Inventory_management_8744645Icon,
  "nm-investment_12942999": Investment_12942999Icon,
  "nm-investment_16485024": Investment_16485024Icon,
  "nm-investment_2159865": Investment_2159865Icon,
  "nm-investment_4930129": Investment_4930129Icon,
  "nm-investor_2386356": Investor_2386356Icon,
  "nm-invoices_3358993": Invoices_3358993Icon,
  "nm-invoice_10112462": Invoice_10112462Icon,
  "nm-invoice_12155208": Invoice_12155208Icon,
  "nm-invoice_12676454": Invoice_12676454Icon,
  "nm-invoice_12970042": Invoice_12970042Icon,
  "nm-invoice_15575258": Invoice_15575258Icon,
  "nm-invoice_16933159": Invoice_16933159Icon,
  "nm-invoice_18491196": Invoice_18491196Icon,
  "nm-invoice_18964749": Invoice_18964749Icon,
  "nm-invoice_2474482": Invoice_2474482Icon,
  "nm-invoice_3408829": Invoice_3408829Icon,
  "nm-invoice_411796": Invoice_411796Icon,
  "nm-invoice_4306889": Invoice_4306889Icon,
  "nm-invoice_4862319": Invoice_4862319Icon,
  "nm-invoice_6026725": Invoice_6026725Icon,
  "nm-invoice_7291266": Invoice_7291266Icon,
  "nm-invoice_8354689": Invoice_8354689Icon,
  "nm-invoice_9071521": Invoice_9071521Icon,
  "nm-in_stock_7444276": In_stock_7444276Icon,
  "nm-isolation_3062991": Isolation_3062991Icon,
  "nm-item_12512009": Item_12512009Icon,
  "nm-job_11898010": Job_11898010Icon,
  "nm-job_application_15189386": Job_application_15189386Icon,
  "nm-job_description_7376263": Job_description_7376263Icon,
  "nm-job_offer_15189475": Job_offer_15189475Icon,
  "nm-journal_12237179": Journal_12237179Icon,
  "nm-justice_16200810": Justice_16200810Icon,
  "nm-keyboard_15463172": Keyboard_15463172Icon,
  "nm-keyword_542632": Keyword_542632Icon,
  "nm-key_10217862": Key_10217862Icon,
  "nm-key_10647744": Key_10647744Icon,
  "nm-key_performance_indicator_10789436": Key_performance_indicator_10789436Icon,
  "nm-kitchen_1606657": Kitchen_1606657Icon,
  "nm-laboratory_7404175": Laboratory_7404175Icon,
  "nm-labor_cost_18250790": Labor_cost_18250790Icon,
  "nm-land_8978082": Land_8978082Icon,
  "nm-law_book_4474491": Law_book_4474491Icon,
  "nm-layout_4507688": Layout_4507688Icon,
  "nm-layout_4725672": Layout_4725672Icon,
  "nm-leader_10165937": Leader_10165937Icon,
  "nm-leader_4059502": Leader_4059502Icon,
  "nm-leave_3387310": Leave_3387310Icon,
  "nm-ledgers_15773346": Ledgers_15773346Icon,
  "nm-ledger_12183981": Ledger_12183981Icon,
  "nm-ledger_17001425": Ledger_17001425Icon,
  "nm-ledger_4680987": Ledger_4680987Icon,
  "nm-legal_18092070": Legal_18092070Icon,
  "nm-legal_document_3207533": Legal_document_3207533Icon,
  "nm-letter_6259496": Letter_6259496Icon,
  "nm-letter_7458351": Letter_7458351Icon,
  "nm-letter_of_guarantee_4930623": Letter_of_guarantee_4930623Icon,
  "nm-level_up_16863363": Level_up_16863363Icon,
  "nm-licensed_12029456": Licensed_12029456Icon,
  "nm-license_10836475": License_10836475Icon,
  "nm-lifting_12299319": Lifting_12299319Icon,
  "nm-lighting_3103277": Lighting_3103277Icon,
  "nm-link_11598691": Link_11598691Icon,
  "nm-link_12366460": Link_12366460Icon,
  "nm-link_455691": Link_455691Icon,
  "nm-link_building_8157946": Link_building_8157946Icon,
  "nm-list_17400520": List_17400520Icon,
  "nm-list_8415783": List_8415783Icon,
  "nm-list_9131997": List_9131997Icon,
  "nm-list_9482813": List_9482813Icon,
  "nm-loading_8081408": Loading_8081408Icon,
  "nm-loan_13794697": Loan_13794697Icon,
  "nm-loan_16933118": Loan_16933118Icon,
  "nm-loan_5023258": Loan_5023258Icon,
  "nm-loan_9828411": Loan_9828411Icon,
  "nm-location_12867982": Location_12867982Icon,
  "nm-location_7547677": Location_7547677Icon,
  "nm-locker_9045439": Locker_9045439Icon,
  "nm-logistic_contract_15597258": Logistic_contract_15597258Icon,
  "nm-log_17377923": Log_17377923Icon,
  "nm-low_performance_2386473": Low_performance_2386473Icon,
  "nm-loyal_customer_5431198": Loyal_customer_5431198Icon,
  "nm-lunch_4893631": Lunch_4893631Icon,
  "nm-machine_13869597": Machine_13869597Icon,
  "nm-magazine_4520868": Magazine_4520868Icon,
  "nm-mail_12287320": Mail_12287320Icon,
  "nm-mail_3720647": Mail_3720647Icon,
  "nm-mail_9318057": Mail_9318057Icon,
  "nm-maintenance_10559639": Maintenance_10559639Icon,
  "nm-maintenance_11276274": Maintenance_11276274Icon,
  "nm-maintenance_14305784": Maintenance_14305784Icon,
  "nm-maintenance_15569954": Maintenance_15569954Icon,
  "nm-maintenance_17073129": Maintenance_17073129Icon,
  "nm-maintenance_17876676": Maintenance_17876676Icon,
  "nm-maintenance_17972679": Maintenance_17972679Icon,
  "nm-maintenance_9831111": Maintenance_9831111Icon,
  "nm-maintenance_9878470": Maintenance_9878470Icon,
  "nm-management_10211342": Management_10211342Icon,
  "nm-management_14432082": Management_14432082Icon,
  "nm-management_1570102": Management_1570102Icon,
  "nm-management_9205839": Management_9205839Icon,
  "nm-manager_10487778": Manager_10487778Icon,
  "nm-man_15630692": Man_15630692Icon,
  "nm-map_6910292": Map_6910292Icon,
  "nm-marketing_16899226": Marketing_16899226Icon,
  "nm-marketing_9464695": Marketing_9464695Icon,
  "nm-marketing_mix_7253129": Marketing_mix_7253129Icon,
  "nm-market_analysis_9254636": Market_analysis_9254636Icon,
  "nm-mark_16530462": Mark_16530462Icon,
  "nm-material_1556328": Material_1556328Icon,
  "nm-math_3655553": Math_3655553Icon,
  "nm-meal_17694923": Meal_17694923Icon,
  "nm-measure_335446": Measure_335446Icon,
  "nm-mechanic_11133669": Mechanic_11133669Icon,
  "nm-mediator_7028072": Mediator_7028072Icon,
  "nm-medical_2302757": Medical_2302757Icon,
  "nm-medical_bill_15135746": Medical_bill_15135746Icon,
  "nm-medical_check_2634036": Medical_check_2634036Icon,
  "nm-medical_devices_17340723": Medical_devices_17340723Icon,
  "nm-medical_expense_17640396": Medical_expense_17640396Icon,
  "nm-medical_invoice_4494274": Medical_invoice_4494274Icon,
  "nm-medical_journey_17225490": Medical_journey_17225490Icon,
  "nm-medical_list_5143800": Medical_list_5143800Icon,
  "nm-medical_record_18150546": Medical_record_18150546Icon,
  "nm-medical_report_3215528": Medical_report_3215528Icon,
  "nm-medical_test_17104715": Medical_test_17104715Icon,
  "nm-medicine_5200471": Medicine_5200471Icon,
  "nm-message_13579018": Message_13579018Icon,
  "nm-message_2604334": Message_2604334Icon,
  "nm-message_dollar_14984866": Message_dollar_14984866Icon,
  "nm-mic_709950": Mic_709950Icon,
  "nm-mission_9092122": Mission_9092122Icon,
  "nm-mission_9372147": Mission_9372147Icon,
  "nm-mobile_management_17937701": Mobile_management_17937701Icon,
  "nm-mobile_payment_4007969": Mobile_payment_4007969Icon,
  "nm-modeling_14106298": Modeling_14106298Icon,
  "nm-money_10219953": Money_10219953Icon,
  "nm-money_13548278": Money_13548278Icon,
  "nm-money_14898589": Money_14898589Icon,
  "nm-money_16422494": Money_16422494Icon,
  "nm-money_16467587": Money_16467587Icon,
  "nm-money_2914767": Money_2914767Icon,
  "nm-money_3133430": Money_3133430Icon,
  "nm-money_bag_2953363": Money_bag_2953363Icon,
  "nm-money_box_2504585": Money_box_2504585Icon,
  "nm-money_chat_18917729": Money_chat_18917729Icon,
  "nm-money_management_12331286": Money_management_12331286Icon,
  "nm-money_management_2666527": Money_management_2666527Icon,
  "nm-monitor_2930617": Monitor_2930617Icon,
  "nm-mortgage_11323576": Mortgage_11323576Icon,
  "nm-mortgage_broker_17063906": Mortgage_broker_17063906Icon,
  "nm-network_3348099": Network_3348099Icon,
  "nm-network_648324": Network_648324Icon,
  "nm-new_employee_14813059": New_employee_14813059Icon,
  "nm-new_product_12474335": New_product_12474335Icon,
  "nm-new_year_16775066": New_year_16775066Icon,
  "nm-notebook_3625224": Notebook_3625224Icon,
  "nm-note_13703448": Note_13703448Icon,
  "nm-notification_2645897": Notification_2645897Icon,
  "nm-no_corruption_10297234": No_corruption_10297234Icon,
  "nm-no_document_12342200": No_document_12342200Icon,
  "nm-no_paper_12065913": No_paper_12065913Icon,
  "nm-number_10_7173313": Number_10_7173313Icon,
  "nm-number_3_8068125": Number_3_8068125Icon,
  "nm-number_3_9387280": Number_3_9387280Icon,
  "nm-number_4_10259208": Number_4_10259208Icon,
  "nm-number_4_8068178": Number_4_8068178Icon,
  "nm-number_5_8068231": Number_5_8068231Icon,
  "nm-number_6_8068286": Number_6_8068286Icon,
  "nm-number_9_8067927": Number_9_8067927Icon,
  "nm-obligations_18564647": Obligations_18564647Icon,
  "nm-offer_12003803": Offer_12003803Icon,
  "nm-offer_1611173": Offer_1611173Icon,
  "nm-offer_9865110": Offer_9865110Icon,
  "nm-office_16131924": Office_16131924Icon,
  "nm-office_4041177": Office_4041177Icon,
  "nm-office_map_13807705": Office_map_13807705Icon,
  "nm-one_4626473": One_4626473Icon,
  "nm-online_16207344": Online_16207344Icon,
  "nm-online_learning_18798433": Online_learning_18798433Icon,
  "nm-online_shopping_1280804": Online_shopping_1280804Icon,
  "nm-online_shopping_3258481": Online_shopping_3258481Icon,
  "nm-online_store_9018922": Online_store_9018922Icon,
  "nm-operating_system_10397335": Operating_system_10397335Icon,
  "nm-operations_18532895": Operations_18532895Icon,
  "nm-operation_11337218": Operation_11337218Icon,
  "nm-operation_11337444": Operation_11337444Icon,
  "nm-operation_11337450": Operation_11337450Icon,
  "nm-optimization_8439152": Optimization_8439152Icon,
  "nm-order_12015378": Order_12015378Icon,
  "nm-order_1554563": Order_1554563Icon,
  "nm-order_1671130": Order_1671130Icon,
  "nm-order_766251": Order_766251Icon,
  "nm-order_7971189": Order_7971189Icon,
  "nm-order_fulfillment_17241069": Order_fulfillment_17241069Icon,
  "nm-order_tracking_3607527": Order_tracking_3607527Icon,
  "nm-order_tracking_9280849": Order_tracking_9280849Icon,
  "nm-outpatient_14599729": Outpatient_14599729Icon,
  "nm-out_of_stock_10614817": Out_of_stock_10614817Icon,
  "nm-overhead_11909702": Overhead_11909702Icon,
  "nm-ownership_5605976": Ownership_5605976Icon,
  "nm-package_2397992": Package_2397992Icon,
  "nm-package_600268": Package_600268Icon,
  "nm-packing_list_1670974": Packing_list_1670974Icon,
  "nm-papers_12843854": Papers_12843854Icon,
  "nm-paper_10407098": Paper_10407098Icon,
  "nm-paper_13349577": Paper_13349577Icon,
  "nm-paper_14294082": Paper_14294082Icon,
  "nm-paper_15978905": Paper_15978905Icon,
  "nm-paper_2541979": Paper_2541979Icon,
  "nm-paper_5653782": Paper_5653782Icon,
  "nm-paper_6300707": Paper_6300707Icon,
  "nm-paper_assessment_18895772": Paper_assessment_18895772Icon,
  "nm-paper_bag_1625706": Paper_bag_1625706Icon,
  "nm-parcel_size_9527158": Parcel_size_9527158Icon,
  "nm-parents_10184701": Parents_10184701Icon,
  "nm-part_17404360": Part_17404360Icon,
  "nm-passport_10865439": Passport_10865439Icon,
  "nm-passport_1257113": Passport_1257113Icon,
  "nm-passport_control_4696981": Passport_control_4696981Icon,
  "nm-patient_2376100": Patient_2376100Icon,
  "nm-patient_9733728": Patient_9733728Icon,
  "nm-pattern_2048512": Pattern_2048512Icon,
  "nm-payment_10683919": Payment_10683919Icon,
  "nm-payment_11253966": Payment_11253966Icon,
  "nm-payment_18557486": Payment_18557486Icon,
  "nm-payment_2530689": Payment_2530689Icon,
  "nm-payment_2780279": Payment_2780279Icon,
  "nm-payment_4645352": Payment_4645352Icon,
  "nm-payment_7262711": Payment_7262711Icon,
  "nm-payment_security_14385195": Payment_security_14385195Icon,
  "nm-payment_service_17389462": Payment_service_17389462Icon,
  "nm-payment_system_15546727": Payment_system_15546727Icon,
  "nm-payment_terminal_2666418": Payment_terminal_2666418Icon,
  "nm-penalties_12061224": Penalties_12061224Icon,
  "nm-penalty_18112872": Penalty_18112872Icon,
  "nm-penalty_18144969": Penalty_18144969Icon,
  "nm-people_15814582": People_15814582Icon,
  "nm-people_15979414": People_15979414Icon,
  "nm-people_16070422": People_16070422Icon,
  "nm-people_1769041": People_1769041Icon,
  "nm-people_3171593": People_3171593Icon,
  "nm-percentage_9731321": Percentage_9731321Icon,
  "nm-performance_11883579": Performance_11883579Icon,
  "nm-performance_16773505": Performance_16773505Icon,
  "nm-performance_3488812": Performance_3488812Icon,
  "nm-pharmacy_17692771": Pharmacy_17692771Icon,
  "nm-phases_4357": Phases_4357Icon,
  "nm-phone_4951609": Phone_4951609Icon,
  "nm-phone_call_3059408": Phone_call_3059408Icon,
  "nm-photocopy_3648602": Photocopy_3648602Icon,
  "nm-physical_therapy_17774705": Physical_therapy_17774705Icon,
  "nm-pick_list_11392541": Pick_list_11392541Icon,
  "nm-pie_chart_7558222": Pie_chart_7558222Icon,
  "nm-pie_graphic_6419899": Pie_graphic_6419899Icon,
  "nm-placeholder_819865": Placeholder_819865Icon,
  "nm-planning_434346": Planning_434346Icon,
  "nm-plan_10120809": Plan_10120809Icon,
  "nm-plan_9402085": Plan_9402085Icon,
  "nm-point_of_service_6140301": Point_of_service_6140301Icon,
  "nm-policy_10710183": Policy_10710183Icon,
  "nm-policy_5187181": Policy_5187181Icon,
  "nm-portfolio_12304404": Portfolio_12304404Icon,
  "nm-portfolio_folder_9413311": Portfolio_folder_9413311Icon,
  "nm-posting_11913601": Posting_11913601Icon,
  "nm-pos_terminal_6551691": Pos_terminal_6551691Icon,
  "nm-preferences_10210533": Preferences_10210533Icon,
  "nm-price_list_10103341": Price_list_10103341Icon,
  "nm-price_list_11000672": Price_list_11000672Icon,
  "nm-price_list_16090725": Price_list_16090725Icon,
  "nm-price_list_4464915": Price_list_4464915Icon,
  "nm-price_list_4961543": Price_list_4961543Icon,
  "nm-price_list_4994468": Price_list_4994468Icon,
  "nm-price_list_7444269": Price_list_7444269Icon,
  "nm-price_list_8461594": Price_list_8461594Icon,
  "nm-price_list_8890319": Price_list_8890319Icon,
  "nm-price_tag_567600": Price_tag_567600Icon,
  "nm-printer_3465791": Printer_3465791Icon,
  "nm-print_4305625": Print_4305625Icon,
  "nm-prioritize_10492974": Prioritize_10492974Icon,
  "nm-privacy_18238966": Privacy_18238966Icon,
  "nm-procedures_11702817": Procedures_11702817Icon,
  "nm-procedure_12299115": Procedure_12299115Icon,
  "nm-processing_10614604": Processing_10614604Icon,
  "nm-process_11494179": Process_11494179Icon,
  "nm-process_1865497": Process_1865497Icon,
  "nm-process_3078984": Process_3078984Icon,
  "nm-process_4149677": Process_4149677Icon,
  "nm-procurement_4862413": Procurement_4862413Icon,
  "nm-product_1311144": Product_1311144Icon,
  "nm-product_15681406": Product_15681406Icon,
  "nm-product_15817361": Product_15817361Icon,
  "nm-product_2652218": Product_2652218Icon,
  "nm-product_3712174": Product_3712174Icon,
  "nm-product_7078329": Product_7078329Icon,
  "nm-product_8744687": Product_8744687Icon,
  "nm-product_categories_15555049": Product_categories_15555049Icon,
  "nm-product_cost_12544334": Product_cost_12544334Icon,
  "nm-product_description_17311699": Product_description_17311699Icon,
  "nm-product_design_15597931": Product_design_15597931Icon,
  "nm-product_management_17970641": Product_management_17970641Icon,
  "nm-product_recall_16940698": Product_recall_16940698Icon,
  "nm-product_return_12459227": Product_return_12459227Icon,
  "nm-profile_11889864": Profile_11889864Icon,
  "nm-profits_3467240": Profits_3467240Icon,
  "nm-programmer_10438910": Programmer_10438910Icon,
  "nm-program_10237089": Program_10237089Icon,
  "nm-project_10898856": Project_10898856Icon,
  "nm-project_2679418": Project_2679418Icon,
  "nm-project_408557": Project_408557Icon,
  "nm-project_5956597": Project_5956597Icon,
  "nm-project_management_1087927": Project_management_1087927Icon,
  "nm-project_management_3286703": Project_management_3286703Icon,
  "nm-project_management_4946385": Project_management_4946385Icon,
  "nm-project_status_10934173": Project_status_10934173Icon,
  "nm-promotional_items_16879606": Promotional_items_16879606Icon,
  "nm-property_2243704": Property_2243704Icon,
  "nm-property_6140354": Property_6140354Icon,
  "nm-property_document_13390614": Property_document_13390614Icon,
  "nm-protected_2058324": Protected_2058324Icon,
  "nm-public_service_9747033": Public_service_9747033Icon,
  "nm-public_toilet_3289742": Public_toilet_3289742Icon,
  "nm-purchase_order_12341403": Purchase_order_12341403Icon,
  "nm-quality_10498248": Quality_10498248Icon,
  "nm-quality_control_4374854": Quality_control_4374854Icon,
  "nm-quality_control_4862471": Quality_control_4862471Icon,
  "nm-quality_control_9789613": Quality_control_9789613Icon,
  "nm-question_12544380": Question_12544380Icon,
  "nm-question_1746624": Question_1746624Icon,
  "nm-question_3156280": Question_3156280Icon,
  "nm-queue_11220153": Queue_11220153Icon,
  "nm-quotation_4388366": Quotation_4388366Icon,
  "nm-quote_16134577": Quote_16134577Icon,
  "nm-quote_request_7024144": Quote_request_7024144Icon,
  "nm-radiology_15192747": Radiology_15192747Icon,
  "nm-ranking_3162263": Ranking_3162263Icon,
  "nm-rating_1322236": Rating_1322236Icon,
  "nm-raw_materials_12981797": Raw_materials_12981797Icon,
  "nm-real_estate_9116574": Real_estate_9116574Icon,
  "nm-real_estate_agent_6333471": Real_estate_agent_6333471Icon,
  "nm-real_time_3043540": Real_time_3043540Icon,
  "nm-receipt_11153374": Receipt_11153374Icon,
  "nm-receipt_1554608": Receipt_1554608Icon,
  "nm-receipt_869698": Receipt_869698Icon,
  "nm-receipt_9069344": Receipt_9069344Icon,
  "nm-receipt_9328666": Receipt_9328666Icon,
  "nm-received_4536732": Received_4536732Icon,
  "nm-receptionist_17625282": Receptionist_17625282Icon,
  "nm-recipe_3802177": Recipe_3802177Icon,
  "nm-referral_18841524": Referral_18841524Icon,
  "nm-refinance_13659814": Refinance_13659814Icon,
  "nm-refresh_2546743": Refresh_2546743Icon,
  "nm-refund_2366081": Refund_2366081Icon,
  "nm-register_17814618": Register_17814618Icon,
  "nm-registration_certificate_14001395": Registration_certificate_14001395Icon,
  "nm-regulation_11210307": Regulation_11210307Icon,
  "nm-regulation_13061404": Regulation_13061404Icon,
  "nm-regulation_9926191": Regulation_9926191Icon,
  "nm-regulatory_12245250": Regulatory_12245250Icon,
  "nm-relax_3063783": Relax_3063783Icon,
  "nm-remove_file_3686931": Remove_file_3686931Icon,
  "nm-renewal_12003696": Renewal_12003696Icon,
  "nm-renewal_18564395": Renewal_18564395Icon,
  "nm-renewal_18564409": Renewal_18564409Icon,
  "nm-rent_2590451": Rent_2590451Icon,
  "nm-rent_4820436": Rent_4820436Icon,
  "nm-reporting_13089755": Reporting_13089755Icon,
  "nm-reports_12727897": Reports_12727897Icon,
  "nm-report_14323490": Report_14323490Icon,
  "nm-report_1450932": Report_1450932Icon,
  "nm-report_16773533": Report_16773533Icon,
  "nm-report_3875734": Report_3875734Icon,
  "nm-report_5656296": Report_5656296Icon,
  "nm-report_6199776": Report_6199776Icon,
  "nm-report_6345343": Report_6345343Icon,
  "nm-report_9504986": Report_9504986Icon,
  "nm-report_card_13334856": Report_card_13334856Icon,
  "nm-report_card_3819810": Report_card_3819810Icon,
  "nm-request_18857268": Request_18857268Icon,
  "nm-request_2117251": Request_2117251Icon,
  "nm-request_for_proposal_11000717": Request_for_proposal_11000717Icon,
  "nm-request_for_proposal_12321839": Request_for_proposal_12321839Icon,
  "nm-requirement_10326046": Requirement_10326046Icon,
  "nm-requirement_12048812": Requirement_12048812Icon,
  "nm-requisition_17235067": Requisition_17235067Icon,
  "nm-research_9419215": Research_9419215Icon,
  "nm-residential_13519264": Residential_13519264Icon,
  "nm-resignation_10436019": Resignation_10436019Icon,
  "nm-resignation_7376570": Resignation_7376570Icon,
  "nm-resource_allocation_13728428": Resource_allocation_13728428Icon,
  "nm-responsibility_10172476": Responsibility_10172476Icon,
  "nm-restaurant_3208003": Restaurant_3208003Icon,
  "nm-restaurant_561382": Restaurant_561382Icon,
  "nm-return_11722917": Return_11722917Icon,
  "nm-return_16117131": Return_16117131Icon,
  "nm-return_1671017": Return_1671017Icon,
  "nm-return_2801689": Return_2801689Icon,
  "nm-return_9252729": Return_9252729Icon,
  "nm-return_box_5469919": Return_box_5469919Icon,
  "nm-reverse_logistics_18248683": Reverse_logistics_18248683Icon,
  "nm-review_3168622": Review_3168622Icon,
  "nm-revision_18857103": Revision_18857103Icon,
  "nm-rewards_6062118": Rewards_6062118Icon,
  "nm-rfq_18564043": Rfq_18564043Icon,
  "nm-risk_12315850": Risk_12315850Icon,
  "nm-room_489874": Room_489874Icon,
  "nm-room_service_3575841": Room_service_3575841Icon,
  "nm-round_16199578": Round_16199578Icon,
  "nm-route_15546556": Route_15546556Icon,
  "nm-route_3061732": Route_3061732Icon,
  "nm-ruler_18994252": Ruler_18994252Icon,
  "nm-rules_2046915": Rules_2046915Icon,
  "nm-running_repair_man_with_wrench_and_kit_25559": Running_repair_man_with_wrench_and_kit_25559Icon,
  "nm-sacrifice_15942674": Sacrifice_15942674Icon,
  "nm-safe_2208007": Safe_2208007Icon,
  "nm-safe_box_2676779": Safe_box_2676779Icon,
  "nm-salary_13441695": Salary_13441695Icon,
  "nm-salary_1672164": Salary_1672164Icon,
  "nm-salary_18566499": Salary_18566499Icon,
  "nm-sale_5959799": Sale_5959799Icon,
  "nm-sale_8480947": Sale_8480947Icon,
  "nm-save_money_1611179": Save_money_1611179Icon,
  "nm-saving_11915929": Saving_11915929Icon,
  "nm-scale_16182041": Scale_16182041Icon,
  "nm-schedule_3107295": Schedule_3107295Icon,
  "nm-schedule_3215495": Schedule_3215495Icon,
  "nm-schedule_8718753": Schedule_8718753Icon,
  "nm-schedule_9375984": Schedule_9375984Icon,
  "nm-schedule_9640755": Schedule_9640755Icon,
  "nm-school_2602412": School_2602412Icon,
  "nm-school_4710565": School_4710565Icon,
  "nm-school_bus_3471534": School_bus_3471534Icon,
  "nm-search_2820167": Search_2820167Icon,
  "nm-season_4360322": Season_4360322Icon,
  "nm-seating_area_18868370": Seating_area_18868370Icon,
  "nm-secure_9461347": Secure_9461347Icon,
  "nm-security_10235668": Security_10235668Icon,
  "nm-security_17404290": Security_17404290Icon,
  "nm-security_2058432": Security_2058432Icon,
  "nm-sedan_2736918": Sedan_2736918Icon,
  "nm-send_18857153": Send_18857153Icon,
  "nm-send_file_6601155": Send_file_6601155Icon,
  "nm-services_11671609": Services_11671609Icon,
  "nm-services_12003833": Services_12003833Icon,
  "nm-services_14784839": Services_14784839Icon,
  "nm-service_1649375": Service_1649375Icon,
  "nm-service_4692103": Service_4692103Icon,
  "nm-service_center_1698510": Service_center_1698510Icon,
  "nm-service_station_7600849": Service_station_7600849Icon,
  "nm-settings_15477908": Settings_15477908Icon,
  "nm-settings_2099058": Settings_2099058Icon,
  "nm-settings_6057870": Settings_6057870Icon,
  "nm-setting_1787641": Setting_1787641Icon,
  "nm-setting_3210045": Setting_3210045Icon,
  "nm-setting_5470294": Setting_5470294Icon,
  "nm-shared_folder_1045537": Shared_folder_1045537Icon,
  "nm-shelf_3396325": Shelf_3396325Icon,
  "nm-shift_5538633": Shift_5538633Icon,
  "nm-shift_5539726": Shift_5539726Icon,
  "nm-shipped_411763": Shipped_411763Icon,
  "nm-shipping_11153410": Shipping_11153410Icon,
  "nm-shipping_18532922": Shipping_18532922Icon,
  "nm-shipping_cost_11000652": Shipping_cost_11000652Icon,
  "nm-shipping_location_17573458": Shipping_location_17573458Icon,
  "nm-ship_2485084": Ship_2485084Icon,
  "nm-shopping_13630745": Shopping_13630745Icon,
  "nm-shopping_4183908": Shopping_4183908Icon,
  "nm-shortcut_9784396": Shortcut_9784396Icon,
  "nm-signing_3130444": Signing_3130444Icon,
  "nm-six_4626510": Six_4626510Icon,
  "nm-skill_development_9953680": Skill_development_9953680Icon,
  "nm-sla_17064924": Sla_17064924Icon,
  "nm-sleep_11117712": Sleep_11117712Icon,
  "nm-slot_machine_3076839": Slot_machine_3076839Icon,
  "nm-smartphone_18462159": Smartphone_18462159Icon,
  "nm-smart_temperature_7882983": Smart_temperature_7882983Icon,
  "nm-smelting_14400846": Smelting_14400846Icon,
  "nm-snowflake_5795206": Snowflake_5795206Icon,
  "nm-sorting_18771472": Sorting_18771472Icon,
  "nm-specification_6207279": Specification_6207279Icon,
  "nm-split_1541211": Split_1541211Icon,
  "nm-sponsorship_17788130": Sponsorship_17788130Icon,
  "nm-sponsorship_18824056": Sponsorship_18824056Icon,
  "nm-square_11287293": Square_11287293Icon,
  "nm-stacks_12305887": Stacks_12305887Icon,
  "nm-standards_18575239": Standards_18575239Icon,
  "nm-standard_8439144": Standard_8439144Icon,
  "nm-standard_operating_procedures_16985619": Standard_operating_procedures_16985619Icon,
  "nm-stand_3306951": Stand_3306951Icon,
  "nm-status_8917343": Status_8917343Icon,
  "nm-stock_6902435": Stock_6902435Icon,
  "nm-stock_keeping_unit_12141504": Stock_keeping_unit_12141504Icon,
  "nm-stop_3178618": Stop_3178618Icon,
  "nm-storage_2728486": Storage_2728486Icon,
  "nm-storage_6015470": Storage_6015470Icon,
  "nm-storyboard_12577375": Storyboard_12577375Icon,
  "nm-strategy_planning_16743863": Strategy_planning_16743863Icon,
  "nm-student_8892896": Student_8892896Icon,
  "nm-subcontracting_14458891": Subcontracting_14458891Icon,
  "nm-subscribe_5671858": Subscribe_5671858Icon,
  "nm-sub_8835627": Sub_8835627Icon,
  "nm-suggestion_2593658": Suggestion_2593658Icon,
  "nm-supplier_12321920": Supplier_12321920Icon,
  "nm-supplier_8071262": Supplier_8071262Icon,
  "nm-supply_chain_4813885": Supply_chain_4813885Icon,
  "nm-surgeon_7031573": Surgeon_7031573Icon,
  "nm-surgery_room_4006097": Surgery_room_4006097Icon,
  "nm-survey_10930719": Survey_10930719Icon,
  "nm-sync_data_16856249": Sync_data_16856249Icon,
  "nm-system_16454641": System_16454641Icon,
  "nm-talent_15595789": Talent_15595789Icon,
  "nm-tape_measure_2739200": Tape_measure_2739200Icon,
  "nm-tariff_14104983": Tariff_14104983Icon,
  "nm-task_18312178": Task_18312178Icon,
  "nm-task_2098313": Task_2098313Icon,
  "nm-task_3774569": Task_3774569Icon,
  "nm-task_actions_18988010": Task_actions_18988010Icon,
  "nm-task_complete_17377933": Task_complete_17377933Icon,
  "nm-task_list_2029830": Task_list_2029830Icon,
  "nm-task_management_15762588": Task_management_15762588Icon,
  "nm-taxation_17756286": Taxation_17756286Icon,
  "nm-taxes_4749988": Taxes_4749988Icon,
  "nm-team_11049551": Team_11049551Icon,
  "nm-team_13483396": Team_13483396Icon,
  "nm-team_management_8840707": Team_management_8840707Icon,
  "nm-technical_support_4230997": Technical_support_4230997Icon,
  "nm-technician_9922689": Technician_9922689Icon,
  "nm-temperature_1872808": Temperature_1872808Icon,
  "nm-temperature_8775923": Temperature_8775923Icon,
  "nm-templates_559907": Templates_559907Icon,
  "nm-tender_17148344": Tender_17148344Icon,
  "nm-tender_18699187": Tender_18699187Icon,
  "nm-terms_11582779": Terms_11582779Icon,
  "nm-terms_and_conditions_16331104": Terms_and_conditions_16331104Icon,
  "nm-terms_and_conditions_4436515": Terms_and_conditions_4436515Icon,
  "nm-test_2916315": Test_2916315Icon,
  "nm-test_3204284": Test_3204284Icon,
  "nm-test_results_15756461": Test_results_15756461Icon,
  "nm-test_tube_3373616": Test_tube_3373616Icon,
  "nm-text_11024126": Text_11024126Icon,
  "nm-text_analytics_16137864": Text_analytics_16137864Icon,
  "nm-theme_10134298": Theme_10134298Icon,
  "nm-three_4626487": Three_4626487Icon,
  "nm-ticket_6977799": Ticket_6977799Icon,
  "nm-time_3064481": Time_3064481Icon,
  "nm-time_is_money_6404725": Time_is_money_6404725Icon,
  "nm-time_management_11862147": Time_management_11862147Icon,
  "nm-time_sheet_4388165": Time_sheet_4388165Icon,
  "nm-toolkit_4228902": Toolkit_4228902Icon,
  "nm-tool_2760119": Tool_2760119Icon,
  "nm-top_up_6379125": Top_up_6379125Icon,
  "nm-tourism_2560124": Tourism_2560124Icon,
  "nm-tour_guide_3284377": Tour_guide_3284377Icon,
  "nm-tour_guide_9636012": Tour_guide_9636012Icon,
  "nm-to_do_list_18645372": To_do_list_18645372Icon,
  "nm-to_do_list_3647695": To_do_list_3647695Icon,
  "nm-track_4974331": Track_4974331Icon,
  "nm-track_delivery_12624957": Track_delivery_12624957Icon,
  "nm-training_12650217": Training_12650217Icon,
  "nm-transactional_data_18253441": Transactional_data_18253441Icon,
  "nm-transaction_11826754": Transaction_11826754Icon,
  "nm-transfer_2818813": Transfer_2818813Icon,
  "nm-transfer_757515": Transfer_757515Icon,
  "nm-translation_2793765": Translation_2793765Icon,
  "nm-transport_15841669": Transport_15841669Icon,
  "nm-travel_3376684": Travel_3376684Icon,
  "nm-travel_agency_4586974": Travel_agency_4586974Icon,
  "nm-trolley_4664272": Trolley_4664272Icon,
  "nm-troubleshooting_18643300": Troubleshooting_18643300Icon,
  "nm-trustworthiness_12772408": Trustworthiness_12772408Icon,
  "nm-two_4626479": Two_4626479Icon,
  "nm-typography_14282875": Typography_14282875Icon,
  "nm-unsecured_8900232": Unsecured_8900232Icon,
  "nm-update_4059752": Update_4059752Icon,
  "nm-update_4067725": Update_4067725Icon,
  "nm-update_7159542": Update_7159542Icon,
  "nm-update_list_14752951": Update_list_14752951Icon,
  "nm-updating_2990003": Updating_2990003Icon,
  "nm-usability_12465756": Usability_12465756Icon,
  "nm-user_1515713": User_1515713Icon,
  "nm-user_456283": User_456283Icon,
  "nm-user_favourite_17123247": User_favourite_17123247Icon,
  "nm-vacancy_4288089": Vacancy_4288089Icon,
  "nm-vacation_10403845": Vacation_10403845Icon,
  "nm-vacation_16984394": Vacation_16984394Icon,
  "nm-vacation_18238495": Vacation_18238495Icon,
  "nm-vacation_18747738": Vacation_18747738Icon,
  "nm-validating_ticket_7377200": Validating_ticket_7377200Icon,
  "nm-value_1528669": Value_1528669Icon,
  "nm-variant_12062492": Variant_12062492Icon,
  "nm-vehicle_12359514": Vehicle_12359514Icon,
  "nm-vehicle_12359527": Vehicle_12359527Icon,
  "nm-venture_7261828": Venture_7261828Icon,
  "nm-visa_15916931": Visa_15916931Icon,
  "nm-vision_14014408": Vision_14014408Icon,
  "nm-visitor_753114": Visitor_753114Icon,
  "nm-visit_16841242": Visit_16841242Icon,
  "nm-voltage_indicator_12191265": Voltage_indicator_12191265Icon,
  "nm-voucher_13280369": Voucher_13280369Icon,
  "nm-voucher_481387": Voucher_481387Icon,
  "nm-voucher_7183794": Voucher_7183794Icon,
  "nm-waiting_list_11209494": Waiting_list_11209494Icon,
  "nm-wallet_1198393": Wallet_1198393Icon,
  "nm-warehouse_10638567": Warehouse_10638567Icon,
  "nm-warehouse_702455": Warehouse_702455Icon,
  "nm-warehouse_9597872": Warehouse_9597872Icon,
  "nm-warning_159469": Warning_159469Icon,
  "nm-warranty_card_16868866": Warranty_card_16868866Icon,
  "nm-weighing_machine_2929016": Weighing_machine_2929016Icon,
  "nm-weight_15169691": Weight_15169691Icon,
  "nm-whatsapp_2582600": Whatsapp_2582600Icon,
  "nm-worker_782899": Worker_782899Icon,
  "nm-worker_9936521": Worker_9936521Icon,
  "nm-workflow_5365050": Workflow_5365050Icon,
  "nm-workflow_8317775": Workflow_8317775Icon,
  "nm-working_hours_18103931": Working_hours_18103931Icon,
  "nm-working_time_7626204": Working_time_7626204Icon,
  "nm-workspace_9787259": Workspace_9787259Icon,
  "nm-work_plan_12422852": Work_plan_12422852Icon,
  "nm-world_10690961": World_10690961Icon,
  "nm-write_13785332": Write_13785332Icon,
  "nm-write_14944972": Write_14944972Icon,
  "nm-writing_15889631": Writing_15889631Icon,
  "nm-x_rays_10160241": X_rays_10160241Icon,
  "nm-eye-check": EyeCheckIcon,
  "nm-arrow-fit-height": ArowFitHeightIcon,
  "nm-adjustments": AdjustmentsIcon,
  "nm-add-image": AddImageIcon,
}
export const NamaIconList: GoogleMaterialIcon[] = [
  {name: "nm-accounting"},
  {name: "nm-accounting-revenue"},
  {name: "nm-actions"},
  {name: "nm-add-comment"},
  {name: "nm-add-day"},
  {name: "nm-add-grid"},
  {name: "nm-add-groups"},
  {name: "nm-add"},
  {name: "nm-add-page"},
  {name: "nm-administration"},
  {name: "nm-api"},
  {name: "nm-app-store"},
  {name: "nm-assembly-docs"},
  {name: "nm-assets"},
  {name: "nm-auditing"},
  {name: "nm-balance"},
  {name: "nm-bank-l-c"},
  {name: "nm-bank-loans"},
  {name: "nm-banks"},
  {name: "nm-basic"},
  {name: "nm-basic-information"},
  {name: "nm-blocks"},
  {name: "nm-blood-banks"},
  {name: "nm-budgets"},
  {name: "nm-cache"},
  {name: "nm-capabilities"},
  {name: "nm-car-insurance"},
  {name: "nm-cartoon"},
  {name: "nm-cashier"},
  {name: "nm-cashiers"},
  {name: "nm-charge-invoice"},
  {name: "nm-check-box"},
  {name: "nm-check-circle"},
  {name: "nm-check"},
  {name: "nm-cheques"},
  {name: "nm-chief"},
  {name: "nm-circulars"},
  {name: "nm-clipboard-check"},
  {name: "nm-closing-invoice"},
  {name: "nm-code"},
  {name: "nm-columns"},
  {name: "nm-compact"},
  {name: "nm-compare"},
  {name: "nm-component"},
  {name: "nm-composite"},
  {name: "nm-contracting"},
  {name: "nm-contractor-contracting"},
  {name: "nm-conveyor"},
  {name: "nm-copy"},
  {name: "nm-copy-to-clipboard"},
  {name: "nm-cost"},
  {name: "nm-costs"},
  {name: "nm-create-documents"},
  {name: "nm-create"},
  {name: "nm-create-report"},
  {name: "nm-credit-facilities"},
  {name: "nm-criteria"},
  {name: "nm-crm-dashboard"},
  {name: "nm-crm"},
  {name: "nm-custody-of-assets"},
  {name: "nm-custodys"},
  {name: "nm-customers"},
  {name: "nm-dark-mode"},
  {name: "nm-dashboards"},
  {name: "nm-data-model"},
  {name: "nm-definitions"},
  {name: "nm-delivery-setting"},
  {name: "nm-detail-accounts"},
  {name: "nm-dimensions"},
  {name: "nm-discard"},
  {name: "nm-discussion"},
  {name: "nm-displayed-columns"},
  {name: "nm-dms-location"},
  {name: "nm-document"},
  {name: "nm-document-management"},
  {name: "nm-document-management-system"},
  {name: "nm-document-revision"},
  {name: "nm-documents"},
  {name: "nm-download"},
  {name: "nm-drag"},
  {name: "nm-drag-row-indicator"},
  {name: "nm-dues-liquidation-and-firing"},
  {name: "nm-ecommerce"},
  {name: "nm-ecpa"},
  {name: "nm-edit-screen"},
  {name: "nm-education"},
  {name: "nm-error"},
  {name: "nm-expense"},
  {name: "nm-export-all"},
  {name: "nm-export-group"},
  {name: "nm-export"},
  {name: "nm-export-option"},
  {name: "nm-export-page"},
  {name: "nm-favourites"},
  {name: "nm-favourites-minus"},
  {name: "nm-favourites-plus"},
  {name: "nm-feeding"},
  {name: "nm-fields"},
  {name: "nm-fill"},
  {name: "nm-financial-commitment-management"},
  {name: "nm-financial"},
  {name: "nm-financial-statement"},
  {name: "nm-fines"},
  {name: "nm-fixed-asset-letter-of-credit"},
  {name: "nm-fixed-asset-maintenance"},
  {name: "nm-fixed-assets"},
  {name: "nm-fixed-deposits"},
  {name: "nm-focus"},
  {name: "nm-folder"},
  {name: "nm-folders"},
  {name: "nm-freight-management-system"},
  {name: "nm-google-play"},
  {name: "nm-grid"},
  {name: "nm-group"},
  {name: "nm-health-insurance"},
  {name: "nm-home"},
  {name: "nm-horizontal"},
  {name: "nm-hospital-management-system"},
  {name: "nm-hospital-structure"},
  {name: "nm-housing-documents"},
  {name: "nm-housing-files"},
  {name: "nm-housing"},
  {name: "nm-human-resource"},
  {name: "nm-import"},
  {name: "nm-information"},
  {name: "nm-input"},
  {name: "nm-internal-link"},
  {name: "nm-inventory"},
  {name: "nm-inventory-management"},
  {name: "nm-investment-docs"},
  {name: "nm-investment-documents"},
  {name: "nm-investment"},
  {name: "nm-investment-portfolios"},
  {name: "nm-invoice"},
  {name: "nm-iso"},
  {name: "nm-issue-documents"},
  {name: "nm-item-voting"},
  {name: "nm-job-orders"},
  {name: "nm-lab"},
  {name: "nm-laboratory-tests"},
  {name: "nm-laws"},
  {name: "nm-layout"},
  {name: "nm-letter-of-credit"},
  {name: "nm-letter-of-guarantees"},
  {name: "nm-list-plus"},
  {name: "nm-list-vew"},
  {name: "nm-loans-and-installments"},
  {name: "nm-log-files"},
  {name: "nm-logout"},
  {name: "nm-main-files"},
  {name: "nm-main"},
  {name: "nm-maintenance-contracting"},
  {name: "nm-maintenance-documents"},
  {name: "nm-maintenance-files"},
  {name: "nm-maintenance"},
  {name: "nm-management-and-organization"},
  {name: "nm-management-documents"},
  {name: "nm-manufacturing"},
  {name: "nm-manufacturing-molds"},
  {name: "nm-marketing"},
  {name: "nm-master-files"},
  {name: "nm-material-resource-planning"},
  {name: "nm-meals"},
  {name: "nm-medical-overhead"},
  {name: "nm-medical-services"},
  {name: "nm-meeting"},
  {name: "nm-micro"},
  {name: "nm-migration"},
  {name: "nm-mini-composite"},
  {name: "nm-miscellaneous"},
  {name: "nm-mobile-apps"},
  {name: "nm-modified-blocks"},
  {name: "nm-modified-grid"},
  {name: "nm-modified-groups"},
  {name: "nm-monitoring"},
  {name: "nm-name"},
  {name: "nm-notification"},
  {name: "nm-notifications"},
  {name: "nm-old-pc"},
  {name: "nm-other"},
  {name: "nm-outsource-manufacturing"},
  {name: "nm-out-sourcing-orders"},
  {name: "nm-pages"},
  {name: "nm-party-evaluations"},
  {name: "nm-payroll"},
  {name: "nm-performance-indicators"},
  {name: "nm-person"},
  {name: "nm-pharmacies"},
  {name: "nm-physical-therapy"},
  {name: "nm-point-of-sale"},
  {name: "nm-prevent"},
  {name: "nm-prevent-option"},
  {name: "nm-price-voting"},
  {name: "nm-priority"},
  {name: "nm-project-contracting"},
  {name: "nm-projects"},
  {name: "nm-property"},
  {name: "nm-purchases"},
  {name: "nm-purge-documents"},
  {name: "nm-quad-layout"},
  {name: "nm-quality"},
  {name: "nm-questionairs"},
  {name: "nm-question-answers"},
  {name: "nm-queue-service"},
  {name: "nm-radiology"},
  {name: "nm-real-estate-and-property"},
  {name: "nm-receipt-documents"},
  {name: "nm-reconciliations"},
  {name: "nm-record"},
  {name: "nm-recruitment"},
  {name: "nm-register"},
  {name: "nm-regulations"},
  {name: "nm-reload"},
  {name: "nm-remarks"},
  {name: "nm-rental-assets"},
  {name: "nm-rents"},
  {name: "nm-report"},
  {name: "nm-reports"},
  {name: "nm-reports-monitoring"},
  {name: "nm-research-and-development"},
  {name: "nm-reservation-documents"},
  {name: "nm-resizer"},
  {name: "nm-reward-and-penalty"},
  {name: "nm-salary-configurations"},
  {name: "nm-sales"},
  {name: "nm-sales-prices-and-offers"},
  {name: "nm-school-trips"},
  {name: "nm-screen"},
  {name: "nm-screen-modifer"},
  {name: "nm-searcher-template"},
  {name: "nm-search"},
  {name: "nm-security"},
  {name: "nm-service-center"},
  {name: "nm-service-documents"},
  {name: "nm-settings"},
  {name: "nm-shipping"},
  {name: "nm-social-insurance"},
  {name: "nm-sort"},
  {name: "nm-sql"},
  {name: "nm-stock-taking"},
  {name: "nm-stock-trans-documents"},
  {name: "nm-stock-transfer-docs"},
  {name: "nm-support"},
  {name: "nm-surgeries"},
  {name: "nm-surgery-package"},
  {name: "nm-system-update"},
  {name: "nm-task-execution"},
  {name: "nm-task"},
  {name: "nm-tasks"},
  {name: "nm-tax-payer-configuration"},
  {name: "nm-team"},
  {name: "nm-template-columns"},
  {name: "nm-tenders"},
  {name: "nm-tests"},
  {name: "nm-theme-editor"},
  {name: "nm-time-attendance"},
  {name: "nm-tools"},
  {name: "nm-training"},
  {name: "nm-transactions"},
  {name: "nm-travel"},
  {name: "nm-treasury-bill"},
  {name: "nm-upload-invoice"},
  {name: "nm-user"},
  {name: "nm-vacations"},
  {name: "nm-vector"},
  {name: "nm-vehicles"},
  {name: "nm-vertical"},
  {name: "nm-view-customization"},
  {name: "nm-view"},
  {name: "nm-visas"},
  {name: "nm-waste-management"},
  {name: "nm-weight-scale"},
  {name: "nm-work-list"},
  {name: "nm-action-block"},
  {name: "nm-add-line"},
  {name: "nm-add-record"},
  {name: "nm-approval"},
  {name: "nm-arrow"},
  {name: "nm-ask-a-i"},
  {name: "nm-chat-history"},
  {name: "nm-dash-board-block"},
  {name: "nm-delete"},
  {name: "nm-dialog-close"},
  {name: "nm-dislike"},
  {name: "nm-d-o-c-x"},
  {name: "nm-duplicate"},
  {name: "nm-edit"},
  {name: "nm-enable-selection"},
  {name: "nm-enter"},
  {name: "nm-expert-mode"},
  {name: "nm-first"},
  {name: "nm-go-to-line"},
  {name: "nm-grid-block"},
  {name: "nm-group-block"},
  {name: "nm-last"},
  {name: "nm-list-block"},
  {name: "nm-list-view"},
  {name: "nm-more"},
  {name: "nm-multi-copy"},
  {name: "nm-next"},
  {name: "nm-p-d-f"},
  {name: "nm-p-p-t-x"},
  {name: "nm-previous"},
  {name: "nm-print-as"},
  {name: "nm-print"},
  {name: "nm-refresh"},
  {name: "nm-remove-filter"},
  {name: "nm-report-block"},
  {name: "nm-revise"},
  {name: "nm-save-and-continue"},
  {name: "nm-save-draft"},
  {name: "nm-save"},
  {name: "nm-send-email"},
  {name: "nm-show-help-msgs"},
  {name: "nm-switch"},
  {name: "nm-timeline"},
  {name: "nm-tooltip"},
  {name: "nm-tooltip-list"},
  {name: "nm-tree-view"},
  {name: "nm-un-revise"},
  {name: "nm-win-close"},
  {name: "nm-win-maximize"},
  {name: "nm-x-l-s-x"},
  {name: "nm-zoom-in"},
  {name: "nm-zoom-out"},
  {name: "nm-asc-sort"},
  {name: "nm-auto-fit-col"},
  {name: "nm-auto-fit-col-to-content"},
  {name: "nm-export-excel"},
  {name: "nm-filter"},
  {name: "nm-filter-list"},
  {name: "nm-table-columns"},
  {name: "nm-advanced-search"},
  {name: "nm-ai"},
  {name: "nm-approve"},
  {name: "nm-attachment"},
  {name: "nm-auto-save"},
  {name: "nm-calendar"},
  {name: "nm-cancel"},
  {name: "nm-chat"},
  {name: "nm-clock"},
  {name: "nm-color-palette"},
  {name: "nm-criteria-filter"},
  {name: "nm-descending-sort"},
  {name: "nm-drop-down-close"},
  {name: "nm-edit-text"},
  {name: "nm-email"},
  {name: "nm-employee"},
  {name: "nm-empty-search"},
  {name: "nm-exception"},
  {name: "nm-expand"},
  {name: "nm-facebook"},
  {name: "nm-fail"},
  {name: "nm-initial"},
  {name: "nm-instagram"},
  {name: "nm-invalid"},
  {name: "nm-linkedin"},
  {name: "nm-link"},
  {name: "nm-loading"},
  {name: "nm-lock"},
  {name: "nm-map-location"},
  {name: "nm-menu"},
  {name: "nm-microphone"},
  {name: "nm-pending"},
  {name: "nm-phone-call"},
  {name: "nm-play"},
  {name: "nm-previous-step"},
  {name: "nm-processed"},
  {name: "nm-question-list"},
  {name: "nm-rejected"},
  {name: "nm-reply"},
  {name: "nm-retry"},
  {name: "nm-returned"},
  {name: "nm-revised-level"},
  {name: "nm-revoked"},
  {name: "nm-scan"},
  {name: "nm-send"},
  {name: "nm-signature"},
  {name: "nm-snapchat"},
  {name: "nm-sort-reset"},
  {name: "nm-stable"},
  {name: "nm-supervisor"},
  {name: "nm-tiktok"},
  {name: "nm-translation"},
  {name: "nm-tree-list"},
  {name: "nm-twitter"},
  {name: "nm-undo"},
  {name: "nm-waiting"},
  {name: "nm-wave"},
  {name: "nm-whats-app"},
  {name: "nm-youtube"},
  {name: "nm-access_denied_2186052"},
  {name: "nm-accomodation_16681378"},
  {name: "nm-accountability_9981536"},
  {name: "nm-accounting_10331873"},
  {name: "nm-accounting_1570887"},
  {name: "nm-accounting_4979100"},
  {name: "nm-account_1233162"},
  {name: "nm-account_maintenance_17640422"},
  {name: "nm-acquisition_12134708"},
  {name: "nm-address_3365020"},
  {name: "nm-add_10563482"},
  {name: "nm-add_12517897"},
  {name: "nm-adjustment_4289046"},
  {name: "nm-adjust_9710826"},
  {name: "nm-administrative_fine_9897376"},
  {name: "nm-administrator_8921054"},
  {name: "nm-agreement_1278586"},
  {name: "nm-agreement_1492552"},
  {name: "nm-agreement_17227040"},
  {name: "nm-agreement_4504481"},
  {name: "nm-agreement_4604417"},
  {name: "nm-ai_17653338"},
  {name: "nm-ai_powered_models_16209773"},
  {name: "nm-algebra_4010849"},
  {name: "nm-allocation_12708441"},
  {name: "nm-analysis_18362456"},
  {name: "nm-analysis_809497"},
  {name: "nm-analytics_6012662"},
  {name: "nm-api_103093"},
  {name: "nm-application_10227469"},
  {name: "nm-application_15875439"},
  {name: "nm-application_18277246"},
  {name: "nm-application_2245059"},
  {name: "nm-application_9791628"},
  {name: "nm-appointment_request_12630733"},
  {name: "nm-approved_10721349"},
  {name: "nm-approved_11442743"},
  {name: "nm-approved_942833"},
  {name: "nm-approve_7270275"},
  {name: "nm-approve_9926380"},
  {name: "nm-architecture_9398782"},
  {name: "nm-archive_1721906"},
  {name: "nm-art_5311124"},
  {name: "nm-ask_2859733"},
  {name: "nm-assembly_1118470"},
  {name: "nm-assessment_11112891"},
  {name: "nm-assessment_12199381"},
  {name: "nm-asset_12062393"},
  {name: "nm-asset_12300653"},
  {name: "nm-asset_12885326"},
  {name: "nm-asset_4002065"},
  {name: "nm-asset_allocation_11376888"},
  {name: "nm-asset_allocation_12315713"},
  {name: "nm-assortment_4827324"},
  {name: "nm-assurance_4157073"},
  {name: "nm-attendance_6611895"},
  {name: "nm-attendance_device_16230724"},
  {name: "nm-auction_783196"},
  {name: "nm-audition_10227648"},
  {name: "nm-audit_4307934"},
  {name: "nm-automation_10872051"},
  {name: "nm-automation_15569965"},
  {name: "nm-automation_9325681"},
  {name: "nm-autonomous_car_2941989"},
  {name: "nm-avatar_266134"},
  {name: "nm-award_badge_11835451"},
  {name: "nm-b2b_5915166"},
  {name: "nm-bad_9125203"},
  {name: "nm-balance_16680712"},
  {name: "nm-balance_sheet_8682846"},
  {name: "nm-ballot_1533927"},
  {name: "nm-bank_1669617"},
  {name: "nm-bank_3635987"},
  {name: "nm-bank_7969361"},
  {name: "nm-bank_account_8432416"},
  {name: "nm-bank_account_9359512"},
  {name: "nm-bank_statement_3742514"},
  {name: "nm-bank_transfer_2787531"},
  {name: "nm-barcode_16912866"},
  {name: "nm-bar_chart_478544"},
  {name: "nm-bar_graph_8439433"},
  {name: "nm-battery_4115361"},
  {name: "nm-bell_17465958"},
  {name: "nm-benchmarking_18609810"},
  {name: "nm-bid_2162213"},
  {name: "nm-billing_17625287"},
  {name: "nm-bills_2359971"},
  {name: "nm-bill_14895794"},
  {name: "nm-bill_1763436"},
  {name: "nm-bill_2976378"},
  {name: "nm-bill_4545554"},
  {name: "nm-bill_7372992"},
  {name: "nm-bill_781862"},
  {name: "nm-bill_of_lading_14198953"},
  {name: "nm-biometric_attendance_12767435"},
  {name: "nm-block_user_7838125"},
  {name: "nm-blood_test_12485937"},
  {name: "nm-blood_test_16780038"},
  {name: "nm-blood_tube_7678363"},
  {name: "nm-body_paint_repair_13401864"},
  {name: "nm-bond_13473066"},
  {name: "nm-bookmark_13124718"},
  {name: "nm-book_1211755"},
  {name: "nm-book_15947937"},
  {name: "nm-book_3238973"},
  {name: "nm-book_9257188"},
  {name: "nm-box_13964534"},
  {name: "nm-box_14116892"},
  {name: "nm-box_1524539"},
  {name: "nm-box_9962216"},
  {name: "nm-branch_6712276"},
  {name: "nm-brand_3886706"},
  {name: "nm-brand_awareness_17328280"},
  {name: "nm-briefcase_17989959"},
  {name: "nm-budgeting_8123485"},
  {name: "nm-budget_4341568"},
  {name: "nm-budget_7615720"},
  {name: "nm-budget_9918832"},
  {name: "nm-budget_planning_11048265"},
  {name: "nm-builder_7152038"},
  {name: "nm-building_1324872"},
  {name: "nm-businessman_3630246"},
  {name: "nm-business_14525232"},
  {name: "nm-business_15139054"},
  {name: "nm-business_and_finance_1773345"},
  {name: "nm-business_people_9606006"},
  {name: "nm-business_plan_11925596"},
  {name: "nm-business_proposal_6623145"},
  {name: "nm-business_report_4060002"},
  {name: "nm-business_strategy_9140477"},
  {name: "nm-bus_3124381"},
  {name: "nm-calculator_1760539"},
  {name: "nm-calculator_2488980"},
  {name: "nm-calculator_5151275"},
  {name: "nm-calendar_10403035"},
  {name: "nm-calendar_1581943"},
  {name: "nm-calendar_17376753"},
  {name: "nm-calendar_2370264"},
  {name: "nm-calendar_2746028"},
  {name: "nm-campaign_4573251"},
  {name: "nm-cancelation_7516548"},
  {name: "nm-cancel_3037017"},
  {name: "nm-cancel_7868098"},
  {name: "nm-cancel_order_12893893"},
  {name: "nm-cancel_order_13466951"},
  {name: "nm-capability_12133586"},
  {name: "nm-capital_12394258"},
  {name: "nm-capital_17980663"},
  {name: "nm-cards_4748745"},
  {name: "nm-carton_5790352"},
  {name: "nm-car_10105423"},
  {name: "nm-car_14236293"},
  {name: "nm-car_insurance_11442860"},
  {name: "nm-car_insurance_1518645"},
  {name: "nm-car_insurance_1743700"},
  {name: "nm-car_service_1647922"},
  {name: "nm-cashback_7444875"},
  {name: "nm-cashier_2450340"},
  {name: "nm-cashless_payment_4108841"},
  {name: "nm-cash_flow_10842949"},
  {name: "nm-cash_flow_15341964"},
  {name: "nm-cash_machine_4689858"},
  {name: "nm-casting_18362364"},
  {name: "nm-category_4013399"},
  {name: "nm-caution_4601287"},
  {name: "nm-certificate_1470846"},
  {name: "nm-chain_14148805"},
  {name: "nm-change_125860"},
  {name: "nm-chapter_15586789"},
  {name: "nm-chat_2950667"},
  {name: "nm-chat_9742173"},
  {name: "nm-checklists_6735211"},
  {name: "nm-checklist_11458709"},
  {name: "nm-checklist_12681572"},
  {name: "nm-checklist_15169051"},
  {name: "nm-checklist_3336536"},
  {name: "nm-checklist_3750160"},
  {name: "nm-checklist_4342581"},
  {name: "nm-checklist_7050554"},
  {name: "nm-checklist_7547631"},
  {name: "nm-checklist_8214750"},
  {name: "nm-checklist_8719356"},
  {name: "nm-checklist_9752119"},
  {name: "nm-check_13514507"},
  {name: "nm-check_2974151"},
  {name: "nm-check_8719000"},
  {name: "nm-check_list_1721936"},
  {name: "nm-check_list_3406866"},
  {name: "nm-choose_12061689"},
  {name: "nm-chronic_illness_18367611"},
  {name: "nm-cigarette_2925545"},
  {name: "nm-circle_1_10595791"},
  {name: "nm-circle_2_11183354"},
  {name: "nm-circle_7_11183359"},
  {name: "nm-circle_8_10595796"},
  {name: "nm-circle_9_10595797"},
  {name: "nm-citizenship_18278821"},
  {name: "nm-citizenship_7141967"},
  {name: "nm-claim_2419593"},
  {name: "nm-classification_14639636"},
  {name: "nm-classroom_3197831"},
  {name: "nm-cleaning_cart_2975216"},
  {name: "nm-client_support_17373211"},
  {name: "nm-clinic_2222554"},
  {name: "nm-clipboard_13394359"},
  {name: "nm-clipboard_1962592"},
  {name: "nm-clipboard_3022148"},
  {name: "nm-clipboard_8102915"},
  {name: "nm-clipboard_839860"},
  {name: "nm-cli_10237174"},
  {name: "nm-clock_10227441"},
  {name: "nm-clock_4129791"},
  {name: "nm-close_11963953"},
  {name: "nm-coal_1275480"},
  {name: "nm-coding_2010990"},
  {name: "nm-coding_3242120"},
  {name: "nm-collaboration_11992996"},
  {name: "nm-collaboration_5541565"},
  {name: "nm-commentary_1230203"},
  {name: "nm-commission_7028100"},
  {name: "nm-commitment_11671576"},
  {name: "nm-commodity_2973905"},
  {name: "nm-communication_11208135"},
  {name: "nm-company_5741577"},
  {name: "nm-compare_6175740"},
  {name: "nm-competitor_analysis_16314442"},
  {name: "nm-complaint_9375697"},
  {name: "nm-compliance_10521137"},
  {name: "nm-compliance_17474862"},
  {name: "nm-compliant_4252474"},
  {name: "nm-compliant_4961688"},
  {name: "nm-computer_1589642"},
  {name: "nm-computer_16103184"},
  {name: "nm-computer_4007539"},
  {name: "nm-configuration_10618038"},
  {name: "nm-connect_3974952"},
  {name: "nm-consistency_18832178"},
  {name: "nm-construction_12359525"},
  {name: "nm-construction_14243038"},
  {name: "nm-construction_method_14106373"},
  {name: "nm-contacts_18090908"},
  {name: "nm-container_3364160"},
  {name: "nm-container_4459682"},
  {name: "nm-container_7115168"},
  {name: "nm-content_11386335"},
  {name: "nm-contractor_11671674"},
  {name: "nm-contractor_12003757"},
  {name: "nm-contract_10279810"},
  {name: "nm-contract_11000620"},
  {name: "nm-contract_11099161"},
  {name: "nm-contract_12003720"},
  {name: "nm-contract_1275212"},
  {name: "nm-contract_15586801"},
  {name: "nm-contract_17213425"},
  {name: "nm-contract_1721843"},
  {name: "nm-contract_17322641"},
  {name: "nm-contract_17718602"},
  {name: "nm-contract_18601700"},
  {name: "nm-contract_2655351"},
  {name: "nm-contract_2666523"},
  {name: "nm-contract_3985921"},
  {name: "nm-contract_5513696"},
  {name: "nm-contract_5545080"},
  {name: "nm-contract_5545095"},
  {name: "nm-contract_5965822"},
  {name: "nm-contract_6822251"},
  {name: "nm-contract_7352878"},
  {name: "nm-contract_757320"},
  {name: "nm-contract_913393"},
  {name: "nm-contract_9186233"},
  {name: "nm-contract_document_15913380"},
  {name: "nm-controller_1687819"},
  {name: "nm-control_12943317"},
  {name: "nm-conversation_3050431"},
  {name: "nm-conversion_rate_17328299"},
  {name: "nm-cooperation_9139670"},
  {name: "nm-coordinated_17876780"},
  {name: "nm-copy_2874774"},
  {name: "nm-corporation_18666942"},
  {name: "nm-corrugated_16587756"},
  {name: "nm-corruption_5267757"},
  {name: "nm-cost_12573938"},
  {name: "nm-cost_3875852"},
  {name: "nm-cost_5531516"},
  {name: "nm-cost_5656822"},
  {name: "nm-cost_7700020"},
  {name: "nm-cost_circle_18851400"},
  {name: "nm-cost_of_goods_sold_15554945"},
  {name: "nm-counter_3410112"},
  {name: "nm-counter_7207766"},
  {name: "nm-coupons_4683372"},
  {name: "nm-coupon_9551915"},
  {name: "nm-courier_7000501"},
  {name: "nm-credit_card_4021708"},
  {name: "nm-credit_card_4457310"},
  {name: "nm-credit_card_4689390"},
  {name: "nm-currencies_2601491"},
  {name: "nm-currency_exchange_2473887"},
  {name: "nm-customer_journey_18665145"},
  {name: "nm-customer_service_3632552"},
  {name: "nm-customer_support_12247491"},
  {name: "nm-custom_2760940"},
  {name: "nm-custom_clearance_12828346"},
  {name: "nm-custom_clearance_14785145"},
  {name: "nm-custom_clearance_7141914"},
  {name: "nm-cycle_7267546"},
  {name: "nm-damaged_package_5501789"},
  {name: "nm-damage_16934322"},
  {name: "nm-dashboard_2956542"},
  {name: "nm-dashboard_8278857"},
  {name: "nm-database_12945605"},
  {name: "nm-data_993762"},
  {name: "nm-data_cleaning_12091023"},
  {name: "nm-data_cleanup_17982835"},
  {name: "nm-data_collection_10003054"},
  {name: "nm-data_compression_4403169"},
  {name: "nm-data_replication_16810774"},
  {name: "nm-data_report_18034974"},
  {name: "nm-data_transfer_8316751"},
  {name: "nm-data_warehouse_18273867"},
  {name: "nm-data_warehouse_4149668"},
  {name: "nm-day_off_7174337"},
  {name: "nm-deadline_2612924"},
  {name: "nm-deal_2601512"},
  {name: "nm-deal_paper_18819525"},
  {name: "nm-debit_card_1087117"},
  {name: "nm-debt_5104787"},
  {name: "nm-debt_consolidation_2516260"},
  {name: "nm-defective_5187063"},
  {name: "nm-deficit_10064043"},
  {name: "nm-definition_11036823"},
  {name: "nm-definition_15873524"},
  {name: "nm-delegation_7626111"},
  {name: "nm-delete_2807722"},
  {name: "nm-delete_3240358"},
  {name: "nm-delivery_4791449"},
  {name: "nm-delivery_box_4213948"},
  {name: "nm-delivery_car_7615749"},
  {name: "nm-delivery_service_11458660"},
  {name: "nm-delivery_status_9272041"},
  {name: "nm-delivery_truck_17886103"},
  {name: "nm-design_resources_17921234"},
  {name: "nm-destination_6889707"},
  {name: "nm-destination_9655360"},
  {name: "nm-detector_11875686"},
  {name: "nm-diagnosis_17749910"},
  {name: "nm-disclaimer_11422025"},
  {name: "nm-disclosure_18035720"},
  {name: "nm-discount_17173670"},
  {name: "nm-discount_879757"},
  {name: "nm-discount_coupon_9618755"},
  {name: "nm-dismissal_6896416"},
  {name: "nm-disposal_3154606"},
  {name: "nm-distance_learning_3359690"},
  {name: "nm-distribution_7444365"},
  {name: "nm-distribution_9402109"},
  {name: "nm-dms_12280933"},
  {name: "nm-doctor_3481061"},
  {name: "nm-doctor_consultation_15756405"},
  {name: "nm-documents_9409822"},
  {name: "nm-document_10103861"},
  {name: "nm-document_10690902"},
  {name: "nm-document_12410588"},
  {name: "nm-document_12507778"},
  {name: "nm-document_13068212"},
  {name: "nm-document_14228636"},
  {name: "nm-document_1459111"},
  {name: "nm-document_15839141"},
  {name: "nm-document_16227978"},
  {name: "nm-document_17931105"},
  {name: "nm-document_2615828"},
  {name: "nm-document_2802210"},
  {name: "nm-document_2833676"},
  {name: "nm-document_3028707"},
  {name: "nm-document_3131591"},
  {name: "nm-document_4168367"},
  {name: "nm-document_5036831"},
  {name: "nm-document_5064870"},
  {name: "nm-document_6179995"},
  {name: "nm-document_6486605"},
  {name: "nm-document_6679506"},
  {name: "nm-document_8848039"},
  {name: "nm-doc_file_8586188"},
  {name: "nm-dollar_7250391"},
  {name: "nm-door_to_door_10352744"},
  {name: "nm-double_bed_2284001"},
  {name: "nm-driver_license_2916223"},
  {name: "nm-drugs_840781"},
  {name: "nm-due_diligence_12134552"},
  {name: "nm-duplex_9705814"},
  {name: "nm-ecommerce_2847083"},
  {name: "nm-edit_13246694"},
  {name: "nm-edit_2490572"},
  {name: "nm-edit_7073677"},
  {name: "nm-edit_8470847"},
  {name: "nm-education_level_18178797"},
  {name: "nm-email_18410022"},
  {name: "nm-email_2303951"},
  {name: "nm-email_4548492"},
  {name: "nm-emergency_17774923"},
  {name: "nm-emergency_exit_5523246"},
  {name: "nm-emergency_room_9733672"},
  {name: "nm-employee_14331334"},
  {name: "nm-employee_18819990"},
  {name: "nm-employee_912316"},
  {name: "nm-employee_assessment_16761069"},
  {name: "nm-employee_data_11542066"},
  {name: "nm-employee_of_the_month_12422988"},
  {name: "nm-erp_5627023"},
  {name: "nm-error_message_2581972"},
  {name: "nm-escrow_15166230"},
  {name: "nm-estate_12394291"},
  {name: "nm-estate_planning_15636935"},
  {name: "nm-estimation_9735680"},
  {name: "nm-evaluation_12197483"},
  {name: "nm-event_2413035"},
  {name: "nm-excavator_4968068"},
  {name: "nm-exchange_1585147"},
  {name: "nm-exchange_3979328"},
  {name: "nm-exchange_9788303"},
  {name: "nm-exchange_rate_2510663"},
  {name: "nm-exclusion_12058761"},
  {name: "nm-execution_16753378"},
  {name: "nm-expenses_17777561"},
  {name: "nm-expenses_8655448"},
  {name: "nm-expense_11241017"},
  {name: "nm-export_14105078"},
  {name: "nm-export_2356610"},
  {name: "nm-extinguisher_5672574"},
  {name: "nm-field_trip_5190157"},
  {name: "nm-files_15330716"},
  {name: "nm-file_10217805"},
  {name: "nm-file_1362090"},
  {name: "nm-file_14680590"},
  {name: "nm-file_16882340"},
  {name: "nm-file_2140667"},
  {name: "nm-file_2521572"},
  {name: "nm-file_2997966"},
  {name: "nm-file_3286176"},
  {name: "nm-file_8406598"},
  {name: "nm-file_8406610"},
  {name: "nm-file_import_14400288"},
  {name: "nm-file_rotation_15948280"},
  {name: "nm-file_transfer_11305627"},
  {name: "nm-file_transfer_12192997"},
  {name: "nm-filter_1159641"},
  {name: "nm-filter_1511905"},
  {name: "nm-filter_17321815"},
  {name: "nm-filter_3839020"},
  {name: "nm-finance_1992253"},
  {name: "nm-finance_4072713"},
  {name: "nm-finance_8581429"},
  {name: "nm-financial_9423027"},
  {name: "nm-financial_audit_17786297"},
  {name: "nm-financial_information_10064074"},
  {name: "nm-financial_planning_15586826"},
  {name: "nm-financial_statement_6341974"},
  {name: "nm-financing_18242351"},
  {name: "nm-fiscal_17756128"},
  {name: "nm-five_4626501"},
  {name: "nm-five_stars_5134846"},
  {name: "nm-fixed_asset_3491684"},
  {name: "nm-flags_455582"},
  {name: "nm-floor_7700034"},
  {name: "nm-flute_848166"},
  {name: "nm-focus_group_16805859"},
  {name: "nm-folder_10210092"},
  {name: "nm-folder_10828574"},
  {name: "nm-folder_13644434"},
  {name: "nm-folder_16090918"},
  {name: "nm-folder_17864149"},
  {name: "nm-folder_8117645"},
  {name: "nm-follow_up_16792851"},
  {name: "nm-food_2771460"},
  {name: "nm-food_preparation_18810291"},
  {name: "nm-forecasting_8553022"},
  {name: "nm-forecast_6633516"},
  {name: "nm-forecast_analytics_16137972"},
  {name: "nm-framework_4160849"},
  {name: "nm-frame_7033171"},
  {name: "nm-free_shipping_15557514"},
  {name: "nm-freight_18303387"},
  {name: "nm-function_18565923"},
  {name: "nm-gadget_6711321"},
  {name: "nm-gears_9581641"},
  {name: "nm-gear_13355740"},
  {name: "nm-gear_17870834"},
  {name: "nm-gear_2953165"},
  {name: "nm-gear_518875"},
  {name: "nm-gift_2731865"},
  {name: "nm-gift_box_18098228"},
  {name: "nm-goal_1465829"},
  {name: "nm-goods_12003912"},
  {name: "nm-group_3394744"},
  {name: "nm-group_8073854"},
  {name: "nm-gruop_16390039"},
  {name: "nm-guide_17050066"},
  {name: "nm-handrail_4349346"},
  {name: "nm-handshake_10266978"},
  {name: "nm-handshake_2613094"},
  {name: "nm-hand_18409994"},
  {name: "nm-hatchback_5035167"},
  {name: "nm-healthcare_2966334"},
  {name: "nm-healthcare_4003747"},
  {name: "nm-healthy_eating_18706159"},
  {name: "nm-healthy_food_9757178"},
  {name: "nm-health_insurance_12712315"},
  {name: "nm-health_insurance_4388224"},
  {name: "nm-health_report_17967663"},
  {name: "nm-help_1660114"},
  {name: "nm-hijri_15364805"},
  {name: "nm-history_15231313"},
  {name: "nm-hold_5966090"},
  {name: "nm-holidays_3634857"},
  {name: "nm-homework_17251701"},
  {name: "nm-homework_4711767"},
  {name: "nm-home_1848500"},
  {name: "nm-hospitalisation_2302792"},
  {name: "nm-hospital_2895071"},
  {name: "nm-hospital_3209159"},
  {name: "nm-hotel_201426"},
  {name: "nm-hotel_bed_3060178"},
  {name: "nm-house_10604757"},
  {name: "nm-house_3637773"},
  {name: "nm-house_9202668"},
  {name: "nm-house_lock_5687474"},
  {name: "nm-human_5246761"},
  {name: "nm-human_resources_10488501"},
  {name: "nm-idea_9453383"},
  {name: "nm-id_card_10721956"},
  {name: "nm-illegal_5736545"},
  {name: "nm-important_mail_11889689"},
  {name: "nm-import_export_15221871"},
  {name: "nm-inbound_12141524"},
  {name: "nm-inch_4236604"},
  {name: "nm-increase_10243550"},
  {name: "nm-infrastructure_11495742"},
  {name: "nm-input_9671337"},
  {name: "nm-insight_18492905"},
  {name: "nm-inspection_15166526"},
  {name: "nm-inspection_5531663"},
  {name: "nm-inspection_6052465"},
  {name: "nm-instructions_12627704"},
  {name: "nm-insurance_11443006"},
  {name: "nm-insurance_1962586"},
  {name: "nm-insurance_6888112"},
  {name: "nm-insurance_9824434"},
  {name: "nm-insurance_audit_13068277"},
  {name: "nm-insurance_company_7339353"},
  {name: "nm-integration_4618560"},
  {name: "nm-interior_design_2400622"},
  {name: "nm-internet_16502214"},
  {name: "nm-inventory_12141431"},
  {name: "nm-inventory_18771476"},
  {name: "nm-inventory_2897616"},
  {name: "nm-inventory_management_18564078"},
  {name: "nm-inventory_management_8744645"},
  {name: "nm-investment_12942999"},
  {name: "nm-investment_16485024"},
  {name: "nm-investment_2159865"},
  {name: "nm-investment_4930129"},
  {name: "nm-investor_2386356"},
  {name: "nm-invoices_3358993"},
  {name: "nm-invoice_10112462"},
  {name: "nm-invoice_12155208"},
  {name: "nm-invoice_12676454"},
  {name: "nm-invoice_12970042"},
  {name: "nm-invoice_15575258"},
  {name: "nm-invoice_16933159"},
  {name: "nm-invoice_18491196"},
  {name: "nm-invoice_18964749"},
  {name: "nm-invoice_2474482"},
  {name: "nm-invoice_3408829"},
  {name: "nm-invoice_411796"},
  {name: "nm-invoice_4306889"},
  {name: "nm-invoice_4862319"},
  {name: "nm-invoice_6026725"},
  {name: "nm-invoice_7291266"},
  {name: "nm-invoice_8354689"},
  {name: "nm-invoice_9071521"},
  {name: "nm-in_stock_7444276"},
  {name: "nm-isolation_3062991"},
  {name: "nm-item_12512009"},
  {name: "nm-job_11898010"},
  {name: "nm-job_application_15189386"},
  {name: "nm-job_description_7376263"},
  {name: "nm-job_offer_15189475"},
  {name: "nm-journal_12237179"},
  {name: "nm-justice_16200810"},
  {name: "nm-keyboard_15463172"},
  {name: "nm-keyword_542632"},
  {name: "nm-key_10217862"},
  {name: "nm-key_10647744"},
  {name: "nm-key_performance_indicator_10789436"},
  {name: "nm-kitchen_1606657"},
  {name: "nm-laboratory_7404175"},
  {name: "nm-labor_cost_18250790"},
  {name: "nm-land_8978082"},
  {name: "nm-law_book_4474491"},
  {name: "nm-layout_4507688"},
  {name: "nm-layout_4725672"},
  {name: "nm-leader_10165937"},
  {name: "nm-leader_4059502"},
  {name: "nm-leave_3387310"},
  {name: "nm-ledgers_15773346"},
  {name: "nm-ledger_12183981"},
  {name: "nm-ledger_17001425"},
  {name: "nm-ledger_4680987"},
  {name: "nm-legal_18092070"},
  {name: "nm-legal_document_3207533"},
  {name: "nm-letter_6259496"},
  {name: "nm-letter_7458351"},
  {name: "nm-letter_of_guarantee_4930623"},
  {name: "nm-level_up_16863363"},
  {name: "nm-licensed_12029456"},
  {name: "nm-license_10836475"},
  {name: "nm-lifting_12299319"},
  {name: "nm-lighting_3103277"},
  {name: "nm-link_11598691"},
  {name: "nm-link_12366460"},
  {name: "nm-link_455691"},
  {name: "nm-link_building_8157946"},
  {name: "nm-list_17400520"},
  {name: "nm-list_8415783"},
  {name: "nm-list_9131997"},
  {name: "nm-list_9482813"},
  {name: "nm-loading_8081408"},
  {name: "nm-loan_13794697"},
  {name: "nm-loan_16933118"},
  {name: "nm-loan_5023258"},
  {name: "nm-loan_9828411"},
  {name: "nm-location_12867982"},
  {name: "nm-location_7547677"},
  {name: "nm-locker_9045439"},
  {name: "nm-logistic_contract_15597258"},
  {name: "nm-log_17377923"},
  {name: "nm-low_performance_2386473"},
  {name: "nm-loyal_customer_5431198"},
  {name: "nm-lunch_4893631"},
  {name: "nm-machine_13869597"},
  {name: "nm-magazine_4520868"},
  {name: "nm-mail_12287320"},
  {name: "nm-mail_3720647"},
  {name: "nm-mail_9318057"},
  {name: "nm-maintenance_10559639"},
  {name: "nm-maintenance_11276274"},
  {name: "nm-maintenance_14305784"},
  {name: "nm-maintenance_15569954"},
  {name: "nm-maintenance_17073129"},
  {name: "nm-maintenance_17876676"},
  {name: "nm-maintenance_17972679"},
  {name: "nm-maintenance_9831111"},
  {name: "nm-maintenance_9878470"},
  {name: "nm-management_10211342"},
  {name: "nm-management_14432082"},
  {name: "nm-management_1570102"},
  {name: "nm-management_9205839"},
  {name: "nm-manager_10487778"},
  {name: "nm-man_15630692"},
  {name: "nm-map_6910292"},
  {name: "nm-marketing_16899226"},
  {name: "nm-marketing_9464695"},
  {name: "nm-marketing_mix_7253129"},
  {name: "nm-market_analysis_9254636"},
  {name: "nm-mark_16530462"},
  {name: "nm-material_1556328"},
  {name: "nm-math_3655553"},
  {name: "nm-meal_17694923"},
  {name: "nm-measure_335446"},
  {name: "nm-mechanic_11133669"},
  {name: "nm-mediator_7028072"},
  {name: "nm-medical_2302757"},
  {name: "nm-medical_bill_15135746"},
  {name: "nm-medical_check_2634036"},
  {name: "nm-medical_devices_17340723"},
  {name: "nm-medical_expense_17640396"},
  {name: "nm-medical_invoice_4494274"},
  {name: "nm-medical_journey_17225490"},
  {name: "nm-medical_list_5143800"},
  {name: "nm-medical_record_18150546"},
  {name: "nm-medical_report_3215528"},
  {name: "nm-medical_test_17104715"},
  {name: "nm-medicine_5200471"},
  {name: "nm-message_13579018"},
  {name: "nm-message_2604334"},
  {name: "nm-message_dollar_14984866"},
  {name: "nm-mic_709950"},
  {name: "nm-mission_9092122"},
  {name: "nm-mission_9372147"},
  {name: "nm-mobile_management_17937701"},
  {name: "nm-mobile_payment_4007969"},
  {name: "nm-modeling_14106298"},
  {name: "nm-money_10219953"},
  {name: "nm-money_13548278"},
  {name: "nm-money_14898589"},
  {name: "nm-money_16422494"},
  {name: "nm-money_16467587"},
  {name: "nm-money_2914767"},
  {name: "nm-money_3133430"},
  {name: "nm-money_bag_2953363"},
  {name: "nm-money_box_2504585"},
  {name: "nm-money_chat_18917729"},
  {name: "nm-money_management_12331286"},
  {name: "nm-money_management_2666527"},
  {name: "nm-monitor_2930617"},
  {name: "nm-mortgage_11323576"},
  {name: "nm-mortgage_broker_17063906"},
  {name: "nm-network_3348099"},
  {name: "nm-network_648324"},
  {name: "nm-new_employee_14813059"},
  {name: "nm-new_product_12474335"},
  {name: "nm-new_year_16775066"},
  {name: "nm-notebook_3625224"},
  {name: "nm-note_13703448"},
  {name: "nm-notification_2645897"},
  {name: "nm-no_corruption_10297234"},
  {name: "nm-no_document_12342200"},
  {name: "nm-no_paper_12065913"},
  {name: "nm-number_10_7173313"},
  {name: "nm-number_3_8068125"},
  {name: "nm-number_3_9387280"},
  {name: "nm-number_4_10259208"},
  {name: "nm-number_4_8068178"},
  {name: "nm-number_5_8068231"},
  {name: "nm-number_6_8068286"},
  {name: "nm-number_9_8067927"},
  {name: "nm-obligations_18564647"},
  {name: "nm-offer_12003803"},
  {name: "nm-offer_1611173"},
  {name: "nm-offer_9865110"},
  {name: "nm-office_16131924"},
  {name: "nm-office_4041177"},
  {name: "nm-office_map_13807705"},
  {name: "nm-one_4626473"},
  {name: "nm-online_16207344"},
  {name: "nm-online_learning_18798433"},
  {name: "nm-online_shopping_1280804"},
  {name: "nm-online_shopping_3258481"},
  {name: "nm-online_store_9018922"},
  {name: "nm-operating_system_10397335"},
  {name: "nm-operations_18532895"},
  {name: "nm-operation_11337218"},
  {name: "nm-operation_11337444"},
  {name: "nm-operation_11337450"},
  {name: "nm-optimization_8439152"},
  {name: "nm-order_12015378"},
  {name: "nm-order_1554563"},
  {name: "nm-order_1671130"},
  {name: "nm-order_766251"},
  {name: "nm-order_7971189"},
  {name: "nm-order_fulfillment_17241069"},
  {name: "nm-order_tracking_3607527"},
  {name: "nm-order_tracking_9280849"},
  {name: "nm-outpatient_14599729"},
  {name: "nm-out_of_stock_10614817"},
  {name: "nm-overhead_11909702"},
  {name: "nm-ownership_5605976"},
  {name: "nm-package_2397992"},
  {name: "nm-package_600268"},
  {name: "nm-packing_list_1670974"},
  {name: "nm-papers_12843854"},
  {name: "nm-paper_10407098"},
  {name: "nm-paper_13349577"},
  {name: "nm-paper_14294082"},
  {name: "nm-paper_15978905"},
  {name: "nm-paper_2541979"},
  {name: "nm-paper_5653782"},
  {name: "nm-paper_6300707"},
  {name: "nm-paper_assessment_18895772"},
  {name: "nm-paper_bag_1625706"},
  {name: "nm-parcel_size_9527158"},
  {name: "nm-parents_10184701"},
  {name: "nm-part_17404360"},
  {name: "nm-passport_10865439"},
  {name: "nm-passport_1257113"},
  {name: "nm-passport_control_4696981"},
  {name: "nm-patient_2376100"},
  {name: "nm-patient_9733728"},
  {name: "nm-pattern_2048512"},
  {name: "nm-payment_10683919"},
  {name: "nm-payment_11253966"},
  {name: "nm-payment_18557486"},
  {name: "nm-payment_2530689"},
  {name: "nm-payment_2780279"},
  {name: "nm-payment_4645352"},
  {name: "nm-payment_7262711"},
  {name: "nm-payment_security_14385195"},
  {name: "nm-payment_service_17389462"},
  {name: "nm-payment_system_15546727"},
  {name: "nm-payment_terminal_2666418"},
  {name: "nm-penalties_12061224"},
  {name: "nm-penalty_18112872"},
  {name: "nm-penalty_18144969"},
  {name: "nm-people_15814582"},
  {name: "nm-people_15979414"},
  {name: "nm-people_16070422"},
  {name: "nm-people_1769041"},
  {name: "nm-people_3171593"},
  {name: "nm-percentage_9731321"},
  {name: "nm-performance_11883579"},
  {name: "nm-performance_16773505"},
  {name: "nm-performance_3488812"},
  {name: "nm-pharmacy_17692771"},
  {name: "nm-phases_4357"},
  {name: "nm-phone_4951609"},
  {name: "nm-phone_call_3059408"},
  {name: "nm-photocopy_3648602"},
  {name: "nm-physical_therapy_17774705"},
  {name: "nm-pick_list_11392541"},
  {name: "nm-pie_chart_7558222"},
  {name: "nm-pie_graphic_6419899"},
  {name: "nm-placeholder_819865"},
  {name: "nm-planning_434346"},
  {name: "nm-plan_10120809"},
  {name: "nm-plan_9402085"},
  {name: "nm-point_of_service_6140301"},
  {name: "nm-policy_10710183"},
  {name: "nm-policy_5187181"},
  {name: "nm-portfolio_12304404"},
  {name: "nm-portfolio_folder_9413311"},
  {name: "nm-posting_11913601"},
  {name: "nm-pos_terminal_6551691"},
  {name: "nm-preferences_10210533"},
  {name: "nm-price_list_10103341"},
  {name: "nm-price_list_11000672"},
  {name: "nm-price_list_16090725"},
  {name: "nm-price_list_4464915"},
  {name: "nm-price_list_4961543"},
  {name: "nm-price_list_4994468"},
  {name: "nm-price_list_7444269"},
  {name: "nm-price_list_8461594"},
  {name: "nm-price_list_8890319"},
  {name: "nm-price_tag_567600"},
  {name: "nm-printer_3465791"},
  {name: "nm-print_4305625"},
  {name: "nm-prioritize_10492974"},
  {name: "nm-privacy_18238966"},
  {name: "nm-procedures_11702817"},
  {name: "nm-procedure_12299115"},
  {name: "nm-processing_10614604"},
  {name: "nm-process_11494179"},
  {name: "nm-process_1865497"},
  {name: "nm-process_3078984"},
  {name: "nm-process_4149677"},
  {name: "nm-procurement_4862413"},
  {name: "nm-product_1311144"},
  {name: "nm-product_15681406"},
  {name: "nm-product_15817361"},
  {name: "nm-product_2652218"},
  {name: "nm-product_3712174"},
  {name: "nm-product_7078329"},
  {name: "nm-product_8744687"},
  {name: "nm-product_categories_15555049"},
  {name: "nm-product_cost_12544334"},
  {name: "nm-product_description_17311699"},
  {name: "nm-product_design_15597931"},
  {name: "nm-product_management_17970641"},
  {name: "nm-product_recall_16940698"},
  {name: "nm-product_return_12459227"},
  {name: "nm-profile_11889864"},
  {name: "nm-profits_3467240"},
  {name: "nm-programmer_10438910"},
  {name: "nm-program_10237089"},
  {name: "nm-project_10898856"},
  {name: "nm-project_2679418"},
  {name: "nm-project_408557"},
  {name: "nm-project_5956597"},
  {name: "nm-project_management_1087927"},
  {name: "nm-project_management_3286703"},
  {name: "nm-project_management_4946385"},
  {name: "nm-project_status_10934173"},
  {name: "nm-promotional_items_16879606"},
  {name: "nm-property_2243704"},
  {name: "nm-property_6140354"},
  {name: "nm-property_document_13390614"},
  {name: "nm-protected_2058324"},
  {name: "nm-public_service_9747033"},
  {name: "nm-public_toilet_3289742"},
  {name: "nm-purchase_order_12341403"},
  {name: "nm-quality_10498248"},
  {name: "nm-quality_control_4374854"},
  {name: "nm-quality_control_4862471"},
  {name: "nm-quality_control_9789613"},
  {name: "nm-question_12544380"},
  {name: "nm-question_1746624"},
  {name: "nm-question_3156280"},
  {name: "nm-queue_11220153"},
  {name: "nm-quotation_4388366"},
  {name: "nm-quote_16134577"},
  {name: "nm-quote_request_7024144"},
  {name: "nm-radiology_15192747"},
  {name: "nm-ranking_3162263"},
  {name: "nm-rating_1322236"},
  {name: "nm-raw_materials_12981797"},
  {name: "nm-real_estate_9116574"},
  {name: "nm-real_estate_agent_6333471"},
  {name: "nm-real_time_3043540"},
  {name: "nm-receipt_11153374"},
  {name: "nm-receipt_1554608"},
  {name: "nm-receipt_869698"},
  {name: "nm-receipt_9069344"},
  {name: "nm-receipt_9328666"},
  {name: "nm-received_4536732"},
  {name: "nm-receptionist_17625282"},
  {name: "nm-recipe_3802177"},
  {name: "nm-referral_18841524"},
  {name: "nm-refinance_13659814"},
  {name: "nm-refresh_2546743"},
  {name: "nm-refund_2366081"},
  {name: "nm-register_17814618"},
  {name: "nm-registration_certificate_14001395"},
  {name: "nm-regulation_11210307"},
  {name: "nm-regulation_13061404"},
  {name: "nm-regulation_9926191"},
  {name: "nm-regulatory_12245250"},
  {name: "nm-relax_3063783"},
  {name: "nm-remove_file_3686931"},
  {name: "nm-renewal_12003696"},
  {name: "nm-renewal_18564395"},
  {name: "nm-renewal_18564409"},
  {name: "nm-rent_2590451"},
  {name: "nm-rent_4820436"},
  {name: "nm-reporting_13089755"},
  {name: "nm-reports_12727897"},
  {name: "nm-report_14323490"},
  {name: "nm-report_1450932"},
  {name: "nm-report_16773533"},
  {name: "nm-report_3875734"},
  {name: "nm-report_5656296"},
  {name: "nm-report_6199776"},
  {name: "nm-report_6345343"},
  {name: "nm-report_9504986"},
  {name: "nm-report_card_13334856"},
  {name: "nm-report_card_3819810"},
  {name: "nm-request_18857268"},
  {name: "nm-request_2117251"},
  {name: "nm-request_for_proposal_11000717"},
  {name: "nm-request_for_proposal_12321839"},
  {name: "nm-requirement_10326046"},
  {name: "nm-requirement_12048812"},
  {name: "nm-requisition_17235067"},
  {name: "nm-research_9419215"},
  {name: "nm-residential_13519264"},
  {name: "nm-resignation_10436019"},
  {name: "nm-resignation_7376570"},
  {name: "nm-resource_allocation_13728428"},
  {name: "nm-responsibility_10172476"},
  {name: "nm-restaurant_3208003"},
  {name: "nm-restaurant_561382"},
  {name: "nm-return_11722917"},
  {name: "nm-return_16117131"},
  {name: "nm-return_1671017"},
  {name: "nm-return_2801689"},
  {name: "nm-return_9252729"},
  {name: "nm-return_box_5469919"},
  {name: "nm-reverse_logistics_18248683"},
  {name: "nm-review_3168622"},
  {name: "nm-revision_18857103"},
  {name: "nm-rewards_6062118"},
  {name: "nm-rfq_18564043"},
  {name: "nm-risk_12315850"},
  {name: "nm-room_489874"},
  {name: "nm-room_service_3575841"},
  {name: "nm-round_16199578"},
  {name: "nm-route_15546556"},
  {name: "nm-route_3061732"},
  {name: "nm-ruler_18994252"},
  {name: "nm-rules_2046915"},
  {name: "nm-running_repair_man_with_wrench_and_kit_25559"},
  {name: "nm-sacrifice_15942674"},
  {name: "nm-safe_2208007"},
  {name: "nm-safe_box_2676779"},
  {name: "nm-salary_13441695"},
  {name: "nm-salary_1672164"},
  {name: "nm-salary_18566499"},
  {name: "nm-sale_5959799"},
  {name: "nm-sale_8480947"},
  {name: "nm-save_money_1611179"},
  {name: "nm-saving_11915929"},
  {name: "nm-scale_16182041"},
  {name: "nm-schedule_3107295"},
  {name: "nm-schedule_3215495"},
  {name: "nm-schedule_8718753"},
  {name: "nm-schedule_9375984"},
  {name: "nm-schedule_9640755"},
  {name: "nm-school_2602412"},
  {name: "nm-school_4710565"},
  {name: "nm-school_bus_3471534"},
  {name: "nm-search_2820167"},
  {name: "nm-season_4360322"},
  {name: "nm-seating_area_18868370"},
  {name: "nm-secure_9461347"},
  {name: "nm-security_10235668"},
  {name: "nm-security_17404290"},
  {name: "nm-security_2058432"},
  {name: "nm-sedan_2736918"},
  {name: "nm-send_18857153"},
  {name: "nm-send_file_6601155"},
  {name: "nm-services_11671609"},
  {name: "nm-services_12003833"},
  {name: "nm-services_14784839"},
  {name: "nm-service_1649375"},
  {name: "nm-service_4692103"},
  {name: "nm-service_center_1698510"},
  {name: "nm-service_station_7600849"},
  {name: "nm-settings_15477908"},
  {name: "nm-settings_2099058"},
  {name: "nm-settings_6057870"},
  {name: "nm-setting_1787641"},
  {name: "nm-setting_3210045"},
  {name: "nm-setting_5470294"},
  {name: "nm-shared_folder_1045537"},
  {name: "nm-shelf_3396325"},
  {name: "nm-shift_5538633"},
  {name: "nm-shift_5539726"},
  {name: "nm-shipped_411763"},
  {name: "nm-shipping_11153410"},
  {name: "nm-shipping_18532922"},
  {name: "nm-shipping_cost_11000652"},
  {name: "nm-shipping_location_17573458"},
  {name: "nm-ship_2485084"},
  {name: "nm-shopping_13630745"},
  {name: "nm-shopping_4183908"},
  {name: "nm-shortcut_9784396"},
  {name: "nm-signing_3130444"},
  {name: "nm-six_4626510"},
  {name: "nm-skill_development_9953680"},
  {name: "nm-sla_17064924"},
  {name: "nm-sleep_11117712"},
  {name: "nm-slot_machine_3076839"},
  {name: "nm-smartphone_18462159"},
  {name: "nm-smart_temperature_7882983"},
  {name: "nm-smelting_14400846"},
  {name: "nm-snowflake_5795206"},
  {name: "nm-sorting_18771472"},
  {name: "nm-specification_6207279"},
  {name: "nm-split_1541211"},
  {name: "nm-sponsorship_17788130"},
  {name: "nm-sponsorship_18824056"},
  {name: "nm-square_11287293"},
  {name: "nm-stacks_12305887"},
  {name: "nm-standards_18575239"},
  {name: "nm-standard_8439144"},
  {name: "nm-standard_operating_procedures_16985619"},
  {name: "nm-stand_3306951"},
  {name: "nm-status_8917343"},
  {name: "nm-stock_6902435"},
  {name: "nm-stock_keeping_unit_12141504"},
  {name: "nm-stop_3178618"},
  {name: "nm-storage_2728486"},
  {name: "nm-storage_6015470"},
  {name: "nm-storyboard_12577375"},
  {name: "nm-strategy_planning_16743863"},
  {name: "nm-student_8892896"},
  {name: "nm-subcontracting_14458891"},
  {name: "nm-subscribe_5671858"},
  {name: "nm-sub_8835627"},
  {name: "nm-suggestion_2593658"},
  {name: "nm-supplier_12321920"},
  {name: "nm-supplier_8071262"},
  {name: "nm-supply_chain_4813885"},
  {name: "nm-surgeon_7031573"},
  {name: "nm-surgery_room_4006097"},
  {name: "nm-survey_10930719"},
  {name: "nm-sync_data_16856249"},
  {name: "nm-system_16454641"},
  {name: "nm-talent_15595789"},
  {name: "nm-tape_measure_2739200"},
  {name: "nm-tariff_14104983"},
  {name: "nm-task_18312178"},
  {name: "nm-task_2098313"},
  {name: "nm-task_3774569"},
  {name: "nm-task_actions_18988010"},
  {name: "nm-task_complete_17377933"},
  {name: "nm-task_list_2029830"},
  {name: "nm-task_management_15762588"},
  {name: "nm-taxation_17756286"},
  {name: "nm-taxes_4749988"},
  {name: "nm-team_11049551"},
  {name: "nm-team_13483396"},
  {name: "nm-team_management_8840707"},
  {name: "nm-technical_support_4230997"},
  {name: "nm-technician_9922689"},
  {name: "nm-temperature_1872808"},
  {name: "nm-temperature_8775923"},
  {name: "nm-templates_559907"},
  {name: "nm-tender_17148344"},
  {name: "nm-tender_18699187"},
  {name: "nm-terms_11582779"},
  {name: "nm-terms_and_conditions_16331104"},
  {name: "nm-terms_and_conditions_4436515"},
  {name: "nm-test_2916315"},
  {name: "nm-test_3204284"},
  {name: "nm-test_results_15756461"},
  {name: "nm-test_tube_3373616"},
  {name: "nm-text_11024126"},
  {name: "nm-text_analytics_16137864"},
  {name: "nm-theme_10134298"},
  {name: "nm-three_4626487"},
  {name: "nm-ticket_6977799"},
  {name: "nm-time_3064481"},
  {name: "nm-time_is_money_6404725"},
  {name: "nm-time_management_11862147"},
  {name: "nm-time_sheet_4388165"},
  {name: "nm-toolkit_4228902"},
  {name: "nm-tool_2760119"},
  {name: "nm-top_up_6379125"},
  {name: "nm-tourism_2560124"},
  {name: "nm-tour_guide_3284377"},
  {name: "nm-tour_guide_9636012"},
  {name: "nm-to_do_list_18645372"},
  {name: "nm-to_do_list_3647695"},
  {name: "nm-track_4974331"},
  {name: "nm-track_delivery_12624957"},
  {name: "nm-training_12650217"},
  {name: "nm-transactional_data_18253441"},
  {name: "nm-transaction_11826754"},
  {name: "nm-transfer_2818813"},
  {name: "nm-transfer_757515"},
  {name: "nm-translation_2793765"},
  {name: "nm-transport_15841669"},
  {name: "nm-travel_3376684"},
  {name: "nm-travel_agency_4586974"},
  {name: "nm-trolley_4664272"},
  {name: "nm-troubleshooting_18643300"},
  {name: "nm-trustworthiness_12772408"},
  {name: "nm-two_4626479"},
  {name: "nm-typography_14282875"},
  {name: "nm-unsecured_8900232"},
  {name: "nm-update_4059752"},
  {name: "nm-update_4067725"},
  {name: "nm-update_7159542"},
  {name: "nm-update_list_14752951"},
  {name: "nm-updating_2990003"},
  {name: "nm-usability_12465756"},
  {name: "nm-user_1515713"},
  {name: "nm-user_456283"},
  {name: "nm-user_favourite_17123247"},
  {name: "nm-vacancy_4288089"},
  {name: "nm-vacation_10403845"},
  {name: "nm-vacation_16984394"},
  {name: "nm-vacation_18238495"},
  {name: "nm-vacation_18747738"},
  {name: "nm-validating_ticket_7377200"},
  {name: "nm-value_1528669"},
  {name: "nm-variant_12062492"},
  {name: "nm-vehicle_12359514"},
  {name: "nm-vehicle_12359527"},
  {name: "nm-venture_7261828"},
  {name: "nm-visa_15916931"},
  {name: "nm-vision_14014408"},
  {name: "nm-visitor_753114"},
  {name: "nm-visit_16841242"},
  {name: "nm-voltage_indicator_12191265"},
  {name: "nm-voucher_13280369"},
  {name: "nm-voucher_481387"},
  {name: "nm-voucher_7183794"},
  {name: "nm-waiting_list_11209494"},
  {name: "nm-wallet_1198393"},
  {name: "nm-warehouse_10638567"},
  {name: "nm-warehouse_702455"},
  {name: "nm-warehouse_9597872"},
  {name: "nm-warning_159469"},
  {name: "nm-warranty_card_16868866"},
  {name: "nm-weighing_machine_2929016"},
  {name: "nm-weight_15169691"},
  {name: "nm-whatsapp_2582600"},
  {name: "nm-worker_782899"},
  {name: "nm-worker_9936521"},
  {name: "nm-workflow_5365050"},
  {name: "nm-workflow_8317775"},
  {name: "nm-working_hours_18103931"},
  {name: "nm-working_time_7626204"},
  {name: "nm-workspace_9787259"},
  {name: "nm-work_plan_12422852"},
  {name: "nm-world_10690961"},
  {name: "nm-write_13785332"},
  {name: "nm-write_14944972"},
  {name: "nm-writing_15889631"},
  {name: "nm-x_rays_10160241"},
]
